/* eslint-disable */

export type EmojiJsonItem = [
  unified: string,
  shortName: string,
  shortNames: string[],
  category: string,
  sortOrder: number,
  addedIn: number,
  hasImgTwitter: boolean,
  skinVariations: Record<
    string,
    { unified: string; symbol: string; addedIn: number; hasImgTwitter: boolean }
  > | null,
];

export const emoji: EmojiJsonItem[] = [
  ['0023-FE0F-20E3', 'hash', ['hash'], 'Symbols', 1500, 0.6, true, null],
  ['002A-FE0F-20E3', 'keycap_star', ['keycap_star'], 'Symbols', 1501, 2, true, null],
  ['0030-FE0F-20E3', 'zero', ['zero'], 'Symbols', 1502, 0.6, true, null],
  ['0031-FE0F-20E3', 'one', ['one'], 'Symbols', 1503, 0.6, true, null],
  ['0032-FE0F-20E3', 'two', ['two'], 'Symbols', 1504, 0.6, true, null],
  ['0033-FE0F-20E3', 'three', ['three'], 'Symbols', 1505, 0.6, true, null],
  ['0034-FE0F-20E3', 'four', ['four'], 'Symbols', 1506, 0.6, true, null],
  ['0035-FE0F-20E3', 'five', ['five'], 'Symbols', 1507, 0.6, true, null],
  ['0036-FE0F-20E3', 'six', ['six'], 'Symbols', 1508, 0.6, true, null],
  ['0037-FE0F-20E3', 'seven', ['seven'], 'Symbols', 1509, 0.6, true, null],
  ['0038-FE0F-20E3', 'eight', ['eight'], 'Symbols', 1510, 0.6, true, null],
  ['0039-FE0F-20E3', 'nine', ['nine'], 'Symbols', 1511, 0.6, true, null],
  ['00A9-FE0F', 'copyright', ['copyright'], 'Symbols', 1497, 0.6, true, null],
  ['00AE-FE0F', 'registered', ['registered'], 'Symbols', 1498, 0.6, true, null],
  ['1F004', 'mahjong', ['mahjong'], 'Activities', 1101, 0.6, true, null],
  ['1F0CF', 'black_joker', ['black_joker'], 'Activities', 1100, 0.6, true, null],
  ['1F170-FE0F', 'a', ['a'], 'Symbols', 1518, 0.6, true, null],
  ['1F171-FE0F', 'b', ['b'], 'Symbols', 1520, 0.6, true, null],
  ['1F17E-FE0F', 'o2', ['o2'], 'Symbols', 1529, 0.6, true, null],
  ['1F17F-FE0F', 'parking', ['parking'], 'Symbols', 1531, 0.6, true, null],
  ['1F18E', 'ab', ['ab'], 'Symbols', 1519, 0.6, true, null],
  ['1F191', 'cl', ['cl'], 'Symbols', 1521, 0.6, true, null],
  ['1F192', 'cool', ['cool'], 'Symbols', 1522, 0.6, true, null],
  ['1F193', 'free', ['free'], 'Symbols', 1523, 0.6, true, null],
  ['1F194', 'id', ['id'], 'Symbols', 1525, 0.6, true, null],
  ['1F195', 'new', ['new'], 'Symbols', 1527, 0.6, true, null],
  ['1F196', 'ng', ['ng'], 'Symbols', 1528, 0.6, true, null],
  ['1F197', 'ok', ['ok'], 'Symbols', 1530, 0.6, true, null],
  ['1F198', 'sos', ['sos'], 'Symbols', 1532, 0.6, true, null],
  ['1F199', 'up', ['up'], 'Symbols', 1533, 0.6, true, null],
  ['1F19A', 'vs', ['vs'], 'Symbols', 1534, 0.6, true, null],
  ['1F1E6-1F1E8', 'flag-ac', ['flag-ac'], 'Flags', 1594, 2, true, null],
  ['1F1E6-1F1E9', 'flag-ad', ['flag-ad'], 'Flags', 1595, 2, true, null],
  ['1F1E6-1F1EA', 'flag-ae', ['flag-ae'], 'Flags', 1596, 2, true, null],
  ['1F1E6-1F1EB', 'flag-af', ['flag-af'], 'Flags', 1597, 2, true, null],
  ['1F1E6-1F1EC', 'flag-ag', ['flag-ag'], 'Flags', 1598, 2, true, null],
  ['1F1E6-1F1EE', 'flag-ai', ['flag-ai'], 'Flags', 1599, 2, true, null],
  ['1F1E6-1F1F1', 'flag-al', ['flag-al'], 'Flags', 1600, 2, true, null],
  ['1F1E6-1F1F2', 'flag-am', ['flag-am'], 'Flags', 1601, 2, true, null],
  ['1F1E6-1F1F4', 'flag-ao', ['flag-ao'], 'Flags', 1602, 2, true, null],
  ['1F1E6-1F1F6', 'flag-aq', ['flag-aq'], 'Flags', 1603, 2, true, null],
  ['1F1E6-1F1F7', 'flag-ar', ['flag-ar'], 'Flags', 1604, 2, true, null],
  ['1F1E6-1F1F8', 'flag-as', ['flag-as'], 'Flags', 1605, 2, true, null],
  ['1F1E6-1F1F9', 'flag-at', ['flag-at'], 'Flags', 1606, 2, true, null],
  ['1F1E6-1F1FA', 'flag-au', ['flag-au'], 'Flags', 1607, 2, true, null],
  ['1F1E6-1F1FC', 'flag-aw', ['flag-aw'], 'Flags', 1608, 2, true, null],
  ['1F1E6-1F1FD', 'flag-ax', ['flag-ax'], 'Flags', 1609, 2, true, null],
  ['1F1E6-1F1FF', 'flag-az', ['flag-az'], 'Flags', 1610, 2, true, null],
  ['1F1E7-1F1E6', 'flag-ba', ['flag-ba'], 'Flags', 1611, 2, true, null],
  ['1F1E7-1F1E7', 'flag-bb', ['flag-bb'], 'Flags', 1612, 2, true, null],
  ['1F1E7-1F1E9', 'flag-bd', ['flag-bd'], 'Flags', 1613, 2, true, null],
  ['1F1E7-1F1EA', 'flag-be', ['flag-be'], 'Flags', 1614, 2, true, null],
  ['1F1E7-1F1EB', 'flag-bf', ['flag-bf'], 'Flags', 1615, 2, true, null],
  ['1F1E7-1F1EC', 'flag-bg', ['flag-bg'], 'Flags', 1616, 2, true, null],
  ['1F1E7-1F1ED', 'flag-bh', ['flag-bh'], 'Flags', 1617, 2, true, null],
  ['1F1E7-1F1EE', 'flag-bi', ['flag-bi'], 'Flags', 1618, 2, true, null],
  ['1F1E7-1F1EF', 'flag-bj', ['flag-bj'], 'Flags', 1619, 2, true, null],
  ['1F1E7-1F1F1', 'flag-bl', ['flag-bl'], 'Flags', 1620, 2, true, null],
  ['1F1E7-1F1F2', 'flag-bm', ['flag-bm'], 'Flags', 1621, 2, true, null],
  ['1F1E7-1F1F3', 'flag-bn', ['flag-bn'], 'Flags', 1622, 2, true, null],
  ['1F1E7-1F1F4', 'flag-bo', ['flag-bo'], 'Flags', 1623, 2, true, null],
  ['1F1E7-1F1F6', 'flag-bq', ['flag-bq'], 'Flags', 1624, 2, true, null],
  ['1F1E7-1F1F7', 'flag-br', ['flag-br'], 'Flags', 1625, 2, true, null],
  ['1F1E7-1F1F8', 'flag-bs', ['flag-bs'], 'Flags', 1626, 2, true, null],
  ['1F1E7-1F1F9', 'flag-bt', ['flag-bt'], 'Flags', 1627, 2, true, null],
  ['1F1E7-1F1FB', 'flag-bv', ['flag-bv'], 'Flags', 1628, 2, true, null],
  ['1F1E7-1F1FC', 'flag-bw', ['flag-bw'], 'Flags', 1629, 2, true, null],
  ['1F1E7-1F1FE', 'flag-by', ['flag-by'], 'Flags', 1630, 2, true, null],
  ['1F1E7-1F1FF', 'flag-bz', ['flag-bz'], 'Flags', 1631, 2, true, null],
  ['1F1E8-1F1E6', 'flag-ca', ['flag-ca'], 'Flags', 1632, 2, true, null],
  ['1F1E8-1F1E8', 'flag-cc', ['flag-cc'], 'Flags', 1633, 2, true, null],
  ['1F1E8-1F1E9', 'flag-cd', ['flag-cd'], 'Flags', 1634, 2, true, null],
  ['1F1E8-1F1EB', 'flag-cf', ['flag-cf'], 'Flags', 1635, 2, true, null],
  ['1F1E8-1F1EC', 'flag-cg', ['flag-cg'], 'Flags', 1636, 2, true, null],
  ['1F1E8-1F1ED', 'flag-ch', ['flag-ch'], 'Flags', 1637, 2, true, null],
  ['1F1E8-1F1EE', 'flag-ci', ['flag-ci'], 'Flags', 1638, 2, true, null],
  ['1F1E8-1F1F0', 'flag-ck', ['flag-ck'], 'Flags', 1639, 2, true, null],
  ['1F1E8-1F1F1', 'flag-cl', ['flag-cl'], 'Flags', 1640, 2, true, null],
  ['1F1E8-1F1F2', 'flag-cm', ['flag-cm'], 'Flags', 1641, 2, true, null],
  ['1F1E8-1F1F3', 'cn', ['cn', 'flag-cn'], 'Flags', 1642, 0.6, true, null],
  ['1F1E8-1F1F4', 'flag-co', ['flag-co'], 'Flags', 1643, 2, true, null],
  ['1F1E8-1F1F5', 'flag-cp', ['flag-cp'], 'Flags', 1644, 2, true, null],
  ['1F1E8-1F1F7', 'flag-cr', ['flag-cr'], 'Flags', 1645, 2, true, null],
  ['1F1E8-1F1FA', 'flag-cu', ['flag-cu'], 'Flags', 1646, 2, true, null],
  ['1F1E8-1F1FB', 'flag-cv', ['flag-cv'], 'Flags', 1647, 2, true, null],
  ['1F1E8-1F1FC', 'flag-cw', ['flag-cw'], 'Flags', 1648, 2, true, null],
  ['1F1E8-1F1FD', 'flag-cx', ['flag-cx'], 'Flags', 1649, 2, true, null],
  ['1F1E8-1F1FE', 'flag-cy', ['flag-cy'], 'Flags', 1650, 2, true, null],
  ['1F1E8-1F1FF', 'flag-cz', ['flag-cz'], 'Flags', 1651, 2, true, null],
  ['1F1E9-1F1EA', 'de', ['de', 'flag-de'], 'Flags', 1652, 0.6, true, null],
  ['1F1E9-1F1EC', 'flag-dg', ['flag-dg'], 'Flags', 1653, 2, true, null],
  ['1F1E9-1F1EF', 'flag-dj', ['flag-dj'], 'Flags', 1654, 2, true, null],
  ['1F1E9-1F1F0', 'flag-dk', ['flag-dk'], 'Flags', 1655, 2, true, null],
  ['1F1E9-1F1F2', 'flag-dm', ['flag-dm'], 'Flags', 1656, 2, true, null],
  ['1F1E9-1F1F4', 'flag-do', ['flag-do'], 'Flags', 1657, 2, true, null],
  ['1F1E9-1F1FF', 'flag-dz', ['flag-dz'], 'Flags', 1658, 2, true, null],
  ['1F1EA-1F1E6', 'flag-ea', ['flag-ea'], 'Flags', 1659, 2, true, null],
  ['1F1EA-1F1E8', 'flag-ec', ['flag-ec'], 'Flags', 1660, 2, true, null],
  ['1F1EA-1F1EA', 'flag-ee', ['flag-ee'], 'Flags', 1661, 2, true, null],
  ['1F1EA-1F1EC', 'flag-eg', ['flag-eg'], 'Flags', 1662, 2, true, null],
  ['1F1EA-1F1ED', 'flag-eh', ['flag-eh'], 'Flags', 1663, 2, true, null],
  ['1F1EA-1F1F7', 'flag-er', ['flag-er'], 'Flags', 1664, 2, true, null],
  ['1F1EA-1F1F8', 'es', ['es', 'flag-es'], 'Flags', 1665, 0.6, true, null],
  ['1F1EA-1F1F9', 'flag-et', ['flag-et'], 'Flags', 1666, 2, true, null],
  ['1F1EA-1F1FA', 'flag-eu', ['flag-eu'], 'Flags', 1667, 2, true, null],
  ['1F1EB-1F1EE', 'flag-fi', ['flag-fi'], 'Flags', 1668, 2, true, null],
  ['1F1EB-1F1EF', 'flag-fj', ['flag-fj'], 'Flags', 1669, 2, true, null],
  ['1F1EB-1F1F0', 'flag-fk', ['flag-fk'], 'Flags', 1670, 2, true, null],
  ['1F1EB-1F1F2', 'flag-fm', ['flag-fm'], 'Flags', 1671, 2, true, null],
  ['1F1EB-1F1F4', 'flag-fo', ['flag-fo'], 'Flags', 1672, 2, true, null],
  ['1F1EB-1F1F7', 'fr', ['fr', 'flag-fr'], 'Flags', 1673, 0.6, true, null],
  ['1F1EC-1F1E6', 'flag-ga', ['flag-ga'], 'Flags', 1674, 2, true, null],
  ['1F1EC-1F1E7', 'gb', ['gb', 'uk', 'flag-gb'], 'Flags', 1675, 0.6, true, null],
  ['1F1EC-1F1E9', 'flag-gd', ['flag-gd'], 'Flags', 1676, 2, true, null],
  ['1F1EC-1F1EA', 'flag-ge', ['flag-ge'], 'Flags', 1677, 2, true, null],
  ['1F1EC-1F1EB', 'flag-gf', ['flag-gf'], 'Flags', 1678, 2, true, null],
  ['1F1EC-1F1EC', 'flag-gg', ['flag-gg'], 'Flags', 1679, 2, true, null],
  ['1F1EC-1F1ED', 'flag-gh', ['flag-gh'], 'Flags', 1680, 2, true, null],
  ['1F1EC-1F1EE', 'flag-gi', ['flag-gi'], 'Flags', 1681, 2, true, null],
  ['1F1EC-1F1F1', 'flag-gl', ['flag-gl'], 'Flags', 1682, 2, true, null],
  ['1F1EC-1F1F2', 'flag-gm', ['flag-gm'], 'Flags', 1683, 2, true, null],
  ['1F1EC-1F1F3', 'flag-gn', ['flag-gn'], 'Flags', 1684, 2, true, null],
  ['1F1EC-1F1F5', 'flag-gp', ['flag-gp'], 'Flags', 1685, 2, true, null],
  ['1F1EC-1F1F6', 'flag-gq', ['flag-gq'], 'Flags', 1686, 2, true, null],
  ['1F1EC-1F1F7', 'flag-gr', ['flag-gr'], 'Flags', 1687, 2, true, null],
  ['1F1EC-1F1F8', 'flag-gs', ['flag-gs'], 'Flags', 1688, 2, true, null],
  ['1F1EC-1F1F9', 'flag-gt', ['flag-gt'], 'Flags', 1689, 2, true, null],
  ['1F1EC-1F1FA', 'flag-gu', ['flag-gu'], 'Flags', 1690, 2, true, null],
  ['1F1EC-1F1FC', 'flag-gw', ['flag-gw'], 'Flags', 1691, 2, true, null],
  ['1F1EC-1F1FE', 'flag-gy', ['flag-gy'], 'Flags', 1692, 2, true, null],
  ['1F1ED-1F1F0', 'flag-hk', ['flag-hk'], 'Flags', 1693, 2, true, null],
  ['1F1ED-1F1F2', 'flag-hm', ['flag-hm'], 'Flags', 1694, 2, true, null],
  ['1F1ED-1F1F3', 'flag-hn', ['flag-hn'], 'Flags', 1695, 2, true, null],
  ['1F1ED-1F1F7', 'flag-hr', ['flag-hr'], 'Flags', 1696, 2, true, null],
  ['1F1ED-1F1F9', 'flag-ht', ['flag-ht'], 'Flags', 1697, 2, true, null],
  ['1F1ED-1F1FA', 'flag-hu', ['flag-hu'], 'Flags', 1698, 2, true, null],
  ['1F1EE-1F1E8', 'flag-ic', ['flag-ic'], 'Flags', 1699, 2, true, null],
  ['1F1EE-1F1E9', 'flag-id', ['flag-id'], 'Flags', 1700, 2, true, null],
  ['1F1EE-1F1EA', 'flag-ie', ['flag-ie'], 'Flags', 1701, 2, true, null],
  ['1F1EE-1F1F1', 'flag-il', ['flag-il'], 'Flags', 1702, 2, true, null],
  ['1F1EE-1F1F2', 'flag-im', ['flag-im'], 'Flags', 1703, 2, true, null],
  ['1F1EE-1F1F3', 'flag-in', ['flag-in'], 'Flags', 1704, 2, true, null],
  ['1F1EE-1F1F4', 'flag-io', ['flag-io'], 'Flags', 1705, 2, true, null],
  ['1F1EE-1F1F6', 'flag-iq', ['flag-iq'], 'Flags', 1706, 2, true, null],
  ['1F1EE-1F1F7', 'flag-ir', ['flag-ir'], 'Flags', 1707, 2, true, null],
  ['1F1EE-1F1F8', 'flag-is', ['flag-is'], 'Flags', 1708, 2, true, null],
  ['1F1EE-1F1F9', 'it', ['it', 'flag-it'], 'Flags', 1709, 0.6, true, null],
  ['1F1EF-1F1EA', 'flag-je', ['flag-je'], 'Flags', 1710, 2, true, null],
  ['1F1EF-1F1F2', 'flag-jm', ['flag-jm'], 'Flags', 1711, 2, true, null],
  ['1F1EF-1F1F4', 'flag-jo', ['flag-jo'], 'Flags', 1712, 2, true, null],
  ['1F1EF-1F1F5', 'jp', ['jp', 'flag-jp'], 'Flags', 1713, 0.6, true, null],
  ['1F1F0-1F1EA', 'flag-ke', ['flag-ke'], 'Flags', 1714, 2, true, null],
  ['1F1F0-1F1EC', 'flag-kg', ['flag-kg'], 'Flags', 1715, 2, true, null],
  ['1F1F0-1F1ED', 'flag-kh', ['flag-kh'], 'Flags', 1716, 2, true, null],
  ['1F1F0-1F1EE', 'flag-ki', ['flag-ki'], 'Flags', 1717, 2, true, null],
  ['1F1F0-1F1F2', 'flag-km', ['flag-km'], 'Flags', 1718, 2, true, null],
  ['1F1F0-1F1F3', 'flag-kn', ['flag-kn'], 'Flags', 1719, 2, true, null],
  ['1F1F0-1F1F5', 'flag-kp', ['flag-kp'], 'Flags', 1720, 2, true, null],
  ['1F1F0-1F1F7', 'kr', ['kr', 'flag-kr'], 'Flags', 1721, 0.6, true, null],
  ['1F1F0-1F1FC', 'flag-kw', ['flag-kw'], 'Flags', 1722, 2, true, null],
  ['1F1F0-1F1FE', 'flag-ky', ['flag-ky'], 'Flags', 1723, 2, true, null],
  ['1F1F0-1F1FF', 'flag-kz', ['flag-kz'], 'Flags', 1724, 2, true, null],
  ['1F1F1-1F1E6', 'flag-la', ['flag-la'], 'Flags', 1725, 2, true, null],
  ['1F1F1-1F1E7', 'flag-lb', ['flag-lb'], 'Flags', 1726, 2, true, null],
  ['1F1F1-1F1E8', 'flag-lc', ['flag-lc'], 'Flags', 1727, 2, true, null],
  ['1F1F1-1F1EE', 'flag-li', ['flag-li'], 'Flags', 1728, 2, true, null],
  ['1F1F1-1F1F0', 'flag-lk', ['flag-lk'], 'Flags', 1729, 2, true, null],
  ['1F1F1-1F1F7', 'flag-lr', ['flag-lr'], 'Flags', 1730, 2, true, null],
  ['1F1F1-1F1F8', 'flag-ls', ['flag-ls'], 'Flags', 1731, 2, true, null],
  ['1F1F1-1F1F9', 'flag-lt', ['flag-lt'], 'Flags', 1732, 2, true, null],
  ['1F1F1-1F1FA', 'flag-lu', ['flag-lu'], 'Flags', 1733, 2, true, null],
  ['1F1F1-1F1FB', 'flag-lv', ['flag-lv'], 'Flags', 1734, 2, true, null],
  ['1F1F1-1F1FE', 'flag-ly', ['flag-ly'], 'Flags', 1735, 2, true, null],
  ['1F1F2-1F1E6', 'flag-ma', ['flag-ma'], 'Flags', 1736, 2, true, null],
  ['1F1F2-1F1E8', 'flag-mc', ['flag-mc'], 'Flags', 1737, 2, true, null],
  ['1F1F2-1F1E9', 'flag-md', ['flag-md'], 'Flags', 1738, 2, true, null],
  ['1F1F2-1F1EA', 'flag-me', ['flag-me'], 'Flags', 1739, 2, true, null],
  ['1F1F2-1F1EB', 'flag-mf', ['flag-mf'], 'Flags', 1740, 2, true, null],
  ['1F1F2-1F1EC', 'flag-mg', ['flag-mg'], 'Flags', 1741, 2, true, null],
  ['1F1F2-1F1ED', 'flag-mh', ['flag-mh'], 'Flags', 1742, 2, true, null],
  ['1F1F2-1F1F0', 'flag-mk', ['flag-mk'], 'Flags', 1743, 2, true, null],
  ['1F1F2-1F1F1', 'flag-ml', ['flag-ml'], 'Flags', 1744, 2, true, null],
  ['1F1F2-1F1F2', 'flag-mm', ['flag-mm'], 'Flags', 1745, 2, true, null],
  ['1F1F2-1F1F3', 'flag-mn', ['flag-mn'], 'Flags', 1746, 2, true, null],
  ['1F1F2-1F1F4', 'flag-mo', ['flag-mo'], 'Flags', 1747, 2, true, null],
  ['1F1F2-1F1F5', 'flag-mp', ['flag-mp'], 'Flags', 1748, 2, true, null],
  ['1F1F2-1F1F6', 'flag-mq', ['flag-mq'], 'Flags', 1749, 2, true, null],
  ['1F1F2-1F1F7', 'flag-mr', ['flag-mr'], 'Flags', 1750, 2, true, null],
  ['1F1F2-1F1F8', 'flag-ms', ['flag-ms'], 'Flags', 1751, 2, true, null],
  ['1F1F2-1F1F9', 'flag-mt', ['flag-mt'], 'Flags', 1752, 2, true, null],
  ['1F1F2-1F1FA', 'flag-mu', ['flag-mu'], 'Flags', 1753, 2, true, null],
  ['1F1F2-1F1FB', 'flag-mv', ['flag-mv'], 'Flags', 1754, 2, true, null],
  ['1F1F2-1F1FC', 'flag-mw', ['flag-mw'], 'Flags', 1755, 2, true, null],
  ['1F1F2-1F1FD', 'flag-mx', ['flag-mx'], 'Flags', 1756, 2, true, null],
  ['1F1F2-1F1FE', 'flag-my', ['flag-my'], 'Flags', 1757, 2, true, null],
  ['1F1F2-1F1FF', 'flag-mz', ['flag-mz'], 'Flags', 1758, 2, true, null],
  ['1F1F3-1F1E6', 'flag-na', ['flag-na'], 'Flags', 1759, 2, true, null],
  ['1F1F3-1F1E8', 'flag-nc', ['flag-nc'], 'Flags', 1760, 2, true, null],
  ['1F1F3-1F1EA', 'flag-ne', ['flag-ne'], 'Flags', 1761, 2, true, null],
  ['1F1F3-1F1EB', 'flag-nf', ['flag-nf'], 'Flags', 1762, 2, true, null],
  ['1F1F3-1F1EC', 'flag-ng', ['flag-ng'], 'Flags', 1763, 2, true, null],
  ['1F1F3-1F1EE', 'flag-ni', ['flag-ni'], 'Flags', 1764, 2, true, null],
  ['1F1F3-1F1F1', 'flag-nl', ['flag-nl'], 'Flags', 1765, 2, true, null],
  ['1F1F3-1F1F4', 'flag-no', ['flag-no'], 'Flags', 1766, 2, true, null],
  ['1F1F3-1F1F5', 'flag-np', ['flag-np'], 'Flags', 1767, 2, true, null],
  ['1F1F3-1F1F7', 'flag-nr', ['flag-nr'], 'Flags', 1768, 2, true, null],
  ['1F1F3-1F1FA', 'flag-nu', ['flag-nu'], 'Flags', 1769, 2, true, null],
  ['1F1F3-1F1FF', 'flag-nz', ['flag-nz'], 'Flags', 1770, 2, true, null],
  ['1F1F4-1F1F2', 'flag-om', ['flag-om'], 'Flags', 1771, 2, true, null],
  ['1F1F5-1F1E6', 'flag-pa', ['flag-pa'], 'Flags', 1772, 2, true, null],
  ['1F1F5-1F1EA', 'flag-pe', ['flag-pe'], 'Flags', 1773, 2, true, null],
  ['1F1F5-1F1EB', 'flag-pf', ['flag-pf'], 'Flags', 1774, 2, true, null],
  ['1F1F5-1F1EC', 'flag-pg', ['flag-pg'], 'Flags', 1775, 2, true, null],
  ['1F1F5-1F1ED', 'flag-ph', ['flag-ph'], 'Flags', 1776, 2, true, null],
  ['1F1F5-1F1F0', 'flag-pk', ['flag-pk'], 'Flags', 1777, 2, true, null],
  ['1F1F5-1F1F1', 'flag-pl', ['flag-pl'], 'Flags', 1778, 2, true, null],
  ['1F1F5-1F1F2', 'flag-pm', ['flag-pm'], 'Flags', 1779, 2, true, null],
  ['1F1F5-1F1F3', 'flag-pn', ['flag-pn'], 'Flags', 1780, 2, true, null],
  ['1F1F5-1F1F7', 'flag-pr', ['flag-pr'], 'Flags', 1781, 2, true, null],
  ['1F1F5-1F1F8', 'flag-ps', ['flag-ps'], 'Flags', 1782, 2, true, null],
  ['1F1F5-1F1F9', 'flag-pt', ['flag-pt'], 'Flags', 1783, 2, true, null],
  ['1F1F5-1F1FC', 'flag-pw', ['flag-pw'], 'Flags', 1784, 2, true, null],
  ['1F1F5-1F1FE', 'flag-py', ['flag-py'], 'Flags', 1785, 2, true, null],
  ['1F1F6-1F1E6', 'flag-qa', ['flag-qa'], 'Flags', 1786, 2, true, null],
  ['1F1F7-1F1EA', 'flag-re', ['flag-re'], 'Flags', 1787, 2, true, null],
  ['1F1F7-1F1F4', 'flag-ro', ['flag-ro'], 'Flags', 1788, 2, true, null],
  ['1F1F7-1F1F8', 'flag-rs', ['flag-rs'], 'Flags', 1789, 2, true, null],
  ['1F1F7-1F1FA', 'ru', ['ru', 'flag-ru'], 'Flags', 1790, 0.6, true, null],
  ['1F1F7-1F1FC', 'flag-rw', ['flag-rw'], 'Flags', 1791, 2, true, null],
  ['1F1F8-1F1E6', 'flag-sa', ['flag-sa'], 'Flags', 1792, 2, true, null],
  ['1F1F8-1F1E7', 'flag-sb', ['flag-sb'], 'Flags', 1793, 2, true, null],
  ['1F1F8-1F1E8', 'flag-sc', ['flag-sc'], 'Flags', 1794, 2, true, null],
  ['1F1F8-1F1E9', 'flag-sd', ['flag-sd'], 'Flags', 1795, 2, true, null],
  ['1F1F8-1F1EA', 'flag-se', ['flag-se'], 'Flags', 1796, 2, true, null],
  ['1F1F8-1F1EC', 'flag-sg', ['flag-sg'], 'Flags', 1797, 2, true, null],
  ['1F1F8-1F1ED', 'flag-sh', ['flag-sh'], 'Flags', 1798, 2, true, null],
  ['1F1F8-1F1EE', 'flag-si', ['flag-si'], 'Flags', 1799, 2, true, null],
  ['1F1F8-1F1EF', 'flag-sj', ['flag-sj'], 'Flags', 1800, 2, true, null],
  ['1F1F8-1F1F0', 'flag-sk', ['flag-sk'], 'Flags', 1801, 2, true, null],
  ['1F1F8-1F1F1', 'flag-sl', ['flag-sl'], 'Flags', 1802, 2, true, null],
  ['1F1F8-1F1F2', 'flag-sm', ['flag-sm'], 'Flags', 1803, 2, true, null],
  ['1F1F8-1F1F3', 'flag-sn', ['flag-sn'], 'Flags', 1804, 2, true, null],
  ['1F1F8-1F1F4', 'flag-so', ['flag-so'], 'Flags', 1805, 2, true, null],
  ['1F1F8-1F1F7', 'flag-sr', ['flag-sr'], 'Flags', 1806, 2, true, null],
  ['1F1F8-1F1F8', 'flag-ss', ['flag-ss'], 'Flags', 1807, 2, true, null],
  ['1F1F8-1F1F9', 'flag-st', ['flag-st'], 'Flags', 1808, 2, true, null],
  ['1F1F8-1F1FB', 'flag-sv', ['flag-sv'], 'Flags', 1809, 2, true, null],
  ['1F1F8-1F1FD', 'flag-sx', ['flag-sx'], 'Flags', 1810, 2, true, null],
  ['1F1F8-1F1FE', 'flag-sy', ['flag-sy'], 'Flags', 1811, 2, true, null],
  ['1F1F8-1F1FF', 'flag-sz', ['flag-sz'], 'Flags', 1812, 2, true, null],
  ['1F1F9-1F1E6', 'flag-ta', ['flag-ta'], 'Flags', 1813, 2, true, null],
  ['1F1F9-1F1E8', 'flag-tc', ['flag-tc'], 'Flags', 1814, 2, true, null],
  ['1F1F9-1F1E9', 'flag-td', ['flag-td'], 'Flags', 1815, 2, true, null],
  ['1F1F9-1F1EB', 'flag-tf', ['flag-tf'], 'Flags', 1816, 2, true, null],
  ['1F1F9-1F1EC', 'flag-tg', ['flag-tg'], 'Flags', 1817, 2, true, null],
  ['1F1F9-1F1ED', 'flag-th', ['flag-th'], 'Flags', 1818, 2, true, null],
  ['1F1F9-1F1EF', 'flag-tj', ['flag-tj'], 'Flags', 1819, 2, true, null],
  ['1F1F9-1F1F0', 'flag-tk', ['flag-tk'], 'Flags', 1820, 2, true, null],
  ['1F1F9-1F1F1', 'flag-tl', ['flag-tl'], 'Flags', 1821, 2, true, null],
  ['1F1F9-1F1F2', 'flag-tm', ['flag-tm'], 'Flags', 1822, 2, true, null],
  ['1F1F9-1F1F3', 'flag-tn', ['flag-tn'], 'Flags', 1823, 2, true, null],
  ['1F1F9-1F1F4', 'flag-to', ['flag-to'], 'Flags', 1824, 2, true, null],
  ['1F1F9-1F1F7', 'flag-tr', ['flag-tr'], 'Flags', 1825, 2, true, null],
  ['1F1F9-1F1F9', 'flag-tt', ['flag-tt'], 'Flags', 1826, 2, true, null],
  ['1F1F9-1F1FB', 'flag-tv', ['flag-tv'], 'Flags', 1827, 2, true, null],
  ['1F1F9-1F1FC', 'flag-tw', ['flag-tw'], 'Flags', 1828, 2, true, null],
  ['1F1F9-1F1FF', 'flag-tz', ['flag-tz'], 'Flags', 1829, 2, true, null],
  ['1F1FA-1F1E6', 'flag-ua', ['flag-ua'], 'Flags', 1830, 2, true, null],
  ['1F1FA-1F1EC', 'flag-ug', ['flag-ug'], 'Flags', 1831, 2, true, null],
  ['1F1FA-1F1F2', 'flag-um', ['flag-um'], 'Flags', 1832, 2, true, null],
  ['1F1FA-1F1F3', 'flag-un', ['flag-un'], 'Flags', 1833, 4, true, null],
  ['1F1FA-1F1F8', 'us', ['us', 'flag-us'], 'Flags', 1834, 0.6, true, null],
  ['1F1FA-1F1FE', 'flag-uy', ['flag-uy'], 'Flags', 1835, 2, true, null],
  ['1F1FA-1F1FF', 'flag-uz', ['flag-uz'], 'Flags', 1836, 2, true, null],
  ['1F1FB-1F1E6', 'flag-va', ['flag-va'], 'Flags', 1837, 2, true, null],
  ['1F1FB-1F1E8', 'flag-vc', ['flag-vc'], 'Flags', 1838, 2, true, null],
  ['1F1FB-1F1EA', 'flag-ve', ['flag-ve'], 'Flags', 1839, 2, true, null],
  ['1F1FB-1F1EC', 'flag-vg', ['flag-vg'], 'Flags', 1840, 2, true, null],
  ['1F1FB-1F1EE', 'flag-vi', ['flag-vi'], 'Flags', 1841, 2, true, null],
  ['1F1FB-1F1F3', 'flag-vn', ['flag-vn'], 'Flags', 1842, 2, true, null],
  ['1F1FB-1F1FA', 'flag-vu', ['flag-vu'], 'Flags', 1843, 2, true, null],
  ['1F1FC-1F1EB', 'flag-wf', ['flag-wf'], 'Flags', 1844, 2, true, null],
  ['1F1FC-1F1F8', 'flag-ws', ['flag-ws'], 'Flags', 1845, 2, true, null],
  ['1F1FD-1F1F0', 'flag-xk', ['flag-xk'], 'Flags', 1846, 2, true, null],
  ['1F1FE-1F1EA', 'flag-ye', ['flag-ye'], 'Flags', 1847, 2, true, null],
  ['1F1FE-1F1F9', 'flag-yt', ['flag-yt'], 'Flags', 1848, 2, true, null],
  ['1F1FF-1F1E6', 'flag-za', ['flag-za'], 'Flags', 1849, 2, true, null],
  ['1F1FF-1F1F2', 'flag-zm', ['flag-zm'], 'Flags', 1850, 2, true, null],
  ['1F1FF-1F1FC', 'flag-zw', ['flag-zw'], 'Flags', 1851, 2, true, null],
  ['1F201', 'koko', ['koko'], 'Symbols', 1535, 0.6, true, null],
  ['1F202-FE0F', 'sa', ['sa'], 'Symbols', 1536, 0.6, true, null],
  ['1F21A', 'u7121', ['u7121'], 'Symbols', 1542, 0.6, true, null],
  ['1F22F', 'u6307', ['u6307'], 'Symbols', 1539, 0.6, true, null],
  ['1F232', 'u7981', ['u7981'], 'Symbols', 1543, 0.6, true, null],
  ['1F233', 'u7a7a', ['u7a7a'], 'Symbols', 1547, 0.6, true, null],
  ['1F234', 'u5408', ['u5408'], 'Symbols', 1546, 0.6, true, null],
  ['1F235', 'u6e80', ['u6e80'], 'Symbols', 1551, 0.6, true, null],
  ['1F236', 'u6709', ['u6709'], 'Symbols', 1538, 0.6, true, null],
  ['1F237-FE0F', 'u6708', ['u6708'], 'Symbols', 1537, 0.6, true, null],
  ['1F238', 'u7533', ['u7533'], 'Symbols', 1545, 0.6, true, null],
  ['1F239', 'u5272', ['u5272'], 'Symbols', 1541, 0.6, true, null],
  ['1F23A', 'u55b6', ['u55b6'], 'Symbols', 1550, 0.6, true, null],
  ['1F250', 'ideograph_advantage', ['ideograph_advantage'], 'Symbols', 1540, 0.6, true, null],
  ['1F251', 'accept', ['accept'], 'Symbols', 1544, 0.6, true, null],
  ['1F300', 'cyclone', ['cyclone'], 'Travel & Places', 1010, 0.6, true, null],
  ['1F301', 'foggy', ['foggy'], 'Travel & Places', 857, 0.6, true, null],
  ['1F302', 'closed_umbrella', ['closed_umbrella'], 'Travel & Places', 1012, 0.6, true, null],
  ['1F303', 'night_with_stars', ['night_with_stars'], 'Travel & Places', 858, 0.6, true, null],
  [
    '1F304',
    'sunrise_over_mountains',
    ['sunrise_over_mountains'],
    'Travel & Places',
    860,
    0.6,
    true,
    null,
  ],
  ['1F305', 'sunrise', ['sunrise'], 'Travel & Places', 861, 0.6, true, null],
  ['1F306', 'city_sunset', ['city_sunset'], 'Travel & Places', 862, 0.6, true, null],
  ['1F307', 'city_sunrise', ['city_sunrise'], 'Travel & Places', 863, 0.6, true, null],
  ['1F308', 'rainbow', ['rainbow'], 'Travel & Places', 1011, 0.6, true, null],
  ['1F309', 'bridge_at_night', ['bridge_at_night'], 'Travel & Places', 864, 0.6, true, null],
  ['1F30A', 'ocean', ['ocean'], 'Travel & Places', 1023, 0.6, true, null],
  ['1F30B', 'volcano', ['volcano'], 'Travel & Places', 815, 0.6, true, null],
  ['1F30C', 'milky_way', ['milky_way'], 'Travel & Places', 997, 0.6, true, null],
  ['1F30D', 'earth_africa', ['earth_africa'], 'Travel & Places', 806, 0.7, true, null],
  ['1F30E', 'earth_americas', ['earth_americas'], 'Travel & Places', 807, 0.7, true, null],
  ['1F30F', 'earth_asia', ['earth_asia'], 'Travel & Places', 808, 0.6, true, null],
  [
    '1F310',
    'globe_with_meridians',
    ['globe_with_meridians'],
    'Travel & Places',
    809,
    1,
    true,
    null,
  ],
  ['1F311', 'new_moon', ['new_moon'], 'Travel & Places', 977, 0.6, true, null],
  [
    '1F312',
    'waxing_crescent_moon',
    ['waxing_crescent_moon'],
    'Travel & Places',
    978,
    1,
    true,
    null,
  ],
  ['1F313', 'first_quarter_moon', ['first_quarter_moon'], 'Travel & Places', 979, 0.6, true, null],
  ['1F314', 'moon', ['moon', 'waxing_gibbous_moon'], 'Travel & Places', 980, 0.6, true, null],
  ['1F315', 'full_moon', ['full_moon'], 'Travel & Places', 981, 0.6, true, null],
  ['1F316', 'waning_gibbous_moon', ['waning_gibbous_moon'], 'Travel & Places', 982, 1, true, null],
  ['1F317', 'last_quarter_moon', ['last_quarter_moon'], 'Travel & Places', 983, 1, true, null],
  [
    '1F318',
    'waning_crescent_moon',
    ['waning_crescent_moon'],
    'Travel & Places',
    984,
    1,
    true,
    null,
  ],
  ['1F319', 'crescent_moon', ['crescent_moon'], 'Travel & Places', 985, 0.6, true, null],
  ['1F31A', 'new_moon_with_face', ['new_moon_with_face'], 'Travel & Places', 986, 1, true, null],
  [
    '1F31B',
    'first_quarter_moon_with_face',
    ['first_quarter_moon_with_face'],
    'Travel & Places',
    987,
    0.6,
    true,
    null,
  ],
  [
    '1F31C',
    'last_quarter_moon_with_face',
    ['last_quarter_moon_with_face'],
    'Travel & Places',
    988,
    0.7,
    true,
    null,
  ],
  ['1F31D', 'full_moon_with_face', ['full_moon_with_face'], 'Travel & Places', 991, 1, true, null],
  ['1F31E', 'sun_with_face', ['sun_with_face'], 'Travel & Places', 992, 1, true, null],
  ['1F31F', 'star2', ['star2'], 'Travel & Places', 995, 0.6, true, null],
  ['1F320', 'stars', ['stars'], 'Travel & Places', 996, 0.6, true, null],
  ['1F321-FE0F', 'thermometer', ['thermometer'], 'Travel & Places', 989, 0.7, true, null],
  [
    '1F324-FE0F',
    'mostly_sunny',
    ['mostly_sunny', 'sun_small_cloud'],
    'Travel & Places',
    1001,
    0.7,
    true,
    null,
  ],
  [
    '1F325-FE0F',
    'barely_sunny',
    ['barely_sunny', 'sun_behind_cloud'],
    'Travel & Places',
    1002,
    0.7,
    true,
    null,
  ],
  [
    '1F326-FE0F',
    'partly_sunny_rain',
    ['partly_sunny_rain', 'sun_behind_rain_cloud'],
    'Travel & Places',
    1003,
    0.7,
    true,
    null,
  ],
  ['1F327-FE0F', 'rain_cloud', ['rain_cloud'], 'Travel & Places', 1004, 0.7, true, null],
  ['1F328-FE0F', 'snow_cloud', ['snow_cloud'], 'Travel & Places', 1005, 0.7, true, null],
  [
    '1F329-FE0F',
    'lightning',
    ['lightning', 'lightning_cloud'],
    'Travel & Places',
    1006,
    0.7,
    true,
    null,
  ],
  ['1F32A-FE0F', 'tornado', ['tornado', 'tornado_cloud'], 'Travel & Places', 1007, 0.7, true, null],
  ['1F32B-FE0F', 'fog', ['fog'], 'Travel & Places', 1008, 0.7, true, null],
  [
    '1F32C-FE0F',
    'wind_blowing_face',
    ['wind_blowing_face'],
    'Travel & Places',
    1009,
    0.7,
    true,
    null,
  ],
  ['1F32D', 'hotdog', ['hotdog'], 'Food & Drink', 725, 1, true, null],
  ['1F32E', 'taco', ['taco'], 'Food & Drink', 727, 1, true, null],
  ['1F32F', 'burrito', ['burrito'], 'Food & Drink', 728, 1, true, null],
  ['1F330', 'chestnut', ['chestnut'], 'Food & Drink', 708, 0.6, true, null],
  ['1F331', 'seedling', ['seedling'], 'Animals & Nature', 659, 0.6, true, null],
  ['1F332', 'evergreen_tree', ['evergreen_tree'], 'Animals & Nature', 661, 1, true, null],
  ['1F333', 'deciduous_tree', ['deciduous_tree'], 'Animals & Nature', 662, 1, true, null],
  ['1F334', 'palm_tree', ['palm_tree'], 'Animals & Nature', 663, 0.6, true, null],
  ['1F335', 'cactus', ['cactus'], 'Animals & Nature', 664, 0.6, true, null],
  ['1F336-FE0F', 'hot_pepper', ['hot_pepper'], 'Food & Drink', 698, 0.7, true, null],
  ['1F337', 'tulip', ['tulip'], 'Animals & Nature', 658, 0.6, true, null],
  ['1F338', 'cherry_blossom', ['cherry_blossom'], 'Animals & Nature', 649, 0.6, true, null],
  ['1F339', 'rose', ['rose'], 'Animals & Nature', 653, 0.6, true, null],
  ['1F33A', 'hibiscus', ['hibiscus'], 'Animals & Nature', 655, 0.6, true, null],
  ['1F33B', 'sunflower', ['sunflower'], 'Animals & Nature', 656, 0.6, true, null],
  ['1F33C', 'blossom', ['blossom'], 'Animals & Nature', 657, 0.6, true, null],
  ['1F33D', 'corn', ['corn'], 'Food & Drink', 697, 0.6, true, null],
  ['1F33E', 'ear_of_rice', ['ear_of_rice'], 'Animals & Nature', 665, 0.6, true, null],
  ['1F33F', 'herb', ['herb'], 'Animals & Nature', 666, 0.6, true, null],
  ['1F340', 'four_leaf_clover', ['four_leaf_clover'], 'Animals & Nature', 668, 0.6, true, null],
  ['1F341', 'maple_leaf', ['maple_leaf'], 'Animals & Nature', 669, 0.6, true, null],
  ['1F342', 'fallen_leaf', ['fallen_leaf'], 'Animals & Nature', 670, 0.6, true, null],
  ['1F343', 'leaves', ['leaves'], 'Animals & Nature', 671, 0.6, true, null],
  ['1F344', 'mushroom', ['mushroom'], 'Food & Drink', 705, 0.6, true, null],
  ['1F345', 'tomato', ['tomato'], 'Food & Drink', 690, 0.6, true, null],
  ['1F346', 'eggplant', ['eggplant'], 'Food & Drink', 694, 0.6, true, null],
  ['1F347', 'grapes', ['grapes'], 'Food & Drink', 674, 0.6, true, null],
  ['1F348', 'melon', ['melon'], 'Food & Drink', 675, 0.6, true, null],
  ['1F349', 'watermelon', ['watermelon'], 'Food & Drink', 676, 0.6, true, null],
  ['1F34A', 'tangerine', ['tangerine'], 'Food & Drink', 677, 0.6, true, null],
  ['1F34B', 'lemon', ['lemon'], 'Food & Drink', 678, 1, true, null],
  ['1F34C', 'banana', ['banana'], 'Food & Drink', 679, 0.6, true, null],
  ['1F34D', 'pineapple', ['pineapple'], 'Food & Drink', 680, 0.6, true, null],
  ['1F34E', 'apple', ['apple'], 'Food & Drink', 682, 0.6, true, null],
  ['1F34F', 'green_apple', ['green_apple'], 'Food & Drink', 683, 0.6, true, null],
  ['1F350', 'pear', ['pear'], 'Food & Drink', 684, 1, true, null],
  ['1F351', 'peach', ['peach'], 'Food & Drink', 685, 0.6, true, null],
  ['1F352', 'cherries', ['cherries'], 'Food & Drink', 686, 0.6, true, null],
  ['1F353', 'strawberry', ['strawberry'], 'Food & Drink', 687, 0.6, true, null],
  ['1F354', 'hamburger', ['hamburger'], 'Food & Drink', 722, 0.6, true, null],
  ['1F355', 'pizza', ['pizza'], 'Food & Drink', 724, 0.6, true, null],
  ['1F356', 'meat_on_bone', ['meat_on_bone'], 'Food & Drink', 718, 0.6, true, null],
  ['1F357', 'poultry_leg', ['poultry_leg'], 'Food & Drink', 719, 0.6, true, null],
  ['1F358', 'rice_cracker', ['rice_cracker'], 'Food & Drink', 744, 0.6, true, null],
  ['1F359', 'rice_ball', ['rice_ball'], 'Food & Drink', 745, 0.6, true, null],
  ['1F35A', 'rice', ['rice'], 'Food & Drink', 746, 0.6, true, null],
  ['1F35B', 'curry', ['curry'], 'Food & Drink', 747, 0.6, true, null],
  ['1F35C', 'ramen', ['ramen'], 'Food & Drink', 748, 0.6, true, null],
  ['1F35D', 'spaghetti', ['spaghetti'], 'Food & Drink', 749, 0.6, true, null],
  ['1F35E', 'bread', ['bread'], 'Food & Drink', 709, 0.6, true, null],
  ['1F35F', 'fries', ['fries'], 'Food & Drink', 723, 0.6, true, null],
  ['1F360', 'sweet_potato', ['sweet_potato'], 'Food & Drink', 750, 0.6, true, null],
  ['1F361', 'dango', ['dango'], 'Food & Drink', 756, 0.6, true, null],
  ['1F362', 'oden', ['oden'], 'Food & Drink', 751, 0.6, true, null],
  ['1F363', 'sushi', ['sushi'], 'Food & Drink', 752, 0.6, true, null],
  ['1F364', 'fried_shrimp', ['fried_shrimp'], 'Food & Drink', 753, 0.6, true, null],
  ['1F365', 'fish_cake', ['fish_cake'], 'Food & Drink', 754, 0.6, true, null],
  ['1F366', 'icecream', ['icecream'], 'Food & Drink', 765, 0.6, true, null],
  ['1F367', 'shaved_ice', ['shaved_ice'], 'Food & Drink', 766, 0.6, true, null],
  ['1F368', 'ice_cream', ['ice_cream'], 'Food & Drink', 767, 0.6, true, null],
  ['1F369', 'doughnut', ['doughnut'], 'Food & Drink', 768, 0.6, true, null],
  ['1F36A', 'cookie', ['cookie'], 'Food & Drink', 769, 0.6, true, null],
  ['1F36B', 'chocolate_bar', ['chocolate_bar'], 'Food & Drink', 774, 0.6, true, null],
  ['1F36C', 'candy', ['candy'], 'Food & Drink', 775, 0.6, true, null],
  ['1F36D', 'lollipop', ['lollipop'], 'Food & Drink', 776, 0.6, true, null],
  ['1F36E', 'custard', ['custard'], 'Food & Drink', 777, 0.6, true, null],
  ['1F36F', 'honey_pot', ['honey_pot'], 'Food & Drink', 778, 0.6, true, null],
  ['1F370', 'cake', ['cake'], 'Food & Drink', 771, 0.6, true, null],
  ['1F371', 'bento', ['bento'], 'Food & Drink', 743, 0.6, true, null],
  ['1F372', 'stew', ['stew'], 'Food & Drink', 735, 0.6, true, null],
  ['1F373', 'fried_egg', ['fried_egg', 'cooking'], 'Food & Drink', 733, 0.6, true, null],
  ['1F374', 'fork_and_knife', ['fork_and_knife'], 'Food & Drink', 801, 0.6, true, null],
  ['1F375', 'tea', ['tea'], 'Food & Drink', 783, 0.6, true, null],
  ['1F376', 'sake', ['sake'], 'Food & Drink', 784, 0.6, true, null],
  ['1F377', 'wine_glass', ['wine_glass'], 'Food & Drink', 786, 0.6, true, null],
  ['1F378', 'cocktail', ['cocktail'], 'Food & Drink', 787, 0.6, true, null],
  ['1F379', 'tropical_drink', ['tropical_drink'], 'Food & Drink', 788, 0.6, true, null],
  ['1F37A', 'beer', ['beer'], 'Food & Drink', 789, 0.6, true, null],
  ['1F37B', 'beers', ['beers'], 'Food & Drink', 790, 0.6, true, null],
  ['1F37C', 'baby_bottle', ['baby_bottle'], 'Food & Drink', 779, 1, true, null],
  ['1F37D-FE0F', 'knife_fork_plate', ['knife_fork_plate'], 'Food & Drink', 800, 0.7, true, null],
  ['1F37E', 'champagne', ['champagne'], 'Food & Drink', 785, 1, true, null],
  ['1F37F', 'popcorn', ['popcorn'], 'Food & Drink', 739, 1, true, null],
  ['1F380', 'ribbon', ['ribbon'], 'Activities', 1040, 0.6, true, null],
  ['1F381', 'gift', ['gift'], 'Activities', 1041, 0.6, true, null],
  ['1F382', 'birthday', ['birthday'], 'Food & Drink', 770, 0.6, true, null],
  ['1F383', 'jack_o_lantern', ['jack_o_lantern'], 'Activities', 1024, 0.6, true, null],
  ['1F384', 'christmas_tree', ['christmas_tree'], 'Activities', 1025, 0.6, true, null],
  [
    '1F385',
    'santa',
    ['santa'],
    'People & Body',
    364,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F385-1F3FB', symbol: '🎅🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F385-1F3FC', symbol: '🎅🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F385-1F3FD', symbol: '🎅🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F385-1F3FE', symbol: '🎅🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F385-1F3FF', symbol: '🎅🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F386', 'fireworks', ['fireworks'], 'Activities', 1026, 0.6, true, null],
  ['1F387', 'sparkler', ['sparkler'], 'Activities', 1027, 0.6, true, null],
  ['1F388', 'balloon', ['balloon'], 'Activities', 1030, 0.6, true, null],
  ['1F389', 'tada', ['tada'], 'Activities', 1031, 0.6, true, null],
  ['1F38A', 'confetti_ball', ['confetti_ball'], 'Activities', 1032, 0.6, true, null],
  ['1F38B', 'tanabata_tree', ['tanabata_tree'], 'Activities', 1033, 0.6, true, null],
  ['1F38C', 'crossed_flags', ['crossed_flags'], 'Flags', 1588, 0.6, true, null],
  ['1F38D', 'bamboo', ['bamboo'], 'Activities', 1034, 0.6, true, null],
  ['1F38E', 'dolls', ['dolls'], 'Activities', 1035, 0.6, true, null],
  ['1F38F', 'flags', ['flags'], 'Activities', 1036, 0.6, true, null],
  ['1F390', 'wind_chime', ['wind_chime'], 'Activities', 1037, 0.6, true, null],
  ['1F391', 'rice_scene', ['rice_scene'], 'Activities', 1038, 0.6, true, null],
  ['1F392', 'school_satchel', ['school_satchel'], 'Objects', 1134, 0.6, true, null],
  ['1F393', 'mortar_board', ['mortar_board'], 'Objects', 1147, 0.6, true, null],
  ['1F396-FE0F', 'medal', ['medal'], 'Activities', 1045, 0.7, true, null],
  ['1F397-FE0F', 'reminder_ribbon', ['reminder_ribbon'], 'Activities', 1042, 0.7, true, null],
  ['1F399-FE0F', 'studio_microphone', ['studio_microphone'], 'Objects', 1167, 0.7, true, null],
  ['1F39A-FE0F', 'level_slider', ['level_slider'], 'Objects', 1168, 0.7, true, null],
  ['1F39B-FE0F', 'control_knobs', ['control_knobs'], 'Objects', 1169, 0.7, true, null],
  ['1F39E-FE0F', 'film_frames', ['film_frames'], 'Objects', 1203, 0.7, true, null],
  ['1F39F-FE0F', 'admission_tickets', ['admission_tickets'], 'Activities', 1043, 0.7, true, null],
  ['1F3A0', 'carousel_horse', ['carousel_horse'], 'Travel & Places', 866, 0.6, true, null],
  ['1F3A1', 'ferris_wheel', ['ferris_wheel'], 'Travel & Places', 868, 0.6, true, null],
  ['1F3A2', 'roller_coaster', ['roller_coaster'], 'Travel & Places', 869, 0.6, true, null],
  [
    '1F3A3',
    'fishing_pole_and_fish',
    ['fishing_pole_and_fish'],
    'Activities',
    1072,
    0.6,
    true,
    null,
  ],
  ['1F3A4', 'microphone', ['microphone'], 'Objects', 1170, 0.6, true, null],
  ['1F3A5', 'movie_camera', ['movie_camera'], 'Objects', 1202, 0.6, true, null],
  ['1F3A6', 'cinema', ['cinema'], 'Symbols', 1455, 0.6, true, null],
  ['1F3A7', 'headphones', ['headphones'], 'Objects', 1171, 0.6, true, null],
  ['1F3A8', 'art', ['art'], 'Activities', 1105, 0.6, true, null],
  ['1F3A9', 'tophat', ['tophat'], 'Objects', 1146, 0.6, true, null],
  ['1F3AA', 'circus_tent', ['circus_tent'], 'Travel & Places', 871, 0.6, true, null],
  ['1F3AB', 'ticket', ['ticket'], 'Activities', 1044, 0.6, true, null],
  ['1F3AC', 'clapper', ['clapper'], 'Objects', 1205, 0.6, true, null],
  ['1F3AD', 'performing_arts', ['performing_arts'], 'Activities', 1103, 0.6, true, null],
  ['1F3AE', 'video_game', ['video_game'], 'Activities', 1086, 0.6, true, null],
  ['1F3AF', 'dart', ['dart'], 'Activities', 1078, 0.6, true, null],
  ['1F3B0', 'slot_machine', ['slot_machine'], 'Activities', 1088, 0.6, true, null],
  ['1F3B1', '8ball', ['8ball'], 'Activities', 1081, 0.6, true, null],
  ['1F3B2', 'game_die', ['game_die'], 'Activities', 1089, 0.6, true, null],
  ['1F3B3', 'bowling', ['bowling'], 'Activities', 1060, 0.6, true, null],
  ['1F3B4', 'flower_playing_cards', ['flower_playing_cards'], 'Activities', 1102, 0.6, true, null],
  ['1F3B5', 'musical_note', ['musical_note'], 'Objects', 1165, 0.6, true, null],
  ['1F3B6', 'notes', ['notes'], 'Objects', 1166, 0.6, true, null],
  ['1F3B7', 'saxophone', ['saxophone'], 'Objects', 1173, 0.6, true, null],
  ['1F3B8', 'guitar', ['guitar'], 'Objects', 1175, 0.6, true, null],
  ['1F3B9', 'musical_keyboard', ['musical_keyboard'], 'Objects', 1176, 0.6, true, null],
  ['1F3BA', 'trumpet', ['trumpet'], 'Objects', 1177, 0.6, true, null],
  ['1F3BB', 'violin', ['violin'], 'Objects', 1178, 0.6, true, null],
  ['1F3BC', 'musical_score', ['musical_score'], 'Objects', 1164, 0.6, true, null],
  [
    '1F3BD',
    'running_shirt_with_sash',
    ['running_shirt_with_sash'],
    'Activities',
    1074,
    0.6,
    true,
    null,
  ],
  ['1F3BE', 'tennis', ['tennis'], 'Activities', 1058, 0.6, true, null],
  ['1F3BF', 'ski', ['ski'], 'Activities', 1075, 0.6, true, null],
  ['1F3C0', 'basketball', ['basketball'], 'Activities', 1054, 0.6, true, null],
  ['1F3C1', 'checkered_flag', ['checkered_flag'], 'Flags', 1586, 0.6, true, null],
  [
    '1F3C2',
    'snowboarder',
    ['snowboarder'],
    'People & Body',
    437,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F3C2-1F3FB', symbol: '🏂🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F3C2-1F3FC', symbol: '🏂🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F3C2-1F3FD', symbol: '🏂🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F3C2-1F3FE', symbol: '🏂🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F3C2-1F3FF', symbol: '🏂🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F3C3-200D-2640-FE0F',
    'woman-running',
    ['woman-running'],
    'People & Body',
    421,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F3C3-1F3FB-200D-2640-FE0F',
        symbol: '🏃🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F3C3-1F3FC-200D-2640-FE0F',
        symbol: '🏃🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F3C3-1F3FD-200D-2640-FE0F',
        symbol: '🏃🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F3C3-1F3FE-200D-2640-FE0F',
        symbol: '🏃🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F3C3-1F3FF-200D-2640-FE0F',
        symbol: '🏃🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F3C3-200D-2642-FE0F',
    'man-running',
    ['man-running'],
    'People & Body',
    420,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F3C3-1F3FB-200D-2642-FE0F',
        symbol: '🏃🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F3C3-1F3FC-200D-2642-FE0F',
        symbol: '🏃🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F3C3-1F3FD-200D-2642-FE0F',
        symbol: '🏃🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F3C3-1F3FE-200D-2642-FE0F',
        symbol: '🏃🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F3C3-1F3FF-200D-2642-FE0F',
        symbol: '🏃🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F3C3',
    'runner',
    ['runner', 'running'],
    'People & Body',
    419,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F3C3-1F3FB', symbol: '🏃🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F3C3-1F3FC', symbol: '🏃🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F3C3-1F3FD', symbol: '🏃🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F3C3-1F3FE', symbol: '🏃🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F3C3-1F3FF', symbol: '🏃🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F3C4-200D-2640-FE0F',
    'woman-surfing',
    ['woman-surfing'],
    'People & Body',
    443,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F3C4-1F3FB-200D-2640-FE0F',
        symbol: '🏄🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F3C4-1F3FC-200D-2640-FE0F',
        symbol: '🏄🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F3C4-1F3FD-200D-2640-FE0F',
        symbol: '🏄🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F3C4-1F3FE-200D-2640-FE0F',
        symbol: '🏄🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F3C4-1F3FF-200D-2640-FE0F',
        symbol: '🏄🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F3C4-200D-2642-FE0F',
    'man-surfing',
    ['man-surfing'],
    'People & Body',
    442,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F3C4-1F3FB-200D-2642-FE0F',
        symbol: '🏄🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F3C4-1F3FC-200D-2642-FE0F',
        symbol: '🏄🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F3C4-1F3FD-200D-2642-FE0F',
        symbol: '🏄🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F3C4-1F3FE-200D-2642-FE0F',
        symbol: '🏄🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F3C4-1F3FF-200D-2642-FE0F',
        symbol: '🏄🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F3C4',
    'surfer',
    ['surfer'],
    'People & Body',
    441,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F3C4-1F3FB', symbol: '🏄🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F3C4-1F3FC', symbol: '🏄🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F3C4-1F3FD', symbol: '🏄🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F3C4-1F3FE', symbol: '🏄🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F3C4-1F3FF', symbol: '🏄🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F3C5', 'sports_medal', ['sports_medal'], 'Activities', 1047, 1, true, null],
  ['1F3C6', 'trophy', ['trophy'], 'Activities', 1046, 0.6, true, null],
  [
    '1F3C7',
    'horse_racing',
    ['horse_racing'],
    'People & Body',
    435,
    1,
    true,
    {
      '1F3FB': { unified: '1F3C7-1F3FB', symbol: '🏇🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F3C7-1F3FC', symbol: '🏇🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F3C7-1F3FD', symbol: '🏇🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F3C7-1F3FE', symbol: '🏇🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F3C7-1F3FF', symbol: '🏇🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F3C8', 'football', ['football'], 'Activities', 1056, 0.6, true, null],
  ['1F3C9', 'rugby_football', ['rugby_football'], 'Activities', 1057, 1, true, null],
  [
    '1F3CA-200D-2640-FE0F',
    'woman-swimming',
    ['woman-swimming'],
    'People & Body',
    449,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F3CA-1F3FB-200D-2640-FE0F',
        symbol: '🏊🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F3CA-1F3FC-200D-2640-FE0F',
        symbol: '🏊🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F3CA-1F3FD-200D-2640-FE0F',
        symbol: '🏊🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F3CA-1F3FE-200D-2640-FE0F',
        symbol: '🏊🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F3CA-1F3FF-200D-2640-FE0F',
        symbol: '🏊🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F3CA-200D-2642-FE0F',
    'man-swimming',
    ['man-swimming'],
    'People & Body',
    448,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F3CA-1F3FB-200D-2642-FE0F',
        symbol: '🏊🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F3CA-1F3FC-200D-2642-FE0F',
        symbol: '🏊🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F3CA-1F3FD-200D-2642-FE0F',
        symbol: '🏊🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F3CA-1F3FE-200D-2642-FE0F',
        symbol: '🏊🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F3CA-1F3FF-200D-2642-FE0F',
        symbol: '🏊🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F3CA',
    'swimmer',
    ['swimmer'],
    'People & Body',
    447,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F3CA-1F3FB', symbol: '🏊🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F3CA-1F3FC', symbol: '🏊🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F3CA-1F3FD', symbol: '🏊🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F3CA-1F3FE', symbol: '🏊🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F3CA-1F3FF', symbol: '🏊🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F3CB-FE0F-200D-2640-FE0F',
    'woman-lifting-weights',
    ['woman-lifting-weights'],
    'People & Body',
    455,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F3CB-1F3FB-200D-2640-FE0F',
        symbol: '🏋🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F3CB-1F3FC-200D-2640-FE0F',
        symbol: '🏋🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F3CB-1F3FD-200D-2640-FE0F',
        symbol: '🏋🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F3CB-1F3FE-200D-2640-FE0F',
        symbol: '🏋🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F3CB-1F3FF-200D-2640-FE0F',
        symbol: '🏋🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F3CB-FE0F-200D-2642-FE0F',
    'man-lifting-weights',
    ['man-lifting-weights'],
    'People & Body',
    454,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F3CB-1F3FB-200D-2642-FE0F',
        symbol: '🏋🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F3CB-1F3FC-200D-2642-FE0F',
        symbol: '🏋🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F3CB-1F3FD-200D-2642-FE0F',
        symbol: '🏋🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F3CB-1F3FE-200D-2642-FE0F',
        symbol: '🏋🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F3CB-1F3FF-200D-2642-FE0F',
        symbol: '🏋🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F3CB-FE0F',
    'weight_lifter',
    ['weight_lifter'],
    'People & Body',
    453,
    0.7,
    true,
    {
      '1F3FB': { unified: '1F3CB-1F3FB', symbol: '🏋🏻', addedIn: 2, hasImgTwitter: true },
      '1F3FC': { unified: '1F3CB-1F3FC', symbol: '🏋🏼', addedIn: 2, hasImgTwitter: true },
      '1F3FD': { unified: '1F3CB-1F3FD', symbol: '🏋🏽', addedIn: 2, hasImgTwitter: true },
      '1F3FE': { unified: '1F3CB-1F3FE', symbol: '🏋🏾', addedIn: 2, hasImgTwitter: true },
      '1F3FF': { unified: '1F3CB-1F3FF', symbol: '🏋🏿', addedIn: 2, hasImgTwitter: true },
    },
  ],
  [
    '1F3CC-FE0F-200D-2640-FE0F',
    'woman-golfing',
    ['woman-golfing'],
    'People & Body',
    440,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F3CC-1F3FB-200D-2640-FE0F',
        symbol: '🏌🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F3CC-1F3FC-200D-2640-FE0F',
        symbol: '🏌🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F3CC-1F3FD-200D-2640-FE0F',
        symbol: '🏌🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F3CC-1F3FE-200D-2640-FE0F',
        symbol: '🏌🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F3CC-1F3FF-200D-2640-FE0F',
        symbol: '🏌🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F3CC-FE0F-200D-2642-FE0F',
    'man-golfing',
    ['man-golfing'],
    'People & Body',
    439,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F3CC-1F3FB-200D-2642-FE0F',
        symbol: '🏌🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F3CC-1F3FC-200D-2642-FE0F',
        symbol: '🏌🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F3CC-1F3FD-200D-2642-FE0F',
        symbol: '🏌🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F3CC-1F3FE-200D-2642-FE0F',
        symbol: '🏌🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F3CC-1F3FF-200D-2642-FE0F',
        symbol: '🏌🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F3CC-FE0F',
    'golfer',
    ['golfer'],
    'People & Body',
    438,
    0.7,
    true,
    {
      '1F3FB': { unified: '1F3CC-1F3FB', symbol: '🏌🏻', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F3CC-1F3FC', symbol: '🏌🏼', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F3CC-1F3FD', symbol: '🏌🏽', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F3CC-1F3FE', symbol: '🏌🏾', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F3CC-1F3FF', symbol: '🏌🏿', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F3CD-FE0F',
    'racing_motorcycle',
    ['racing_motorcycle'],
    'Travel & Places',
    902,
    0.7,
    true,
    null,
  ],
  ['1F3CE-FE0F', 'racing_car', ['racing_car'], 'Travel & Places', 901, 0.7, true, null],
  ['1F3CF', 'cricket_bat_and_ball', ['cricket_bat_and_ball'], 'Activities', 1061, 1, true, null],
  ['1F3D0', 'volleyball', ['volleyball'], 'Activities', 1055, 1, true, null],
  [
    '1F3D1',
    'field_hockey_stick_and_ball',
    ['field_hockey_stick_and_ball'],
    'Activities',
    1062,
    1,
    true,
    null,
  ],
  [
    '1F3D2',
    'ice_hockey_stick_and_puck',
    ['ice_hockey_stick_and_puck'],
    'Activities',
    1063,
    1,
    true,
    null,
  ],
  [
    '1F3D3',
    'table_tennis_paddle_and_ball',
    ['table_tennis_paddle_and_ball'],
    'Activities',
    1065,
    1,
    true,
    null,
  ],
  [
    '1F3D4-FE0F',
    'snow_capped_mountain',
    ['snow_capped_mountain'],
    'Travel & Places',
    813,
    0.7,
    true,
    null,
  ],
  ['1F3D5-FE0F', 'camping', ['camping'], 'Travel & Places', 817, 0.7, true, null],
  [
    '1F3D6-FE0F',
    'beach_with_umbrella',
    ['beach_with_umbrella'],
    'Travel & Places',
    818,
    0.7,
    true,
    null,
  ],
  [
    '1F3D7-FE0F',
    'building_construction',
    ['building_construction'],
    'Travel & Places',
    824,
    0.7,
    true,
    null,
  ],
  ['1F3D8-FE0F', 'house_buildings', ['house_buildings'], 'Travel & Places', 829, 0.7, true, null],
  ['1F3D9-FE0F', 'cityscape', ['cityscape'], 'Travel & Places', 859, 0.7, true, null],
  [
    '1F3DA-FE0F',
    'derelict_house_building',
    ['derelict_house_building'],
    'Travel & Places',
    830,
    0.7,
    true,
    null,
  ],
  [
    '1F3DB-FE0F',
    'classical_building',
    ['classical_building'],
    'Travel & Places',
    823,
    0.7,
    true,
    null,
  ],
  ['1F3DC-FE0F', 'desert', ['desert'], 'Travel & Places', 819, 0.7, true, null],
  ['1F3DD-FE0F', 'desert_island', ['desert_island'], 'Travel & Places', 820, 0.7, true, null],
  ['1F3DE-FE0F', 'national_park', ['national_park'], 'Travel & Places', 821, 0.7, true, null],
  ['1F3DF-FE0F', 'stadium', ['stadium'], 'Travel & Places', 822, 0.7, true, null],
  ['1F3E0', 'house', ['house'], 'Travel & Places', 831, 0.6, true, null],
  ['1F3E1', 'house_with_garden', ['house_with_garden'], 'Travel & Places', 832, 0.6, true, null],
  ['1F3E2', 'office', ['office'], 'Travel & Places', 833, 0.6, true, null],
  ['1F3E3', 'post_office', ['post_office'], 'Travel & Places', 834, 0.6, true, null],
  [
    '1F3E4',
    'european_post_office',
    ['european_post_office'],
    'Travel & Places',
    835,
    1,
    true,
    null,
  ],
  ['1F3E5', 'hospital', ['hospital'], 'Travel & Places', 836, 0.6, true, null],
  ['1F3E6', 'bank', ['bank'], 'Travel & Places', 837, 0.6, true, null],
  ['1F3E7', 'atm', ['atm'], 'Symbols', 1365, 0.6, true, null],
  ['1F3E8', 'hotel', ['hotel'], 'Travel & Places', 838, 0.6, true, null],
  ['1F3E9', 'love_hotel', ['love_hotel'], 'Travel & Places', 839, 0.6, true, null],
  ['1F3EA', 'convenience_store', ['convenience_store'], 'Travel & Places', 840, 0.6, true, null],
  ['1F3EB', 'school', ['school'], 'Travel & Places', 841, 0.6, true, null],
  ['1F3EC', 'department_store', ['department_store'], 'Travel & Places', 842, 0.6, true, null],
  ['1F3ED', 'factory', ['factory'], 'Travel & Places', 843, 0.6, true, null],
  ['1F3EE', 'izakaya_lantern', ['izakaya_lantern', 'lantern'], 'Objects', 1216, 0.6, true, null],
  ['1F3EF', 'japanese_castle', ['japanese_castle'], 'Travel & Places', 844, 0.6, true, null],
  ['1F3F0', 'european_castle', ['european_castle'], 'Travel & Places', 845, 0.6, true, null],
  ['1F3F3-FE0F-200D-1F308', 'rainbow-flag', ['rainbow-flag'], 'Flags', 1591, 4, true, null],
  [
    '1F3F3-FE0F-200D-26A7-FE0F',
    'transgender_flag',
    ['transgender_flag'],
    'Flags',
    1592,
    13,
    true,
    null,
  ],
  ['1F3F3-FE0F', 'waving_white_flag', ['waving_white_flag'], 'Flags', 1590, 0.7, true, null],
  ['1F3F4-200D-2620-FE0F', 'pirate_flag', ['pirate_flag'], 'Flags', 1593, 11, true, null],
  [
    '1F3F4-E0067-E0062-E0065-E006E-E0067-E007F',
    'flag-england',
    ['flag-england'],
    'Flags',
    1852,
    5,
    true,
    null,
  ],
  [
    '1F3F4-E0067-E0062-E0073-E0063-E0074-E007F',
    'flag-scotland',
    ['flag-scotland'],
    'Flags',
    1853,
    5,
    true,
    null,
  ],
  [
    '1F3F4-E0067-E0062-E0077-E006C-E0073-E007F',
    'flag-wales',
    ['flag-wales'],
    'Flags',
    1854,
    5,
    true,
    null,
  ],
  ['1F3F4', 'waving_black_flag', ['waving_black_flag'], 'Flags', 1589, 1, true, null],
  ['1F3F5-FE0F', 'rosette', ['rosette'], 'Animals & Nature', 652, 0.7, true, null],
  ['1F3F7-FE0F', 'label', ['label'], 'Objects', 1234, 0.7, true, null],
  [
    '1F3F8',
    'badminton_racquet_and_shuttlecock',
    ['badminton_racquet_and_shuttlecock'],
    'Activities',
    1066,
    1,
    true,
    null,
  ],
  ['1F3F9', 'bow_and_arrow', ['bow_and_arrow'], 'Objects', 1303, 1, true, null],
  ['1F3FA', 'amphora', ['amphora'], 'Food & Drink', 805, 1, true, null],
  ['1F3FB', 'skin-tone-2', ['skin-tone-2'], 'Component', 525, 1, true, null],
  ['1F3FC', 'skin-tone-3', ['skin-tone-3'], 'Component', 526, 1, true, null],
  ['1F3FD', 'skin-tone-4', ['skin-tone-4'], 'Component', 527, 1, true, null],
  ['1F3FE', 'skin-tone-5', ['skin-tone-5'], 'Component', 528, 1, true, null],
  ['1F3FF', 'skin-tone-6', ['skin-tone-6'], 'Component', 529, 1, true, null],
  ['1F400', 'rat', ['rat'], 'Animals & Nature', 576, 1, true, null],
  ['1F401', 'mouse2', ['mouse2'], 'Animals & Nature', 575, 1, true, null],
  ['1F402', 'ox', ['ox'], 'Animals & Nature', 556, 1, true, null],
  ['1F403', 'water_buffalo', ['water_buffalo'], 'Animals & Nature', 557, 1, true, null],
  ['1F404', 'cow2', ['cow2'], 'Animals & Nature', 558, 1, true, null],
  ['1F405', 'tiger2', ['tiger2'], 'Animals & Nature', 547, 1, true, null],
  ['1F406', 'leopard', ['leopard'], 'Animals & Nature', 548, 1, true, null],
  ['1F407', 'rabbit2', ['rabbit2'], 'Animals & Nature', 579, 1, true, null],
  ['1F408-200D-2B1B', 'black_cat', ['black_cat'], 'Animals & Nature', 544, 13, true, null],
  ['1F408', 'cat2', ['cat2'], 'Animals & Nature', 543, 0.7, true, null],
  ['1F409', 'dragon', ['dragon'], 'Animals & Nature', 618, 1, true, null],
  ['1F40A', 'crocodile', ['crocodile'], 'Animals & Nature', 613, 1, true, null],
  ['1F40B', 'whale2', ['whale2'], 'Animals & Nature', 622, 1, true, null],
  ['1F40C', 'snail', ['snail'], 'Animals & Nature', 632, 0.6, true, null],
  ['1F40D', 'snake', ['snake'], 'Animals & Nature', 616, 0.6, true, null],
  ['1F40E', 'racehorse', ['racehorse'], 'Animals & Nature', 550, 0.6, true, null],
  ['1F40F', 'ram', ['ram'], 'Animals & Nature', 563, 1, true, null],
  ['1F410', 'goat', ['goat'], 'Animals & Nature', 565, 1, true, null],
  ['1F411', 'sheep', ['sheep'], 'Animals & Nature', 564, 0.6, true, null],
  ['1F412', 'monkey', ['monkey'], 'Animals & Nature', 531, 0.6, true, null],
  ['1F413', 'rooster', ['rooster'], 'Animals & Nature', 596, 1, true, null],
  ['1F414', 'chicken', ['chicken'], 'Animals & Nature', 595, 0.6, true, null],
  ['1F415-200D-1F9BA', 'service_dog', ['service_dog'], 'Animals & Nature', 537, 12, true, null],
  ['1F415', 'dog2', ['dog2'], 'Animals & Nature', 535, 0.7, true, null],
  ['1F416', 'pig2', ['pig2'], 'Animals & Nature', 560, 1, true, null],
  ['1F417', 'boar', ['boar'], 'Animals & Nature', 561, 0.6, true, null],
  ['1F418', 'elephant', ['elephant'], 'Animals & Nature', 570, 0.6, true, null],
  ['1F419', 'octopus', ['octopus'], 'Animals & Nature', 629, 0.6, true, null],
  ['1F41A', 'shell', ['shell'], 'Animals & Nature', 630, 0.6, true, null],
  ['1F41B', 'bug', ['bug'], 'Animals & Nature', 634, 0.6, true, null],
  ['1F41C', 'ant', ['ant'], 'Animals & Nature', 635, 0.6, true, null],
  ['1F41D', 'bee', ['bee', 'honeybee'], 'Animals & Nature', 636, 0.6, true, null],
  ['1F41E', 'ladybug', ['ladybug', 'lady_beetle'], 'Animals & Nature', 638, 0.6, true, null],
  ['1F41F', 'fish', ['fish'], 'Animals & Nature', 625, 0.6, true, null],
  ['1F420', 'tropical_fish', ['tropical_fish'], 'Animals & Nature', 626, 0.6, true, null],
  ['1F421', 'blowfish', ['blowfish'], 'Animals & Nature', 627, 0.6, true, null],
  ['1F422', 'turtle', ['turtle'], 'Animals & Nature', 614, 0.6, true, null],
  ['1F423', 'hatching_chick', ['hatching_chick'], 'Animals & Nature', 597, 0.6, true, null],
  ['1F424', 'baby_chick', ['baby_chick'], 'Animals & Nature', 598, 0.6, true, null],
  ['1F425', 'hatched_chick', ['hatched_chick'], 'Animals & Nature', 599, 0.6, true, null],
  ['1F426', 'bird', ['bird'], 'Animals & Nature', 600, 0.6, true, null],
  ['1F427', 'penguin', ['penguin'], 'Animals & Nature', 601, 0.6, true, null],
  ['1F428', 'koala', ['koala'], 'Animals & Nature', 586, 0.6, true, null],
  ['1F429', 'poodle', ['poodle'], 'Animals & Nature', 538, 0.6, true, null],
  ['1F42A', 'dromedary_camel', ['dromedary_camel'], 'Animals & Nature', 566, 1, true, null],
  ['1F42B', 'camel', ['camel'], 'Animals & Nature', 567, 0.6, true, null],
  ['1F42C', 'dolphin', ['dolphin', 'flipper'], 'Animals & Nature', 623, 0.6, true, null],
  ['1F42D', 'mouse', ['mouse'], 'Animals & Nature', 574, 0.6, true, null],
  ['1F42E', 'cow', ['cow'], 'Animals & Nature', 555, 0.6, true, null],
  ['1F42F', 'tiger', ['tiger'], 'Animals & Nature', 546, 0.6, true, null],
  ['1F430', 'rabbit', ['rabbit'], 'Animals & Nature', 578, 0.6, true, null],
  ['1F431', 'cat', ['cat'], 'Animals & Nature', 542, 0.6, true, null],
  ['1F432', 'dragon_face', ['dragon_face'], 'Animals & Nature', 617, 0.6, true, null],
  ['1F433', 'whale', ['whale'], 'Animals & Nature', 621, 0.6, true, null],
  ['1F434', 'horse', ['horse'], 'Animals & Nature', 549, 0.6, true, null],
  ['1F435', 'monkey_face', ['monkey_face'], 'Animals & Nature', 530, 0.6, true, null],
  ['1F436', 'dog', ['dog'], 'Animals & Nature', 534, 0.6, true, null],
  ['1F437', 'pig', ['pig'], 'Animals & Nature', 559, 0.6, true, null],
  ['1F438', 'frog', ['frog'], 'Animals & Nature', 612, 0.6, true, null],
  ['1F439', 'hamster', ['hamster'], 'Animals & Nature', 577, 0.6, true, null],
  ['1F43A', 'wolf', ['wolf'], 'Animals & Nature', 539, 0.6, true, null],
  ['1F43B-200D-2744-FE0F', 'polar_bear', ['polar_bear'], 'Animals & Nature', 585, 13, true, null],
  ['1F43B', 'bear', ['bear'], 'Animals & Nature', 584, 0.6, true, null],
  ['1F43C', 'panda_face', ['panda_face'], 'Animals & Nature', 587, 0.6, true, null],
  ['1F43D', 'pig_nose', ['pig_nose'], 'Animals & Nature', 562, 0.6, true, null],
  ['1F43E', 'feet', ['feet', 'paw_prints'], 'Animals & Nature', 593, 0.6, true, null],
  ['1F43F-FE0F', 'chipmunk', ['chipmunk'], 'Animals & Nature', 580, 0.7, true, null],
  ['1F440', 'eyes', ['eyes'], 'People & Body', 218, 0.6, true, null],
  [
    '1F441-FE0F-200D-1F5E8-FE0F',
    'eye-in-speech-bubble',
    ['eye-in-speech-bubble'],
    'Smileys & Emotion',
    159,
    2,
    true,
    null,
  ],
  ['1F441-FE0F', 'eye', ['eye'], 'People & Body', 219, 0.7, true, null],
  [
    '1F442',
    'ear',
    ['ear'],
    'People & Body',
    210,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F442-1F3FB', symbol: '👂🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F442-1F3FC', symbol: '👂🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F442-1F3FD', symbol: '👂🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F442-1F3FE', symbol: '👂🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F442-1F3FF', symbol: '👂🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F443',
    'nose',
    ['nose'],
    'People & Body',
    212,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F443-1F3FB', symbol: '👃🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F443-1F3FC', symbol: '👃🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F443-1F3FD', symbol: '👃🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F443-1F3FE', symbol: '👃🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F443-1F3FF', symbol: '👃🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F444', 'lips', ['lips'], 'People & Body', 221, 0.6, true, null],
  ['1F445', 'tongue', ['tongue'], 'People & Body', 220, 0.6, true, null],
  [
    '1F446',
    'point_up_2',
    ['point_up_2'],
    'People & Body',
    184,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F446-1F3FB', symbol: '👆🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F446-1F3FC', symbol: '👆🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F446-1F3FD', symbol: '👆🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F446-1F3FE', symbol: '👆🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F446-1F3FF', symbol: '👆🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F447',
    'point_down',
    ['point_down'],
    'People & Body',
    186,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F447-1F3FB', symbol: '👇🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F447-1F3FC', symbol: '👇🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F447-1F3FD', symbol: '👇🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F447-1F3FE', symbol: '👇🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F447-1F3FF', symbol: '👇🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F448',
    'point_left',
    ['point_left'],
    'People & Body',
    182,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F448-1F3FB', symbol: '👈🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F448-1F3FC', symbol: '👈🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F448-1F3FD', symbol: '👈🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F448-1F3FE', symbol: '👈🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F448-1F3FF', symbol: '👈🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F449',
    'point_right',
    ['point_right'],
    'People & Body',
    183,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F449-1F3FB', symbol: '👉🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F449-1F3FC', symbol: '👉🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F449-1F3FD', symbol: '👉🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F449-1F3FE', symbol: '👉🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F449-1F3FF', symbol: '👉🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F44A',
    'facepunch',
    ['facepunch', 'punch'],
    'People & Body',
    192,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F44A-1F3FB', symbol: '👊🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F44A-1F3FC', symbol: '👊🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F44A-1F3FD', symbol: '👊🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F44A-1F3FE', symbol: '👊🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F44A-1F3FF', symbol: '👊🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F44B',
    'wave',
    ['wave'],
    'People & Body',
    164,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F44B-1F3FB', symbol: '👋🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F44B-1F3FC', symbol: '👋🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F44B-1F3FD', symbol: '👋🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F44B-1F3FE', symbol: '👋🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F44B-1F3FF', symbol: '👋🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F44C',
    'ok_hand',
    ['ok_hand'],
    'People & Body',
    173,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F44C-1F3FB', symbol: '👌🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F44C-1F3FC', symbol: '👌🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F44C-1F3FD', symbol: '👌🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F44C-1F3FE', symbol: '👌🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F44C-1F3FF', symbol: '👌🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F44D',
    '+1',
    ['+1', 'thumbsup'],
    'People & Body',
    189,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F44D-1F3FB', symbol: '👍🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F44D-1F3FC', symbol: '👍🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F44D-1F3FD', symbol: '👍🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F44D-1F3FE', symbol: '👍🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F44D-1F3FF', symbol: '👍🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F44E',
    '-1',
    ['-1', 'thumbsdown'],
    'People & Body',
    190,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F44E-1F3FB', symbol: '👎🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F44E-1F3FC', symbol: '👎🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F44E-1F3FD', symbol: '👎🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F44E-1F3FE', symbol: '👎🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F44E-1F3FF', symbol: '👎🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F44F',
    'clap',
    ['clap'],
    'People & Body',
    195,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F44F-1F3FB', symbol: '👏🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F44F-1F3FC', symbol: '👏🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F44F-1F3FD', symbol: '👏🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F44F-1F3FE', symbol: '👏🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F44F-1F3FF', symbol: '👏🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F450',
    'open_hands',
    ['open_hands'],
    'People & Body',
    198,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F450-1F3FB', symbol: '👐🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F450-1F3FC', symbol: '👐🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F450-1F3FD', symbol: '👐🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F450-1F3FE', symbol: '👐🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F450-1F3FF', symbol: '👐🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F451', 'crown', ['crown'], 'Objects', 1144, 0.6, true, null],
  ['1F452', 'womans_hat', ['womans_hat'], 'Objects', 1145, 0.6, true, null],
  ['1F453', 'eyeglasses', ['eyeglasses'], 'Objects', 1110, 0.6, true, null],
  ['1F454', 'necktie', ['necktie'], 'Objects', 1115, 0.6, true, null],
  ['1F455', 'shirt', ['shirt', 'tshirt'], 'Objects', 1116, 0.6, true, null],
  ['1F456', 'jeans', ['jeans'], 'Objects', 1117, 0.6, true, null],
  ['1F457', 'dress', ['dress'], 'Objects', 1122, 0.6, true, null],
  ['1F458', 'kimono', ['kimono'], 'Objects', 1123, 0.6, true, null],
  ['1F459', 'bikini', ['bikini'], 'Objects', 1128, 0.6, true, null],
  ['1F45A', 'womans_clothes', ['womans_clothes'], 'Objects', 1129, 0.6, true, null],
  ['1F45B', 'purse', ['purse'], 'Objects', 1130, 0.6, true, null],
  ['1F45C', 'handbag', ['handbag'], 'Objects', 1131, 0.6, true, null],
  ['1F45D', 'pouch', ['pouch'], 'Objects', 1132, 0.6, true, null],
  ['1F45E', 'mans_shoe', ['mans_shoe', 'shoe'], 'Objects', 1136, 0.6, true, null],
  ['1F45F', 'athletic_shoe', ['athletic_shoe'], 'Objects', 1137, 0.6, true, null],
  ['1F460', 'high_heel', ['high_heel'], 'Objects', 1140, 0.6, true, null],
  ['1F461', 'sandal', ['sandal'], 'Objects', 1141, 0.6, true, null],
  ['1F462', 'boot', ['boot'], 'Objects', 1143, 0.6, true, null],
  ['1F463', 'footprints', ['footprints'], 'People & Body', 524, 0.6, true, null],
  ['1F464', 'bust_in_silhouette', ['bust_in_silhouette'], 'People & Body', 521, 0.6, true, null],
  ['1F465', 'busts_in_silhouette', ['busts_in_silhouette'], 'People & Body', 522, 1, true, null],
  [
    '1F466',
    'boy',
    ['boy'],
    'People & Body',
    225,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F466-1F3FB', symbol: '👦🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F466-1F3FC', symbol: '👦🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F466-1F3FD', symbol: '👦🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F466-1F3FE', symbol: '👦🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F466-1F3FF', symbol: '👦🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F467',
    'girl',
    ['girl'],
    'People & Body',
    226,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F467-1F3FB', symbol: '👧🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F467-1F3FC', symbol: '👧🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F467-1F3FD', symbol: '👧🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F467-1F3FE', symbol: '👧🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F467-1F3FF', symbol: '👧🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F468-200D-1F33E',
    'male-farmer',
    ['male-farmer'],
    'People & Body',
    294,
    4,
    true,
    {
      '1F3FB': { unified: '1F468-1F3FB-200D-1F33E', symbol: '👨🏻‍🌾', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F468-1F3FC-200D-1F33E', symbol: '👨🏼‍🌾', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F468-1F3FD-200D-1F33E', symbol: '👨🏽‍🌾', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F468-1F3FE-200D-1F33E', symbol: '👨🏾‍🌾', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F468-1F3FF-200D-1F33E', symbol: '👨🏿‍🌾', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F468-200D-1F373',
    'male-cook',
    ['male-cook'],
    'People & Body',
    297,
    4,
    true,
    {
      '1F3FB': { unified: '1F468-1F3FB-200D-1F373', symbol: '👨🏻‍🍳', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F468-1F3FC-200D-1F373', symbol: '👨🏼‍🍳', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F468-1F3FD-200D-1F373', symbol: '👨🏽‍🍳', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F468-1F3FE-200D-1F373', symbol: '👨🏾‍🍳', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F468-1F3FF-200D-1F373', symbol: '👨🏿‍🍳', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F468-200D-1F37C',
    'man_feeding_baby',
    ['man_feeding_baby'],
    'People & Body',
    361,
    13,
    true,
    {
      '1F3FB': {
        unified: '1F468-1F3FB-200D-1F37C',
        symbol: '👨🏻‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F468-1F3FC-200D-1F37C',
        symbol: '👨🏼‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F468-1F3FD-200D-1F37C',
        symbol: '👨🏽‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F468-1F3FE-200D-1F37C',
        symbol: '👨🏾‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F468-1F3FF-200D-1F37C',
        symbol: '👨🏿‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F468-200D-1F393',
    'male-student',
    ['male-student'],
    'People & Body',
    285,
    4,
    true,
    {
      '1F3FB': { unified: '1F468-1F3FB-200D-1F393', symbol: '👨🏻‍🎓', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F468-1F3FC-200D-1F393', symbol: '👨🏼‍🎓', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F468-1F3FD-200D-1F393', symbol: '👨🏽‍🎓', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F468-1F3FE-200D-1F393', symbol: '👨🏾‍🎓', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F468-1F3FF-200D-1F393', symbol: '👨🏿‍🎓', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F468-200D-1F3A4',
    'male-singer',
    ['male-singer'],
    'People & Body',
    315,
    4,
    true,
    {
      '1F3FB': { unified: '1F468-1F3FB-200D-1F3A4', symbol: '👨🏻‍🎤', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F468-1F3FC-200D-1F3A4', symbol: '👨🏼‍🎤', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F468-1F3FD-200D-1F3A4', symbol: '👨🏽‍🎤', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F468-1F3FE-200D-1F3A4', symbol: '👨🏾‍🎤', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F468-1F3FF-200D-1F3A4', symbol: '👨🏿‍🎤', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F468-200D-1F3A8',
    'male-artist',
    ['male-artist'],
    'People & Body',
    318,
    4,
    true,
    {
      '1F3FB': { unified: '1F468-1F3FB-200D-1F3A8', symbol: '👨🏻‍🎨', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F468-1F3FC-200D-1F3A8', symbol: '👨🏼‍🎨', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F468-1F3FD-200D-1F3A8', symbol: '👨🏽‍🎨', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F468-1F3FE-200D-1F3A8', symbol: '👨🏾‍🎨', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F468-1F3FF-200D-1F3A8', symbol: '👨🏿‍🎨', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F468-200D-1F3EB',
    'male-teacher',
    ['male-teacher'],
    'People & Body',
    288,
    4,
    true,
    {
      '1F3FB': { unified: '1F468-1F3FB-200D-1F3EB', symbol: '👨🏻‍🏫', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F468-1F3FC-200D-1F3EB', symbol: '👨🏼‍🏫', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F468-1F3FD-200D-1F3EB', symbol: '👨🏽‍🏫', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F468-1F3FE-200D-1F3EB', symbol: '👨🏾‍🏫', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F468-1F3FF-200D-1F3EB', symbol: '👨🏿‍🏫', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F468-200D-1F3ED',
    'male-factory-worker',
    ['male-factory-worker'],
    'People & Body',
    303,
    4,
    true,
    {
      '1F3FB': { unified: '1F468-1F3FB-200D-1F3ED', symbol: '👨🏻‍🏭', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F468-1F3FC-200D-1F3ED', symbol: '👨🏼‍🏭', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F468-1F3FD-200D-1F3ED', symbol: '👨🏽‍🏭', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F468-1F3FE-200D-1F3ED', symbol: '👨🏾‍🏭', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F468-1F3FF-200D-1F3ED', symbol: '👨🏿‍🏭', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F468-200D-1F466-200D-1F466',
    'man-boy-boy',
    ['man-boy-boy'],
    'People & Body',
    511,
    4,
    true,
    null,
  ],
  ['1F468-200D-1F466', 'man-boy', ['man-boy'], 'People & Body', 510, 4, true, null],
  [
    '1F468-200D-1F467-200D-1F466',
    'man-girl-boy',
    ['man-girl-boy'],
    'People & Body',
    513,
    4,
    true,
    null,
  ],
  [
    '1F468-200D-1F467-200D-1F467',
    'man-girl-girl',
    ['man-girl-girl'],
    'People & Body',
    514,
    4,
    true,
    null,
  ],
  ['1F468-200D-1F467', 'man-girl', ['man-girl'], 'People & Body', 512, 4, true, null],
  [
    '1F468-200D-1F468-200D-1F466',
    'man-man-boy',
    ['man-man-boy'],
    'People & Body',
    500,
    2,
    true,
    null,
  ],
  [
    '1F468-200D-1F468-200D-1F466-200D-1F466',
    'man-man-boy-boy',
    ['man-man-boy-boy'],
    'People & Body',
    503,
    2,
    true,
    null,
  ],
  [
    '1F468-200D-1F468-200D-1F467',
    'man-man-girl',
    ['man-man-girl'],
    'People & Body',
    501,
    2,
    true,
    null,
  ],
  [
    '1F468-200D-1F468-200D-1F467-200D-1F466',
    'man-man-girl-boy',
    ['man-man-girl-boy'],
    'People & Body',
    502,
    2,
    true,
    null,
  ],
  [
    '1F468-200D-1F468-200D-1F467-200D-1F467',
    'man-man-girl-girl',
    ['man-man-girl-girl'],
    'People & Body',
    504,
    2,
    true,
    null,
  ],
  [
    '1F468-200D-1F469-200D-1F466',
    'man-woman-boy',
    ['man-woman-boy'],
    'People & Body',
    495,
    2,
    true,
    null,
  ],
  [
    '1F468-200D-1F469-200D-1F466-200D-1F466',
    'man-woman-boy-boy',
    ['man-woman-boy-boy'],
    'People & Body',
    498,
    2,
    true,
    null,
  ],
  [
    '1F468-200D-1F469-200D-1F467',
    'man-woman-girl',
    ['man-woman-girl'],
    'People & Body',
    496,
    2,
    true,
    null,
  ],
  [
    '1F468-200D-1F469-200D-1F467-200D-1F466',
    'man-woman-girl-boy',
    ['man-woman-girl-boy'],
    'People & Body',
    497,
    2,
    true,
    null,
  ],
  [
    '1F468-200D-1F469-200D-1F467-200D-1F467',
    'man-woman-girl-girl',
    ['man-woman-girl-girl'],
    'People & Body',
    499,
    2,
    true,
    null,
  ],
  [
    '1F468-200D-1F4BB',
    'male-technologist',
    ['male-technologist'],
    'People & Body',
    312,
    4,
    true,
    {
      '1F3FB': { unified: '1F468-1F3FB-200D-1F4BB', symbol: '👨🏻‍💻', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F468-1F3FC-200D-1F4BB', symbol: '👨🏼‍💻', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F468-1F3FD-200D-1F4BB', symbol: '👨🏽‍💻', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F468-1F3FE-200D-1F4BB', symbol: '👨🏾‍💻', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F468-1F3FF-200D-1F4BB', symbol: '👨🏿‍💻', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F468-200D-1F4BC',
    'male-office-worker',
    ['male-office-worker'],
    'People & Body',
    306,
    4,
    true,
    {
      '1F3FB': { unified: '1F468-1F3FB-200D-1F4BC', symbol: '👨🏻‍💼', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F468-1F3FC-200D-1F4BC', symbol: '👨🏼‍💼', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F468-1F3FD-200D-1F4BC', symbol: '👨🏽‍💼', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F468-1F3FE-200D-1F4BC', symbol: '👨🏾‍💼', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F468-1F3FF-200D-1F4BC', symbol: '👨🏿‍💼', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F468-200D-1F527',
    'male-mechanic',
    ['male-mechanic'],
    'People & Body',
    300,
    4,
    true,
    {
      '1F3FB': { unified: '1F468-1F3FB-200D-1F527', symbol: '👨🏻‍🔧', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F468-1F3FC-200D-1F527', symbol: '👨🏼‍🔧', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F468-1F3FD-200D-1F527', symbol: '👨🏽‍🔧', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F468-1F3FE-200D-1F527', symbol: '👨🏾‍🔧', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F468-1F3FF-200D-1F527', symbol: '👨🏿‍🔧', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F468-200D-1F52C',
    'male-scientist',
    ['male-scientist'],
    'People & Body',
    309,
    4,
    true,
    {
      '1F3FB': { unified: '1F468-1F3FB-200D-1F52C', symbol: '👨🏻‍🔬', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F468-1F3FC-200D-1F52C', symbol: '👨🏼‍🔬', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F468-1F3FD-200D-1F52C', symbol: '👨🏽‍🔬', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F468-1F3FE-200D-1F52C', symbol: '👨🏾‍🔬', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F468-1F3FF-200D-1F52C', symbol: '👨🏿‍🔬', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F468-200D-1F680',
    'male-astronaut',
    ['male-astronaut'],
    'People & Body',
    324,
    4,
    true,
    {
      '1F3FB': { unified: '1F468-1F3FB-200D-1F680', symbol: '👨🏻‍🚀', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F468-1F3FC-200D-1F680', symbol: '👨🏼‍🚀', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F468-1F3FD-200D-1F680', symbol: '👨🏽‍🚀', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F468-1F3FE-200D-1F680', symbol: '👨🏾‍🚀', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F468-1F3FF-200D-1F680', symbol: '👨🏿‍🚀', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F468-200D-1F692',
    'male-firefighter',
    ['male-firefighter'],
    'People & Body',
    327,
    4,
    true,
    {
      '1F3FB': { unified: '1F468-1F3FB-200D-1F692', symbol: '👨🏻‍🚒', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F468-1F3FC-200D-1F692', symbol: '👨🏼‍🚒', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F468-1F3FD-200D-1F692', symbol: '👨🏽‍🚒', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F468-1F3FE-200D-1F692', symbol: '👨🏾‍🚒', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F468-1F3FF-200D-1F692', symbol: '👨🏿‍🚒', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F468-200D-1F9AF',
    'man_with_probing_cane',
    ['man_with_probing_cane'],
    'People & Body',
    411,
    12,
    true,
    {
      '1F3FB': {
        unified: '1F468-1F3FB-200D-1F9AF',
        symbol: '👨🏻‍🦯',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F468-1F3FC-200D-1F9AF',
        symbol: '👨🏼‍🦯',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F468-1F3FD-200D-1F9AF',
        symbol: '👨🏽‍🦯',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F468-1F3FE-200D-1F9AF',
        symbol: '👨🏾‍🦯',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F468-1F3FF-200D-1F9AF',
        symbol: '👨🏿‍🦯',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F468-200D-1F9B0',
    'red_haired_man',
    ['red_haired_man'],
    'People & Body',
    233,
    11,
    true,
    {
      '1F3FB': {
        unified: '1F468-1F3FB-200D-1F9B0',
        symbol: '👨🏻‍🦰',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F468-1F3FC-200D-1F9B0',
        symbol: '👨🏼‍🦰',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F468-1F3FD-200D-1F9B0',
        symbol: '👨🏽‍🦰',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F468-1F3FE-200D-1F9B0',
        symbol: '👨🏾‍🦰',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F468-1F3FF-200D-1F9B0',
        symbol: '👨🏿‍🦰',
        addedIn: 11,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F468-200D-1F9B1',
    'curly_haired_man',
    ['curly_haired_man'],
    'People & Body',
    234,
    11,
    true,
    {
      '1F3FB': {
        unified: '1F468-1F3FB-200D-1F9B1',
        symbol: '👨🏻‍🦱',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F468-1F3FC-200D-1F9B1',
        symbol: '👨🏼‍🦱',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F468-1F3FD-200D-1F9B1',
        symbol: '👨🏽‍🦱',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F468-1F3FE-200D-1F9B1',
        symbol: '👨🏾‍🦱',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F468-1F3FF-200D-1F9B1',
        symbol: '👨🏿‍🦱',
        addedIn: 11,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F468-200D-1F9B2',
    'bald_man',
    ['bald_man'],
    'People & Body',
    236,
    11,
    true,
    {
      '1F3FB': {
        unified: '1F468-1F3FB-200D-1F9B2',
        symbol: '👨🏻‍🦲',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F468-1F3FC-200D-1F9B2',
        symbol: '👨🏼‍🦲',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F468-1F3FD-200D-1F9B2',
        symbol: '👨🏽‍🦲',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F468-1F3FE-200D-1F9B2',
        symbol: '👨🏾‍🦲',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F468-1F3FF-200D-1F9B2',
        symbol: '👨🏿‍🦲',
        addedIn: 11,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F468-200D-1F9B3',
    'white_haired_man',
    ['white_haired_man'],
    'People & Body',
    235,
    11,
    true,
    {
      '1F3FB': {
        unified: '1F468-1F3FB-200D-1F9B3',
        symbol: '👨🏻‍🦳',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F468-1F3FC-200D-1F9B3',
        symbol: '👨🏼‍🦳',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F468-1F3FD-200D-1F9B3',
        symbol: '👨🏽‍🦳',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F468-1F3FE-200D-1F9B3',
        symbol: '👨🏾‍🦳',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F468-1F3FF-200D-1F9B3',
        symbol: '👨🏿‍🦳',
        addedIn: 11,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F468-200D-1F9BC',
    'man_in_motorized_wheelchair',
    ['man_in_motorized_wheelchair'],
    'People & Body',
    414,
    12,
    true,
    {
      '1F3FB': {
        unified: '1F468-1F3FB-200D-1F9BC',
        symbol: '👨🏻‍🦼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F468-1F3FC-200D-1F9BC',
        symbol: '👨🏼‍🦼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F468-1F3FD-200D-1F9BC',
        symbol: '👨🏽‍🦼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F468-1F3FE-200D-1F9BC',
        symbol: '👨🏾‍🦼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F468-1F3FF-200D-1F9BC',
        symbol: '👨🏿‍🦼',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F468-200D-1F9BD',
    'man_in_manual_wheelchair',
    ['man_in_manual_wheelchair'],
    'People & Body',
    417,
    12,
    true,
    {
      '1F3FB': {
        unified: '1F468-1F3FB-200D-1F9BD',
        symbol: '👨🏻‍🦽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F468-1F3FC-200D-1F9BD',
        symbol: '👨🏼‍🦽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F468-1F3FD-200D-1F9BD',
        symbol: '👨🏽‍🦽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F468-1F3FE-200D-1F9BD',
        symbol: '👨🏾‍🦽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F468-1F3FF-200D-1F9BD',
        symbol: '👨🏿‍🦽',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F468-200D-2695-FE0F',
    'male-doctor',
    ['male-doctor'],
    'People & Body',
    282,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F468-1F3FB-200D-2695-FE0F',
        symbol: '👨🏻‍⚕️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F468-1F3FC-200D-2695-FE0F',
        symbol: '👨🏼‍⚕️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F468-1F3FD-200D-2695-FE0F',
        symbol: '👨🏽‍⚕️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F468-1F3FE-200D-2695-FE0F',
        symbol: '👨🏾‍⚕️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F468-1F3FF-200D-2695-FE0F',
        symbol: '👨🏿‍⚕️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F468-200D-2696-FE0F',
    'male-judge',
    ['male-judge'],
    'People & Body',
    291,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F468-1F3FB-200D-2696-FE0F',
        symbol: '👨🏻‍⚖️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F468-1F3FC-200D-2696-FE0F',
        symbol: '👨🏼‍⚖️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F468-1F3FD-200D-2696-FE0F',
        symbol: '👨🏽‍⚖️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F468-1F3FE-200D-2696-FE0F',
        symbol: '👨🏾‍⚖️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F468-1F3FF-200D-2696-FE0F',
        symbol: '👨🏿‍⚖️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F468-200D-2708-FE0F',
    'male-pilot',
    ['male-pilot'],
    'People & Body',
    321,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F468-1F3FB-200D-2708-FE0F',
        symbol: '👨🏻‍✈️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F468-1F3FC-200D-2708-FE0F',
        symbol: '👨🏼‍✈️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F468-1F3FD-200D-2708-FE0F',
        symbol: '👨🏽‍✈️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F468-1F3FE-200D-2708-FE0F',
        symbol: '👨🏾‍✈️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F468-1F3FF-200D-2708-FE0F',
        symbol: '👨🏿‍✈️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F468-200D-2764-FE0F-200D-1F468',
    'man-heart-man',
    ['man-heart-man'],
    'People & Body',
    492,
    2,
    true,
    {
      '1F3FB-1F3FB': {
        unified: '1F468-1F3FB-200D-2764-FE0F-200D-1F468-1F3FB',
        symbol: '👨🏻‍❤️‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FC': {
        unified: '1F468-1F3FB-200D-2764-FE0F-200D-1F468-1F3FC',
        symbol: '👨🏻‍❤️‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FD': {
        unified: '1F468-1F3FB-200D-2764-FE0F-200D-1F468-1F3FD',
        symbol: '👨🏻‍❤️‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FE': {
        unified: '1F468-1F3FB-200D-2764-FE0F-200D-1F468-1F3FE',
        symbol: '👨🏻‍❤️‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FF': {
        unified: '1F468-1F3FB-200D-2764-FE0F-200D-1F468-1F3FF',
        symbol: '👨🏻‍❤️‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FB': {
        unified: '1F468-1F3FC-200D-2764-FE0F-200D-1F468-1F3FB',
        symbol: '👨🏼‍❤️‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FC': {
        unified: '1F468-1F3FC-200D-2764-FE0F-200D-1F468-1F3FC',
        symbol: '👨🏼‍❤️‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FD': {
        unified: '1F468-1F3FC-200D-2764-FE0F-200D-1F468-1F3FD',
        symbol: '👨🏼‍❤️‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FE': {
        unified: '1F468-1F3FC-200D-2764-FE0F-200D-1F468-1F3FE',
        symbol: '👨🏼‍❤️‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FF': {
        unified: '1F468-1F3FC-200D-2764-FE0F-200D-1F468-1F3FF',
        symbol: '👨🏼‍❤️‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FB': {
        unified: '1F468-1F3FD-200D-2764-FE0F-200D-1F468-1F3FB',
        symbol: '👨🏽‍❤️‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FC': {
        unified: '1F468-1F3FD-200D-2764-FE0F-200D-1F468-1F3FC',
        symbol: '👨🏽‍❤️‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FD': {
        unified: '1F468-1F3FD-200D-2764-FE0F-200D-1F468-1F3FD',
        symbol: '👨🏽‍❤️‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FE': {
        unified: '1F468-1F3FD-200D-2764-FE0F-200D-1F468-1F3FE',
        symbol: '👨🏽‍❤️‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FF': {
        unified: '1F468-1F3FD-200D-2764-FE0F-200D-1F468-1F3FF',
        symbol: '👨🏽‍❤️‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FB': {
        unified: '1F468-1F3FE-200D-2764-FE0F-200D-1F468-1F3FB',
        symbol: '👨🏾‍❤️‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FC': {
        unified: '1F468-1F3FE-200D-2764-FE0F-200D-1F468-1F3FC',
        symbol: '👨🏾‍❤️‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FD': {
        unified: '1F468-1F3FE-200D-2764-FE0F-200D-1F468-1F3FD',
        symbol: '👨🏾‍❤️‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FE': {
        unified: '1F468-1F3FE-200D-2764-FE0F-200D-1F468-1F3FE',
        symbol: '👨🏾‍❤️‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FF': {
        unified: '1F468-1F3FE-200D-2764-FE0F-200D-1F468-1F3FF',
        symbol: '👨🏾‍❤️‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FB': {
        unified: '1F468-1F3FF-200D-2764-FE0F-200D-1F468-1F3FB',
        symbol: '👨🏿‍❤️‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FC': {
        unified: '1F468-1F3FF-200D-2764-FE0F-200D-1F468-1F3FC',
        symbol: '👨🏿‍❤️‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FD': {
        unified: '1F468-1F3FF-200D-2764-FE0F-200D-1F468-1F3FD',
        symbol: '👨🏿‍❤️‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FE': {
        unified: '1F468-1F3FF-200D-2764-FE0F-200D-1F468-1F3FE',
        symbol: '👨🏿‍❤️‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FF': {
        unified: '1F468-1F3FF-200D-2764-FE0F-200D-1F468-1F3FF',
        symbol: '👨🏿‍❤️‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F468-200D-2764-FE0F-200D-1F48B-200D-1F468',
    'man-kiss-man',
    ['man-kiss-man'],
    'People & Body',
    488,
    2,
    true,
    {
      '1F3FB-1F3FB': {
        unified: '1F468-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FB',
        symbol: '👨🏻‍❤️‍💋‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FC': {
        unified: '1F468-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FC',
        symbol: '👨🏻‍❤️‍💋‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FD': {
        unified: '1F468-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FD',
        symbol: '👨🏻‍❤️‍💋‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FE': {
        unified: '1F468-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FE',
        symbol: '👨🏻‍❤️‍💋‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FF': {
        unified: '1F468-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FF',
        symbol: '👨🏻‍❤️‍💋‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FB': {
        unified: '1F468-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FB',
        symbol: '👨🏼‍❤️‍💋‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FC': {
        unified: '1F468-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FC',
        symbol: '👨🏼‍❤️‍💋‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FD': {
        unified: '1F468-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FD',
        symbol: '👨🏼‍❤️‍💋‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FE': {
        unified: '1F468-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FE',
        symbol: '👨🏼‍❤️‍💋‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FF': {
        unified: '1F468-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FF',
        symbol: '👨🏼‍❤️‍💋‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FB': {
        unified: '1F468-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FB',
        symbol: '👨🏽‍❤️‍💋‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FC': {
        unified: '1F468-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FC',
        symbol: '👨🏽‍❤️‍💋‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FD': {
        unified: '1F468-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FD',
        symbol: '👨🏽‍❤️‍💋‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FE': {
        unified: '1F468-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FE',
        symbol: '👨🏽‍❤️‍💋‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FF': {
        unified: '1F468-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FF',
        symbol: '👨🏽‍❤️‍💋‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FB': {
        unified: '1F468-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FB',
        symbol: '👨🏾‍❤️‍💋‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FC': {
        unified: '1F468-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FC',
        symbol: '👨🏾‍❤️‍💋‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FD': {
        unified: '1F468-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FD',
        symbol: '👨🏾‍❤️‍💋‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FE': {
        unified: '1F468-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FE',
        symbol: '👨🏾‍❤️‍💋‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FF': {
        unified: '1F468-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FF',
        symbol: '👨🏾‍❤️‍💋‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FB': {
        unified: '1F468-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FB',
        symbol: '👨🏿‍❤️‍💋‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FC': {
        unified: '1F468-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FC',
        symbol: '👨🏿‍❤️‍💋‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FD': {
        unified: '1F468-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FD',
        symbol: '👨🏿‍❤️‍💋‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FE': {
        unified: '1F468-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FE',
        symbol: '👨🏿‍❤️‍💋‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FF': {
        unified: '1F468-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FF',
        symbol: '👨🏿‍❤️‍💋‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F468',
    'man',
    ['man'],
    'People & Body',
    229,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F468-1F3FB', symbol: '👨🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F468-1F3FC', symbol: '👨🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F468-1F3FD', symbol: '👨🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F468-1F3FE', symbol: '👨🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F468-1F3FF', symbol: '👨🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F469-200D-1F33E',
    'female-farmer',
    ['female-farmer'],
    'People & Body',
    295,
    4,
    true,
    {
      '1F3FB': { unified: '1F469-1F3FB-200D-1F33E', symbol: '👩🏻‍🌾', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F469-1F3FC-200D-1F33E', symbol: '👩🏼‍🌾', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F469-1F3FD-200D-1F33E', symbol: '👩🏽‍🌾', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F469-1F3FE-200D-1F33E', symbol: '👩🏾‍🌾', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F469-1F3FF-200D-1F33E', symbol: '👩🏿‍🌾', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F469-200D-1F373',
    'female-cook',
    ['female-cook'],
    'People & Body',
    298,
    4,
    true,
    {
      '1F3FB': { unified: '1F469-1F3FB-200D-1F373', symbol: '👩🏻‍🍳', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F469-1F3FC-200D-1F373', symbol: '👩🏼‍🍳', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F469-1F3FD-200D-1F373', symbol: '👩🏽‍🍳', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F469-1F3FE-200D-1F373', symbol: '👩🏾‍🍳', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F469-1F3FF-200D-1F373', symbol: '👩🏿‍🍳', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F469-200D-1F37C',
    'woman_feeding_baby',
    ['woman_feeding_baby'],
    'People & Body',
    360,
    13,
    true,
    {
      '1F3FB': {
        unified: '1F469-1F3FB-200D-1F37C',
        symbol: '👩🏻‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F469-1F3FC-200D-1F37C',
        symbol: '👩🏼‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F469-1F3FD-200D-1F37C',
        symbol: '👩🏽‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F469-1F3FE-200D-1F37C',
        symbol: '👩🏾‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F469-1F3FF-200D-1F37C',
        symbol: '👩🏿‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469-200D-1F393',
    'female-student',
    ['female-student'],
    'People & Body',
    286,
    4,
    true,
    {
      '1F3FB': { unified: '1F469-1F3FB-200D-1F393', symbol: '👩🏻‍🎓', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F469-1F3FC-200D-1F393', symbol: '👩🏼‍🎓', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F469-1F3FD-200D-1F393', symbol: '👩🏽‍🎓', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F469-1F3FE-200D-1F393', symbol: '👩🏾‍🎓', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F469-1F3FF-200D-1F393', symbol: '👩🏿‍🎓', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F469-200D-1F3A4',
    'female-singer',
    ['female-singer'],
    'People & Body',
    316,
    4,
    true,
    {
      '1F3FB': { unified: '1F469-1F3FB-200D-1F3A4', symbol: '👩🏻‍🎤', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F469-1F3FC-200D-1F3A4', symbol: '👩🏼‍🎤', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F469-1F3FD-200D-1F3A4', symbol: '👩🏽‍🎤', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F469-1F3FE-200D-1F3A4', symbol: '👩🏾‍🎤', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F469-1F3FF-200D-1F3A4', symbol: '👩🏿‍🎤', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F469-200D-1F3A8',
    'female-artist',
    ['female-artist'],
    'People & Body',
    319,
    4,
    true,
    {
      '1F3FB': { unified: '1F469-1F3FB-200D-1F3A8', symbol: '👩🏻‍🎨', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F469-1F3FC-200D-1F3A8', symbol: '👩🏼‍🎨', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F469-1F3FD-200D-1F3A8', symbol: '👩🏽‍🎨', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F469-1F3FE-200D-1F3A8', symbol: '👩🏾‍🎨', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F469-1F3FF-200D-1F3A8', symbol: '👩🏿‍🎨', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F469-200D-1F3EB',
    'female-teacher',
    ['female-teacher'],
    'People & Body',
    289,
    4,
    true,
    {
      '1F3FB': { unified: '1F469-1F3FB-200D-1F3EB', symbol: '👩🏻‍🏫', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F469-1F3FC-200D-1F3EB', symbol: '👩🏼‍🏫', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F469-1F3FD-200D-1F3EB', symbol: '👩🏽‍🏫', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F469-1F3FE-200D-1F3EB', symbol: '👩🏾‍🏫', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F469-1F3FF-200D-1F3EB', symbol: '👩🏿‍🏫', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F469-200D-1F3ED',
    'female-factory-worker',
    ['female-factory-worker'],
    'People & Body',
    304,
    4,
    true,
    {
      '1F3FB': { unified: '1F469-1F3FB-200D-1F3ED', symbol: '👩🏻‍🏭', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F469-1F3FC-200D-1F3ED', symbol: '👩🏼‍🏭', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F469-1F3FD-200D-1F3ED', symbol: '👩🏽‍🏭', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F469-1F3FE-200D-1F3ED', symbol: '👩🏾‍🏭', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F469-1F3FF-200D-1F3ED', symbol: '👩🏿‍🏭', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F469-200D-1F466-200D-1F466',
    'woman-boy-boy',
    ['woman-boy-boy'],
    'People & Body',
    516,
    4,
    true,
    null,
  ],
  ['1F469-200D-1F466', 'woman-boy', ['woman-boy'], 'People & Body', 515, 4, true, null],
  [
    '1F469-200D-1F467-200D-1F466',
    'woman-girl-boy',
    ['woman-girl-boy'],
    'People & Body',
    518,
    4,
    true,
    null,
  ],
  [
    '1F469-200D-1F467-200D-1F467',
    'woman-girl-girl',
    ['woman-girl-girl'],
    'People & Body',
    519,
    4,
    true,
    null,
  ],
  ['1F469-200D-1F467', 'woman-girl', ['woman-girl'], 'People & Body', 517, 4, true, null],
  [
    '1F469-200D-1F469-200D-1F466',
    'woman-woman-boy',
    ['woman-woman-boy'],
    'People & Body',
    505,
    2,
    true,
    null,
  ],
  [
    '1F469-200D-1F469-200D-1F466-200D-1F466',
    'woman-woman-boy-boy',
    ['woman-woman-boy-boy'],
    'People & Body',
    508,
    2,
    true,
    null,
  ],
  [
    '1F469-200D-1F469-200D-1F467',
    'woman-woman-girl',
    ['woman-woman-girl'],
    'People & Body',
    506,
    2,
    true,
    null,
  ],
  [
    '1F469-200D-1F469-200D-1F467-200D-1F466',
    'woman-woman-girl-boy',
    ['woman-woman-girl-boy'],
    'People & Body',
    507,
    2,
    true,
    null,
  ],
  [
    '1F469-200D-1F469-200D-1F467-200D-1F467',
    'woman-woman-girl-girl',
    ['woman-woman-girl-girl'],
    'People & Body',
    509,
    2,
    true,
    null,
  ],
  [
    '1F469-200D-1F4BB',
    'female-technologist',
    ['female-technologist'],
    'People & Body',
    313,
    4,
    true,
    {
      '1F3FB': { unified: '1F469-1F3FB-200D-1F4BB', symbol: '👩🏻‍💻', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F469-1F3FC-200D-1F4BB', symbol: '👩🏼‍💻', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F469-1F3FD-200D-1F4BB', symbol: '👩🏽‍💻', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F469-1F3FE-200D-1F4BB', symbol: '👩🏾‍💻', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F469-1F3FF-200D-1F4BB', symbol: '👩🏿‍💻', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F469-200D-1F4BC',
    'female-office-worker',
    ['female-office-worker'],
    'People & Body',
    307,
    4,
    true,
    {
      '1F3FB': { unified: '1F469-1F3FB-200D-1F4BC', symbol: '👩🏻‍💼', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F469-1F3FC-200D-1F4BC', symbol: '👩🏼‍💼', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F469-1F3FD-200D-1F4BC', symbol: '👩🏽‍💼', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F469-1F3FE-200D-1F4BC', symbol: '👩🏾‍💼', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F469-1F3FF-200D-1F4BC', symbol: '👩🏿‍💼', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F469-200D-1F527',
    'female-mechanic',
    ['female-mechanic'],
    'People & Body',
    301,
    4,
    true,
    {
      '1F3FB': { unified: '1F469-1F3FB-200D-1F527', symbol: '👩🏻‍🔧', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F469-1F3FC-200D-1F527', symbol: '👩🏼‍🔧', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F469-1F3FD-200D-1F527', symbol: '👩🏽‍🔧', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F469-1F3FE-200D-1F527', symbol: '👩🏾‍🔧', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F469-1F3FF-200D-1F527', symbol: '👩🏿‍🔧', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F469-200D-1F52C',
    'female-scientist',
    ['female-scientist'],
    'People & Body',
    310,
    4,
    true,
    {
      '1F3FB': { unified: '1F469-1F3FB-200D-1F52C', symbol: '👩🏻‍🔬', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F469-1F3FC-200D-1F52C', symbol: '👩🏼‍🔬', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F469-1F3FD-200D-1F52C', symbol: '👩🏽‍🔬', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F469-1F3FE-200D-1F52C', symbol: '👩🏾‍🔬', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F469-1F3FF-200D-1F52C', symbol: '👩🏿‍🔬', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F469-200D-1F680',
    'female-astronaut',
    ['female-astronaut'],
    'People & Body',
    325,
    4,
    true,
    {
      '1F3FB': { unified: '1F469-1F3FB-200D-1F680', symbol: '👩🏻‍🚀', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F469-1F3FC-200D-1F680', symbol: '👩🏼‍🚀', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F469-1F3FD-200D-1F680', symbol: '👩🏽‍🚀', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F469-1F3FE-200D-1F680', symbol: '👩🏾‍🚀', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F469-1F3FF-200D-1F680', symbol: '👩🏿‍🚀', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F469-200D-1F692',
    'female-firefighter',
    ['female-firefighter'],
    'People & Body',
    328,
    4,
    true,
    {
      '1F3FB': { unified: '1F469-1F3FB-200D-1F692', symbol: '👩🏻‍🚒', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F469-1F3FC-200D-1F692', symbol: '👩🏼‍🚒', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F469-1F3FD-200D-1F692', symbol: '👩🏽‍🚒', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F469-1F3FE-200D-1F692', symbol: '👩🏾‍🚒', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F469-1F3FF-200D-1F692', symbol: '👩🏿‍🚒', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F469-200D-1F9AF',
    'woman_with_probing_cane',
    ['woman_with_probing_cane'],
    'People & Body',
    412,
    12,
    true,
    {
      '1F3FB': {
        unified: '1F469-1F3FB-200D-1F9AF',
        symbol: '👩🏻‍🦯',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F469-1F3FC-200D-1F9AF',
        symbol: '👩🏼‍🦯',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F469-1F3FD-200D-1F9AF',
        symbol: '👩🏽‍🦯',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F469-1F3FE-200D-1F9AF',
        symbol: '👩🏾‍🦯',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F469-1F3FF-200D-1F9AF',
        symbol: '👩🏿‍🦯',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469-200D-1F9B0',
    'red_haired_woman',
    ['red_haired_woman'],
    'People & Body',
    238,
    11,
    true,
    {
      '1F3FB': {
        unified: '1F469-1F3FB-200D-1F9B0',
        symbol: '👩🏻‍🦰',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F469-1F3FC-200D-1F9B0',
        symbol: '👩🏼‍🦰',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F469-1F3FD-200D-1F9B0',
        symbol: '👩🏽‍🦰',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F469-1F3FE-200D-1F9B0',
        symbol: '👩🏾‍🦰',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F469-1F3FF-200D-1F9B0',
        symbol: '👩🏿‍🦰',
        addedIn: 11,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469-200D-1F9B1',
    'curly_haired_woman',
    ['curly_haired_woman'],
    'People & Body',
    240,
    11,
    true,
    {
      '1F3FB': {
        unified: '1F469-1F3FB-200D-1F9B1',
        symbol: '👩🏻‍🦱',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F469-1F3FC-200D-1F9B1',
        symbol: '👩🏼‍🦱',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F469-1F3FD-200D-1F9B1',
        symbol: '👩🏽‍🦱',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F469-1F3FE-200D-1F9B1',
        symbol: '👩🏾‍🦱',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F469-1F3FF-200D-1F9B1',
        symbol: '👩🏿‍🦱',
        addedIn: 11,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469-200D-1F9B2',
    'bald_woman',
    ['bald_woman'],
    'People & Body',
    244,
    11,
    true,
    {
      '1F3FB': {
        unified: '1F469-1F3FB-200D-1F9B2',
        symbol: '👩🏻‍🦲',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F469-1F3FC-200D-1F9B2',
        symbol: '👩🏼‍🦲',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F469-1F3FD-200D-1F9B2',
        symbol: '👩🏽‍🦲',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F469-1F3FE-200D-1F9B2',
        symbol: '👩🏾‍🦲',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F469-1F3FF-200D-1F9B2',
        symbol: '👩🏿‍🦲',
        addedIn: 11,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469-200D-1F9B3',
    'white_haired_woman',
    ['white_haired_woman'],
    'People & Body',
    242,
    11,
    true,
    {
      '1F3FB': {
        unified: '1F469-1F3FB-200D-1F9B3',
        symbol: '👩🏻‍🦳',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F469-1F3FC-200D-1F9B3',
        symbol: '👩🏼‍🦳',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F469-1F3FD-200D-1F9B3',
        symbol: '👩🏽‍🦳',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F469-1F3FE-200D-1F9B3',
        symbol: '👩🏾‍🦳',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F469-1F3FF-200D-1F9B3',
        symbol: '👩🏿‍🦳',
        addedIn: 11,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469-200D-1F9BC',
    'woman_in_motorized_wheelchair',
    ['woman_in_motorized_wheelchair'],
    'People & Body',
    415,
    12,
    true,
    {
      '1F3FB': {
        unified: '1F469-1F3FB-200D-1F9BC',
        symbol: '👩🏻‍🦼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F469-1F3FC-200D-1F9BC',
        symbol: '👩🏼‍🦼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F469-1F3FD-200D-1F9BC',
        symbol: '👩🏽‍🦼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F469-1F3FE-200D-1F9BC',
        symbol: '👩🏾‍🦼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F469-1F3FF-200D-1F9BC',
        symbol: '👩🏿‍🦼',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469-200D-1F9BD',
    'woman_in_manual_wheelchair',
    ['woman_in_manual_wheelchair'],
    'People & Body',
    418,
    12,
    true,
    {
      '1F3FB': {
        unified: '1F469-1F3FB-200D-1F9BD',
        symbol: '👩🏻‍🦽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F469-1F3FC-200D-1F9BD',
        symbol: '👩🏼‍🦽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F469-1F3FD-200D-1F9BD',
        symbol: '👩🏽‍🦽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F469-1F3FE-200D-1F9BD',
        symbol: '👩🏾‍🦽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F469-1F3FF-200D-1F9BD',
        symbol: '👩🏿‍🦽',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469-200D-2695-FE0F',
    'female-doctor',
    ['female-doctor'],
    'People & Body',
    283,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F469-1F3FB-200D-2695-FE0F',
        symbol: '👩🏻‍⚕️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F469-1F3FC-200D-2695-FE0F',
        symbol: '👩🏼‍⚕️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F469-1F3FD-200D-2695-FE0F',
        symbol: '👩🏽‍⚕️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F469-1F3FE-200D-2695-FE0F',
        symbol: '👩🏾‍⚕️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F469-1F3FF-200D-2695-FE0F',
        symbol: '👩🏿‍⚕️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469-200D-2696-FE0F',
    'female-judge',
    ['female-judge'],
    'People & Body',
    292,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F469-1F3FB-200D-2696-FE0F',
        symbol: '👩🏻‍⚖️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F469-1F3FC-200D-2696-FE0F',
        symbol: '👩🏼‍⚖️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F469-1F3FD-200D-2696-FE0F',
        symbol: '👩🏽‍⚖️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F469-1F3FE-200D-2696-FE0F',
        symbol: '👩🏾‍⚖️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F469-1F3FF-200D-2696-FE0F',
        symbol: '👩🏿‍⚖️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469-200D-2708-FE0F',
    'female-pilot',
    ['female-pilot'],
    'People & Body',
    322,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F469-1F3FB-200D-2708-FE0F',
        symbol: '👩🏻‍✈️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F469-1F3FC-200D-2708-FE0F',
        symbol: '👩🏼‍✈️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F469-1F3FD-200D-2708-FE0F',
        symbol: '👩🏽‍✈️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F469-1F3FE-200D-2708-FE0F',
        symbol: '👩🏾‍✈️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F469-1F3FF-200D-2708-FE0F',
        symbol: '👩🏿‍✈️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469-200D-2764-FE0F-200D-1F468',
    'woman-heart-man',
    ['woman-heart-man'],
    'People & Body',
    491,
    2,
    true,
    {
      '1F3FB-1F3FB': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F468-1F3FB',
        symbol: '👩🏻‍❤️‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FC': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F468-1F3FC',
        symbol: '👩🏻‍❤️‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FD': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F468-1F3FD',
        symbol: '👩🏻‍❤️‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FE': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F468-1F3FE',
        symbol: '👩🏻‍❤️‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FF': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F468-1F3FF',
        symbol: '👩🏻‍❤️‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FB': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F468-1F3FB',
        symbol: '👩🏼‍❤️‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FC': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F468-1F3FC',
        symbol: '👩🏼‍❤️‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FD': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F468-1F3FD',
        symbol: '👩🏼‍❤️‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FE': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F468-1F3FE',
        symbol: '👩🏼‍❤️‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FF': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F468-1F3FF',
        symbol: '👩🏼‍❤️‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FB': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F468-1F3FB',
        symbol: '👩🏽‍❤️‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FC': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F468-1F3FC',
        symbol: '👩🏽‍❤️‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FD': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F468-1F3FD',
        symbol: '👩🏽‍❤️‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FE': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F468-1F3FE',
        symbol: '👩🏽‍❤️‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FF': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F468-1F3FF',
        symbol: '👩🏽‍❤️‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FB': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F468-1F3FB',
        symbol: '👩🏾‍❤️‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FC': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F468-1F3FC',
        symbol: '👩🏾‍❤️‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FD': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F468-1F3FD',
        symbol: '👩🏾‍❤️‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FE': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F468-1F3FE',
        symbol: '👩🏾‍❤️‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FF': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F468-1F3FF',
        symbol: '👩🏾‍❤️‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FB': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F468-1F3FB',
        symbol: '👩🏿‍❤️‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FC': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F468-1F3FC',
        symbol: '👩🏿‍❤️‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FD': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F468-1F3FD',
        symbol: '👩🏿‍❤️‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FE': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F468-1F3FE',
        symbol: '👩🏿‍❤️‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FF': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F468-1F3FF',
        symbol: '👩🏿‍❤️‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469-200D-2764-FE0F-200D-1F469',
    'woman-heart-woman',
    ['woman-heart-woman'],
    'People & Body',
    493,
    2,
    true,
    {
      '1F3FB-1F3FB': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F469-1F3FB',
        symbol: '👩🏻‍❤️‍👩🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FC': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F469-1F3FC',
        symbol: '👩🏻‍❤️‍👩🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FD': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F469-1F3FD',
        symbol: '👩🏻‍❤️‍👩🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FE': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F469-1F3FE',
        symbol: '👩🏻‍❤️‍👩🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FF': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F469-1F3FF',
        symbol: '👩🏻‍❤️‍👩🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FB': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F469-1F3FB',
        symbol: '👩🏼‍❤️‍👩🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FC': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F469-1F3FC',
        symbol: '👩🏼‍❤️‍👩🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FD': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F469-1F3FD',
        symbol: '👩🏼‍❤️‍👩🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FE': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F469-1F3FE',
        symbol: '👩🏼‍❤️‍👩🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FF': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F469-1F3FF',
        symbol: '👩🏼‍❤️‍👩🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FB': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F469-1F3FB',
        symbol: '👩🏽‍❤️‍👩🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FC': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F469-1F3FC',
        symbol: '👩🏽‍❤️‍👩🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FD': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F469-1F3FD',
        symbol: '👩🏽‍❤️‍👩🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FE': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F469-1F3FE',
        symbol: '👩🏽‍❤️‍👩🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FF': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F469-1F3FF',
        symbol: '👩🏽‍❤️‍👩🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FB': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F469-1F3FB',
        symbol: '👩🏾‍❤️‍👩🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FC': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F469-1F3FC',
        symbol: '👩🏾‍❤️‍👩🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FD': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F469-1F3FD',
        symbol: '👩🏾‍❤️‍👩🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FE': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F469-1F3FE',
        symbol: '👩🏾‍❤️‍👩🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FF': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F469-1F3FF',
        symbol: '👩🏾‍❤️‍👩🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FB': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F469-1F3FB',
        symbol: '👩🏿‍❤️‍👩🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FC': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F469-1F3FC',
        symbol: '👩🏿‍❤️‍👩🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FD': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F469-1F3FD',
        symbol: '👩🏿‍❤️‍👩🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FE': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F469-1F3FE',
        symbol: '👩🏿‍❤️‍👩🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FF': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F469-1F3FF',
        symbol: '👩🏿‍❤️‍👩🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469-200D-2764-FE0F-200D-1F48B-200D-1F468',
    'woman-kiss-man',
    ['woman-kiss-man'],
    'People & Body',
    487,
    2,
    true,
    {
      '1F3FB-1F3FB': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FB',
        symbol: '👩🏻‍❤️‍💋‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FC': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FC',
        symbol: '👩🏻‍❤️‍💋‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FD': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FD',
        symbol: '👩🏻‍❤️‍💋‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FE': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FE',
        symbol: '👩🏻‍❤️‍💋‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FF': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FF',
        symbol: '👩🏻‍❤️‍💋‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FB': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FB',
        symbol: '👩🏼‍❤️‍💋‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FC': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FC',
        symbol: '👩🏼‍❤️‍💋‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FD': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FD',
        symbol: '👩🏼‍❤️‍💋‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FE': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FE',
        symbol: '👩🏼‍❤️‍💋‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FF': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FF',
        symbol: '👩🏼‍❤️‍💋‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FB': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FB',
        symbol: '👩🏽‍❤️‍💋‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FC': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FC',
        symbol: '👩🏽‍❤️‍💋‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FD': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FD',
        symbol: '👩🏽‍❤️‍💋‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FE': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FE',
        symbol: '👩🏽‍❤️‍💋‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FF': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FF',
        symbol: '👩🏽‍❤️‍💋‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FB': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FB',
        symbol: '👩🏾‍❤️‍💋‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FC': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FC',
        symbol: '👩🏾‍❤️‍💋‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FD': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FD',
        symbol: '👩🏾‍❤️‍💋‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FE': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FE',
        symbol: '👩🏾‍❤️‍💋‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FF': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FF',
        symbol: '👩🏾‍❤️‍💋‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FB': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FB',
        symbol: '👩🏿‍❤️‍💋‍👨🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FC': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FC',
        symbol: '👩🏿‍❤️‍💋‍👨🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FD': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FD',
        symbol: '👩🏿‍❤️‍💋‍👨🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FE': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FE',
        symbol: '👩🏿‍❤️‍💋‍👨🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FF': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F468-1F3FF',
        symbol: '👩🏿‍❤️‍💋‍👨🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469-200D-2764-FE0F-200D-1F48B-200D-1F469',
    'woman-kiss-woman',
    ['woman-kiss-woman'],
    'People & Body',
    489,
    2,
    true,
    {
      '1F3FB-1F3FB': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FB',
        symbol: '👩🏻‍❤️‍💋‍👩🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FC': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FC',
        symbol: '👩🏻‍❤️‍💋‍👩🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FD': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FD',
        symbol: '👩🏻‍❤️‍💋‍👩🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FE': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FE',
        symbol: '👩🏻‍❤️‍💋‍👩🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FF': {
        unified: '1F469-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FF',
        symbol: '👩🏻‍❤️‍💋‍👩🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FB': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FB',
        symbol: '👩🏼‍❤️‍💋‍👩🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FC': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FC',
        symbol: '👩🏼‍❤️‍💋‍👩🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FD': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FD',
        symbol: '👩🏼‍❤️‍💋‍👩🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FE': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FE',
        symbol: '👩🏼‍❤️‍💋‍👩🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FF': {
        unified: '1F469-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FF',
        symbol: '👩🏼‍❤️‍💋‍👩🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FB': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FB',
        symbol: '👩🏽‍❤️‍💋‍👩🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FC': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FC',
        symbol: '👩🏽‍❤️‍💋‍👩🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FD': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FD',
        symbol: '👩🏽‍❤️‍💋‍👩🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FE': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FE',
        symbol: '👩🏽‍❤️‍💋‍👩🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FF': {
        unified: '1F469-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FF',
        symbol: '👩🏽‍❤️‍💋‍👩🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FB': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FB',
        symbol: '👩🏾‍❤️‍💋‍👩🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FC': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FC',
        symbol: '👩🏾‍❤️‍💋‍👩🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FD': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FD',
        symbol: '👩🏾‍❤️‍💋‍👩🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FE': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FE',
        symbol: '👩🏾‍❤️‍💋‍👩🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FF': {
        unified: '1F469-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FF',
        symbol: '👩🏾‍❤️‍💋‍👩🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FB': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FB',
        symbol: '👩🏿‍❤️‍💋‍👩🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FC': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FC',
        symbol: '👩🏿‍❤️‍💋‍👩🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FD': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FD',
        symbol: '👩🏿‍❤️‍💋‍👩🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FE': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FE',
        symbol: '👩🏿‍❤️‍💋‍👩🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FF': {
        unified: '1F469-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F469-1F3FF',
        symbol: '👩🏿‍❤️‍💋‍👩🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F469',
    'woman',
    ['woman'],
    'People & Body',
    237,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F469-1F3FB', symbol: '👩🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F469-1F3FC', symbol: '👩🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F469-1F3FD', symbol: '👩🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F469-1F3FE', symbol: '👩🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F469-1F3FF', symbol: '👩🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F46A', 'family', ['family'], 'People & Body', 494, 0.6, true, null],
  [
    '1F46B',
    'man_and_woman_holding_hands',
    ['man_and_woman_holding_hands', 'woman_and_man_holding_hands', 'couple'],
    'People & Body',
    484,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F46B-1F3FB', symbol: '👫🏻', addedIn: 12, hasImgTwitter: true },
      '1F3FC': { unified: '1F46B-1F3FC', symbol: '👫🏼', addedIn: 12, hasImgTwitter: true },
      '1F3FD': { unified: '1F46B-1F3FD', symbol: '👫🏽', addedIn: 12, hasImgTwitter: true },
      '1F3FE': { unified: '1F46B-1F3FE', symbol: '👫🏾', addedIn: 12, hasImgTwitter: true },
      '1F3FF': { unified: '1F46B-1F3FF', symbol: '👫🏿', addedIn: 12, hasImgTwitter: true },
      '1F3FB-1F3FC': {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F468-1F3FC',
        symbol: '👩🏻‍🤝‍👨🏼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FD': {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F468-1F3FD',
        symbol: '👩🏻‍🤝‍👨🏽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FE': {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F468-1F3FE',
        symbol: '👩🏻‍🤝‍👨🏾',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FF': {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F468-1F3FF',
        symbol: '👩🏻‍🤝‍👨🏿',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FB': {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F468-1F3FB',
        symbol: '👩🏼‍🤝‍👨🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FD': {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F468-1F3FD',
        symbol: '👩🏼‍🤝‍👨🏽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FE': {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F468-1F3FE',
        symbol: '👩🏼‍🤝‍👨🏾',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FF': {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F468-1F3FF',
        symbol: '👩🏼‍🤝‍👨🏿',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FB': {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F468-1F3FB',
        symbol: '👩🏽‍🤝‍👨🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FC': {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F468-1F3FC',
        symbol: '👩🏽‍🤝‍👨🏼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FE': {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F468-1F3FE',
        symbol: '👩🏽‍🤝‍👨🏾',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FF': {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F468-1F3FF',
        symbol: '👩🏽‍🤝‍👨🏿',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FB': {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F468-1F3FB',
        symbol: '👩🏾‍🤝‍👨🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FC': {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F468-1F3FC',
        symbol: '👩🏾‍🤝‍👨🏼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FD': {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F468-1F3FD',
        symbol: '👩🏾‍🤝‍👨🏽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FF': {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F468-1F3FF',
        symbol: '👩🏾‍🤝‍👨🏿',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FB': {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F468-1F3FB',
        symbol: '👩🏿‍🤝‍👨🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FC': {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F468-1F3FC',
        symbol: '👩🏿‍🤝‍👨🏼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FD': {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F468-1F3FD',
        symbol: '👩🏿‍🤝‍👨🏽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FE': {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F468-1F3FE',
        symbol: '👩🏿‍🤝‍👨🏾',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F46C',
    'two_men_holding_hands',
    ['two_men_holding_hands', 'men_holding_hands'],
    'People & Body',
    485,
    1,
    true,
    {
      '1F3FB': { unified: '1F46C-1F3FB', symbol: '👬🏻', addedIn: 12, hasImgTwitter: true },
      '1F3FC': { unified: '1F46C-1F3FC', symbol: '👬🏼', addedIn: 12, hasImgTwitter: true },
      '1F3FD': { unified: '1F46C-1F3FD', symbol: '👬🏽', addedIn: 12, hasImgTwitter: true },
      '1F3FE': { unified: '1F46C-1F3FE', symbol: '👬🏾', addedIn: 12, hasImgTwitter: true },
      '1F3FF': { unified: '1F46C-1F3FF', symbol: '👬🏿', addedIn: 12, hasImgTwitter: true },
      '1F3FB-1F3FC': {
        unified: '1F468-1F3FB-200D-1F91D-200D-1F468-1F3FC',
        symbol: '👨🏻‍🤝‍👨🏼',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FD': {
        unified: '1F468-1F3FB-200D-1F91D-200D-1F468-1F3FD',
        symbol: '👨🏻‍🤝‍👨🏽',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FE': {
        unified: '1F468-1F3FB-200D-1F91D-200D-1F468-1F3FE',
        symbol: '👨🏻‍🤝‍👨🏾',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FF': {
        unified: '1F468-1F3FB-200D-1F91D-200D-1F468-1F3FF',
        symbol: '👨🏻‍🤝‍👨🏿',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FB': {
        unified: '1F468-1F3FC-200D-1F91D-200D-1F468-1F3FB',
        symbol: '👨🏼‍🤝‍👨🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FD': {
        unified: '1F468-1F3FC-200D-1F91D-200D-1F468-1F3FD',
        symbol: '👨🏼‍🤝‍👨🏽',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FE': {
        unified: '1F468-1F3FC-200D-1F91D-200D-1F468-1F3FE',
        symbol: '👨🏼‍🤝‍👨🏾',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FF': {
        unified: '1F468-1F3FC-200D-1F91D-200D-1F468-1F3FF',
        symbol: '👨🏼‍🤝‍👨🏿',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FB': {
        unified: '1F468-1F3FD-200D-1F91D-200D-1F468-1F3FB',
        symbol: '👨🏽‍🤝‍👨🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FC': {
        unified: '1F468-1F3FD-200D-1F91D-200D-1F468-1F3FC',
        symbol: '👨🏽‍🤝‍👨🏼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FE': {
        unified: '1F468-1F3FD-200D-1F91D-200D-1F468-1F3FE',
        symbol: '👨🏽‍🤝‍👨🏾',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FF': {
        unified: '1F468-1F3FD-200D-1F91D-200D-1F468-1F3FF',
        symbol: '👨🏽‍🤝‍👨🏿',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FB': {
        unified: '1F468-1F3FE-200D-1F91D-200D-1F468-1F3FB',
        symbol: '👨🏾‍🤝‍👨🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FC': {
        unified: '1F468-1F3FE-200D-1F91D-200D-1F468-1F3FC',
        symbol: '👨🏾‍🤝‍👨🏼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FD': {
        unified: '1F468-1F3FE-200D-1F91D-200D-1F468-1F3FD',
        symbol: '👨🏾‍🤝‍👨🏽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FF': {
        unified: '1F468-1F3FE-200D-1F91D-200D-1F468-1F3FF',
        symbol: '👨🏾‍🤝‍👨🏿',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FB': {
        unified: '1F468-1F3FF-200D-1F91D-200D-1F468-1F3FB',
        symbol: '👨🏿‍🤝‍👨🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FC': {
        unified: '1F468-1F3FF-200D-1F91D-200D-1F468-1F3FC',
        symbol: '👨🏿‍🤝‍👨🏼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FD': {
        unified: '1F468-1F3FF-200D-1F91D-200D-1F468-1F3FD',
        symbol: '👨🏿‍🤝‍👨🏽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FE': {
        unified: '1F468-1F3FF-200D-1F91D-200D-1F468-1F3FE',
        symbol: '👨🏿‍🤝‍👨🏾',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F46D',
    'two_women_holding_hands',
    ['two_women_holding_hands', 'women_holding_hands'],
    'People & Body',
    483,
    1,
    true,
    {
      '1F3FB': { unified: '1F46D-1F3FB', symbol: '👭🏻', addedIn: 12, hasImgTwitter: true },
      '1F3FC': { unified: '1F46D-1F3FC', symbol: '👭🏼', addedIn: 12, hasImgTwitter: true },
      '1F3FD': { unified: '1F46D-1F3FD', symbol: '👭🏽', addedIn: 12, hasImgTwitter: true },
      '1F3FE': { unified: '1F46D-1F3FE', symbol: '👭🏾', addedIn: 12, hasImgTwitter: true },
      '1F3FF': { unified: '1F46D-1F3FF', symbol: '👭🏿', addedIn: 12, hasImgTwitter: true },
      '1F3FB-1F3FC': {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F469-1F3FC',
        symbol: '👩🏻‍🤝‍👩🏼',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FD': {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F469-1F3FD',
        symbol: '👩🏻‍🤝‍👩🏽',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FE': {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F469-1F3FE',
        symbol: '👩🏻‍🤝‍👩🏾',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FF': {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F469-1F3FF',
        symbol: '👩🏻‍🤝‍👩🏿',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FB': {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F469-1F3FB',
        symbol: '👩🏼‍🤝‍👩🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FD': {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F469-1F3FD',
        symbol: '👩🏼‍🤝‍👩🏽',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FE': {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F469-1F3FE',
        symbol: '👩🏼‍🤝‍👩🏾',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FF': {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F469-1F3FF',
        symbol: '👩🏼‍🤝‍👩🏿',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FB': {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F469-1F3FB',
        symbol: '👩🏽‍🤝‍👩🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FC': {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F469-1F3FC',
        symbol: '👩🏽‍🤝‍👩🏼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FE': {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F469-1F3FE',
        symbol: '👩🏽‍🤝‍👩🏾',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FF': {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F469-1F3FF',
        symbol: '👩🏽‍🤝‍👩🏿',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FB': {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F469-1F3FB',
        symbol: '👩🏾‍🤝‍👩🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FC': {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F469-1F3FC',
        symbol: '👩🏾‍🤝‍👩🏼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FD': {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F469-1F3FD',
        symbol: '👩🏾‍🤝‍👩🏽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FF': {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F469-1F3FF',
        symbol: '👩🏾‍🤝‍👩🏿',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FB': {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F469-1F3FB',
        symbol: '👩🏿‍🤝‍👩🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FC': {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F469-1F3FC',
        symbol: '👩🏿‍🤝‍👩🏼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FD': {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F469-1F3FD',
        symbol: '👩🏿‍🤝‍👩🏽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FE': {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F469-1F3FE',
        symbol: '👩🏿‍🤝‍👩🏾',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F46E-200D-2640-FE0F',
    'female-police-officer',
    ['female-police-officer'],
    'People & Body',
    331,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F46E-1F3FB-200D-2640-FE0F',
        symbol: '👮🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F46E-1F3FC-200D-2640-FE0F',
        symbol: '👮🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F46E-1F3FD-200D-2640-FE0F',
        symbol: '👮🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F46E-1F3FE-200D-2640-FE0F',
        symbol: '👮🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F46E-1F3FF-200D-2640-FE0F',
        symbol: '👮🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F46E-200D-2642-FE0F',
    'male-police-officer',
    ['male-police-officer'],
    'People & Body',
    330,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F46E-1F3FB-200D-2642-FE0F',
        symbol: '👮🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F46E-1F3FC-200D-2642-FE0F',
        symbol: '👮🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F46E-1F3FD-200D-2642-FE0F',
        symbol: '👮🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F46E-1F3FE-200D-2642-FE0F',
        symbol: '👮🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F46E-1F3FF-200D-2642-FE0F',
        symbol: '👮🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F46E',
    'cop',
    ['cop'],
    'People & Body',
    329,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F46E-1F3FB', symbol: '👮🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F46E-1F3FC', symbol: '👮🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F46E-1F3FD', symbol: '👮🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F46E-1F3FE', symbol: '👮🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F46E-1F3FF', symbol: '👮🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F46F-200D-2640-FE0F',
    'women-with-bunny-ears-partying',
    ['women-with-bunny-ears-partying', 'woman-with-bunny-ears-partying'],
    'People & Body',
    427,
    4,
    true,
    null,
  ],
  [
    '1F46F-200D-2642-FE0F',
    'men-with-bunny-ears-partying',
    ['men-with-bunny-ears-partying', 'man-with-bunny-ears-partying'],
    'People & Body',
    426,
    4,
    true,
    null,
  ],
  ['1F46F', 'dancers', ['dancers'], 'People & Body', 425, 0.6, true, null],
  [
    '1F470-200D-2640-FE0F',
    'woman_with_veil',
    ['woman_with_veil'],
    'People & Body',
    355,
    13,
    true,
    {
      '1F3FB': {
        unified: '1F470-1F3FB-200D-2640-FE0F',
        symbol: '👰🏻‍♀️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F470-1F3FC-200D-2640-FE0F',
        symbol: '👰🏼‍♀️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F470-1F3FD-200D-2640-FE0F',
        symbol: '👰🏽‍♀️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F470-1F3FE-200D-2640-FE0F',
        symbol: '👰🏾‍♀️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F470-1F3FF-200D-2640-FE0F',
        symbol: '👰🏿‍♀️',
        addedIn: 13,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F470-200D-2642-FE0F',
    'man_with_veil',
    ['man_with_veil'],
    'People & Body',
    354,
    13,
    true,
    {
      '1F3FB': {
        unified: '1F470-1F3FB-200D-2642-FE0F',
        symbol: '👰🏻‍♂️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F470-1F3FC-200D-2642-FE0F',
        symbol: '👰🏼‍♂️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F470-1F3FD-200D-2642-FE0F',
        symbol: '👰🏽‍♂️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F470-1F3FE-200D-2642-FE0F',
        symbol: '👰🏾‍♂️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F470-1F3FF-200D-2642-FE0F',
        symbol: '👰🏿‍♂️',
        addedIn: 13,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F470',
    'bride_with_veil',
    ['bride_with_veil'],
    'People & Body',
    353,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F470-1F3FB', symbol: '👰🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F470-1F3FC', symbol: '👰🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F470-1F3FD', symbol: '👰🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F470-1F3FE', symbol: '👰🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F470-1F3FF', symbol: '👰🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F471-200D-2640-FE0F',
    'blond-haired-woman',
    ['blond-haired-woman'],
    'People & Body',
    246,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F471-1F3FB-200D-2640-FE0F',
        symbol: '👱🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F471-1F3FC-200D-2640-FE0F',
        symbol: '👱🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F471-1F3FD-200D-2640-FE0F',
        symbol: '👱🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F471-1F3FE-200D-2640-FE0F',
        symbol: '👱🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F471-1F3FF-200D-2640-FE0F',
        symbol: '👱🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F471-200D-2642-FE0F',
    'blond-haired-man',
    ['blond-haired-man'],
    'People & Body',
    247,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F471-1F3FB-200D-2642-FE0F',
        symbol: '👱🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F471-1F3FC-200D-2642-FE0F',
        symbol: '👱🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F471-1F3FD-200D-2642-FE0F',
        symbol: '👱🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F471-1F3FE-200D-2642-FE0F',
        symbol: '👱🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F471-1F3FF-200D-2642-FE0F',
        symbol: '👱🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F471',
    'person_with_blond_hair',
    ['person_with_blond_hair'],
    'People & Body',
    228,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F471-1F3FB', symbol: '👱🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F471-1F3FC', symbol: '👱🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F471-1F3FD', symbol: '👱🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F471-1F3FE', symbol: '👱🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F471-1F3FF', symbol: '👱🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F472',
    'man_with_gua_pi_mao',
    ['man_with_gua_pi_mao'],
    'People & Body',
    348,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F472-1F3FB', symbol: '👲🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F472-1F3FC', symbol: '👲🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F472-1F3FD', symbol: '👲🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F472-1F3FE', symbol: '👲🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F472-1F3FF', symbol: '👲🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F473-200D-2640-FE0F',
    'woman-wearing-turban',
    ['woman-wearing-turban'],
    'People & Body',
    347,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F473-1F3FB-200D-2640-FE0F',
        symbol: '👳🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F473-1F3FC-200D-2640-FE0F',
        symbol: '👳🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F473-1F3FD-200D-2640-FE0F',
        symbol: '👳🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F473-1F3FE-200D-2640-FE0F',
        symbol: '👳🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F473-1F3FF-200D-2640-FE0F',
        symbol: '👳🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F473-200D-2642-FE0F',
    'man-wearing-turban',
    ['man-wearing-turban'],
    'People & Body',
    346,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F473-1F3FB-200D-2642-FE0F',
        symbol: '👳🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F473-1F3FC-200D-2642-FE0F',
        symbol: '👳🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F473-1F3FD-200D-2642-FE0F',
        symbol: '👳🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F473-1F3FE-200D-2642-FE0F',
        symbol: '👳🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F473-1F3FF-200D-2642-FE0F',
        symbol: '👳🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F473',
    'man_with_turban',
    ['man_with_turban'],
    'People & Body',
    345,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F473-1F3FB', symbol: '👳🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F473-1F3FC', symbol: '👳🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F473-1F3FD', symbol: '👳🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F473-1F3FE', symbol: '👳🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F473-1F3FF', symbol: '👳🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F474',
    'older_man',
    ['older_man'],
    'People & Body',
    249,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F474-1F3FB', symbol: '👴🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F474-1F3FC', symbol: '👴🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F474-1F3FD', symbol: '👴🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F474-1F3FE', symbol: '👴🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F474-1F3FF', symbol: '👴🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F475',
    'older_woman',
    ['older_woman'],
    'People & Body',
    250,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F475-1F3FB', symbol: '👵🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F475-1F3FC', symbol: '👵🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F475-1F3FD', symbol: '👵🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F475-1F3FE', symbol: '👵🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F475-1F3FF', symbol: '👵🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F476',
    'baby',
    ['baby'],
    'People & Body',
    223,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F476-1F3FB', symbol: '👶🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F476-1F3FC', symbol: '👶🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F476-1F3FD', symbol: '👶🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F476-1F3FE', symbol: '👶🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F476-1F3FF', symbol: '👶🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F477-200D-2640-FE0F',
    'female-construction-worker',
    ['female-construction-worker'],
    'People & Body',
    341,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F477-1F3FB-200D-2640-FE0F',
        symbol: '👷🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F477-1F3FC-200D-2640-FE0F',
        symbol: '👷🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F477-1F3FD-200D-2640-FE0F',
        symbol: '👷🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F477-1F3FE-200D-2640-FE0F',
        symbol: '👷🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F477-1F3FF-200D-2640-FE0F',
        symbol: '👷🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F477-200D-2642-FE0F',
    'male-construction-worker',
    ['male-construction-worker'],
    'People & Body',
    340,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F477-1F3FB-200D-2642-FE0F',
        symbol: '👷🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F477-1F3FC-200D-2642-FE0F',
        symbol: '👷🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F477-1F3FD-200D-2642-FE0F',
        symbol: '👷🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F477-1F3FE-200D-2642-FE0F',
        symbol: '👷🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F477-1F3FF-200D-2642-FE0F',
        symbol: '👷🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F477',
    'construction_worker',
    ['construction_worker'],
    'People & Body',
    339,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F477-1F3FB', symbol: '👷🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F477-1F3FC', symbol: '👷🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F477-1F3FD', symbol: '👷🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F477-1F3FE', symbol: '👷🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F477-1F3FF', symbol: '👷🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F478',
    'princess',
    ['princess'],
    'People & Body',
    344,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F478-1F3FB', symbol: '👸🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F478-1F3FC', symbol: '👸🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F478-1F3FD', symbol: '👸🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F478-1F3FE', symbol: '👸🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F478-1F3FF', symbol: '👸🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F479', 'japanese_ogre', ['japanese_ogre'], 'Smileys & Emotion', 109, 0.6, true, null],
  ['1F47A', 'japanese_goblin', ['japanese_goblin'], 'Smileys & Emotion', 110, 0.6, true, null],
  ['1F47B', 'ghost', ['ghost'], 'Smileys & Emotion', 111, 0.6, true, null],
  [
    '1F47C',
    'angel',
    ['angel'],
    'People & Body',
    363,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F47C-1F3FB', symbol: '👼🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F47C-1F3FC', symbol: '👼🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F47C-1F3FD', symbol: '👼🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F47C-1F3FE', symbol: '👼🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F47C-1F3FF', symbol: '👼🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F47D', 'alien', ['alien'], 'Smileys & Emotion', 112, 0.6, true, null],
  ['1F47E', 'space_invader', ['space_invader'], 'Smileys & Emotion', 113, 0.6, true, null],
  ['1F47F', 'imp', ['imp'], 'Smileys & Emotion', 104, 0.6, true, null],
  ['1F480', 'skull', ['skull'], 'Smileys & Emotion', 105, 0.6, true, null],
  [
    '1F481-200D-2640-FE0F',
    'woman-tipping-hand',
    ['woman-tipping-hand'],
    'People & Body',
    265,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F481-1F3FB-200D-2640-FE0F',
        symbol: '💁🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F481-1F3FC-200D-2640-FE0F',
        symbol: '💁🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F481-1F3FD-200D-2640-FE0F',
        symbol: '💁🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F481-1F3FE-200D-2640-FE0F',
        symbol: '💁🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F481-1F3FF-200D-2640-FE0F',
        symbol: '💁🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F481-200D-2642-FE0F',
    'man-tipping-hand',
    ['man-tipping-hand'],
    'People & Body',
    264,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F481-1F3FB-200D-2642-FE0F',
        symbol: '💁🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F481-1F3FC-200D-2642-FE0F',
        symbol: '💁🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F481-1F3FD-200D-2642-FE0F',
        symbol: '💁🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F481-1F3FE-200D-2642-FE0F',
        symbol: '💁🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F481-1F3FF-200D-2642-FE0F',
        symbol: '💁🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F481',
    'information_desk_person',
    ['information_desk_person'],
    'People & Body',
    263,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F481-1F3FB', symbol: '💁🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F481-1F3FC', symbol: '💁🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F481-1F3FD', symbol: '💁🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F481-1F3FE', symbol: '💁🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F481-1F3FF', symbol: '💁🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F482-200D-2640-FE0F',
    'female-guard',
    ['female-guard'],
    'People & Body',
    337,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F482-1F3FB-200D-2640-FE0F',
        symbol: '💂🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F482-1F3FC-200D-2640-FE0F',
        symbol: '💂🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F482-1F3FD-200D-2640-FE0F',
        symbol: '💂🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F482-1F3FE-200D-2640-FE0F',
        symbol: '💂🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F482-1F3FF-200D-2640-FE0F',
        symbol: '💂🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F482-200D-2642-FE0F',
    'male-guard',
    ['male-guard'],
    'People & Body',
    336,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F482-1F3FB-200D-2642-FE0F',
        symbol: '💂🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F482-1F3FC-200D-2642-FE0F',
        symbol: '💂🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F482-1F3FD-200D-2642-FE0F',
        symbol: '💂🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F482-1F3FE-200D-2642-FE0F',
        symbol: '💂🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F482-1F3FF-200D-2642-FE0F',
        symbol: '💂🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F482',
    'guardsman',
    ['guardsman'],
    'People & Body',
    335,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F482-1F3FB', symbol: '💂🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F482-1F3FC', symbol: '💂🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F482-1F3FD', symbol: '💂🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F482-1F3FE', symbol: '💂🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F482-1F3FF', symbol: '💂🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F483',
    'dancer',
    ['dancer'],
    'People & Body',
    422,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F483-1F3FB', symbol: '💃🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F483-1F3FC', symbol: '💃🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F483-1F3FD', symbol: '💃🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F483-1F3FE', symbol: '💃🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F483-1F3FF', symbol: '💃🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F484', 'lipstick', ['lipstick'], 'Objects', 1152, 0.6, true, null],
  [
    '1F485',
    'nail_care',
    ['nail_care'],
    'People & Body',
    203,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F485-1F3FB', symbol: '💅🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F485-1F3FC', symbol: '💅🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F485-1F3FD', symbol: '💅🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F485-1F3FE', symbol: '💅🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F485-1F3FF', symbol: '💅🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F486-200D-2640-FE0F',
    'woman-getting-massage',
    ['woman-getting-massage'],
    'People & Body',
    397,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F486-1F3FB-200D-2640-FE0F',
        symbol: '💆🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F486-1F3FC-200D-2640-FE0F',
        symbol: '💆🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F486-1F3FD-200D-2640-FE0F',
        symbol: '💆🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F486-1F3FE-200D-2640-FE0F',
        symbol: '💆🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F486-1F3FF-200D-2640-FE0F',
        symbol: '💆🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F486-200D-2642-FE0F',
    'man-getting-massage',
    ['man-getting-massage'],
    'People & Body',
    396,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F486-1F3FB-200D-2642-FE0F',
        symbol: '💆🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F486-1F3FC-200D-2642-FE0F',
        symbol: '💆🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F486-1F3FD-200D-2642-FE0F',
        symbol: '💆🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F486-1F3FE-200D-2642-FE0F',
        symbol: '💆🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F486-1F3FF-200D-2642-FE0F',
        symbol: '💆🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F486',
    'massage',
    ['massage'],
    'People & Body',
    395,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F486-1F3FB', symbol: '💆🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F486-1F3FC', symbol: '💆🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F486-1F3FD', symbol: '💆🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F486-1F3FE', symbol: '💆🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F486-1F3FF', symbol: '💆🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F487-200D-2640-FE0F',
    'woman-getting-haircut',
    ['woman-getting-haircut'],
    'People & Body',
    400,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F487-1F3FB-200D-2640-FE0F',
        symbol: '💇🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F487-1F3FC-200D-2640-FE0F',
        symbol: '💇🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F487-1F3FD-200D-2640-FE0F',
        symbol: '💇🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F487-1F3FE-200D-2640-FE0F',
        symbol: '💇🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F487-1F3FF-200D-2640-FE0F',
        symbol: '💇🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F487-200D-2642-FE0F',
    'man-getting-haircut',
    ['man-getting-haircut'],
    'People & Body',
    399,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F487-1F3FB-200D-2642-FE0F',
        symbol: '💇🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F487-1F3FC-200D-2642-FE0F',
        symbol: '💇🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F487-1F3FD-200D-2642-FE0F',
        symbol: '💇🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F487-1F3FE-200D-2642-FE0F',
        symbol: '💇🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F487-1F3FF-200D-2642-FE0F',
        symbol: '💇🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F487',
    'haircut',
    ['haircut'],
    'People & Body',
    398,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F487-1F3FB', symbol: '💇🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F487-1F3FC', symbol: '💇🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F487-1F3FD', symbol: '💇🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F487-1F3FE', symbol: '💇🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F487-1F3FF', symbol: '💇🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F488', 'barber', ['barber'], 'Travel & Places', 870, 0.6, true, null],
  ['1F489', 'syringe', ['syringe'], 'Objects', 1326, 0.6, true, null],
  ['1F48A', 'pill', ['pill'], 'Objects', 1328, 0.6, true, null],
  ['1F48B', 'kiss', ['kiss'], 'Smileys & Emotion', 127, 0.6, true, null],
  ['1F48C', 'love_letter', ['love_letter'], 'Smileys & Emotion', 128, 0.6, true, null],
  ['1F48D', 'ring', ['ring'], 'Objects', 1153, 0.6, true, null],
  ['1F48E', 'gem', ['gem'], 'Objects', 1154, 0.6, true, null],
  [
    '1F48F',
    'couplekiss',
    ['couplekiss'],
    'People & Body',
    486,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F48F-1F3FB', symbol: '💏🏻', addedIn: 13.1, hasImgTwitter: true },
      '1F3FC': { unified: '1F48F-1F3FC', symbol: '💏🏼', addedIn: 13.1, hasImgTwitter: true },
      '1F3FD': { unified: '1F48F-1F3FD', symbol: '💏🏽', addedIn: 13.1, hasImgTwitter: true },
      '1F3FE': { unified: '1F48F-1F3FE', symbol: '💏🏾', addedIn: 13.1, hasImgTwitter: true },
      '1F3FF': { unified: '1F48F-1F3FF', symbol: '💏🏿', addedIn: 13.1, hasImgTwitter: true },
      '1F3FB-1F3FC': {
        unified: '1F9D1-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FC',
        symbol: '🧑🏻‍❤️‍💋‍🧑🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FD': {
        unified: '1F9D1-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FD',
        symbol: '🧑🏻‍❤️‍💋‍🧑🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FE': {
        unified: '1F9D1-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FE',
        symbol: '🧑🏻‍❤️‍💋‍🧑🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FF': {
        unified: '1F9D1-1F3FB-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FF',
        symbol: '🧑🏻‍❤️‍💋‍🧑🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FB': {
        unified: '1F9D1-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FB',
        symbol: '🧑🏼‍❤️‍💋‍🧑🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FD': {
        unified: '1F9D1-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FD',
        symbol: '🧑🏼‍❤️‍💋‍🧑🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FE': {
        unified: '1F9D1-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FE',
        symbol: '🧑🏼‍❤️‍💋‍🧑🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FF': {
        unified: '1F9D1-1F3FC-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FF',
        symbol: '🧑🏼‍❤️‍💋‍🧑🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FB': {
        unified: '1F9D1-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FB',
        symbol: '🧑🏽‍❤️‍💋‍🧑🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FC': {
        unified: '1F9D1-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FC',
        symbol: '🧑🏽‍❤️‍💋‍🧑🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FE': {
        unified: '1F9D1-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FE',
        symbol: '🧑🏽‍❤️‍💋‍🧑🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FF': {
        unified: '1F9D1-1F3FD-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FF',
        symbol: '🧑🏽‍❤️‍💋‍🧑🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FB': {
        unified: '1F9D1-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FB',
        symbol: '🧑🏾‍❤️‍💋‍🧑🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FC': {
        unified: '1F9D1-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FC',
        symbol: '🧑🏾‍❤️‍💋‍🧑🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FD': {
        unified: '1F9D1-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FD',
        symbol: '🧑🏾‍❤️‍💋‍🧑🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FF': {
        unified: '1F9D1-1F3FE-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FF',
        symbol: '🧑🏾‍❤️‍💋‍🧑🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FB': {
        unified: '1F9D1-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FB',
        symbol: '🧑🏿‍❤️‍💋‍🧑🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FC': {
        unified: '1F9D1-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FC',
        symbol: '🧑🏿‍❤️‍💋‍🧑🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FD': {
        unified: '1F9D1-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FD',
        symbol: '🧑🏿‍❤️‍💋‍🧑🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FE': {
        unified: '1F9D1-1F3FF-200D-2764-FE0F-200D-1F48B-200D-1F9D1-1F3FE',
        symbol: '🧑🏿‍❤️‍💋‍🧑🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
    },
  ],
  ['1F490', 'bouquet', ['bouquet'], 'Animals & Nature', 648, 0.6, true, null],
  [
    '1F491',
    'couple_with_heart',
    ['couple_with_heart'],
    'People & Body',
    490,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F491-1F3FB', symbol: '💑🏻', addedIn: 13.1, hasImgTwitter: true },
      '1F3FC': { unified: '1F491-1F3FC', symbol: '💑🏼', addedIn: 13.1, hasImgTwitter: true },
      '1F3FD': { unified: '1F491-1F3FD', symbol: '💑🏽', addedIn: 13.1, hasImgTwitter: true },
      '1F3FE': { unified: '1F491-1F3FE', symbol: '💑🏾', addedIn: 13.1, hasImgTwitter: true },
      '1F3FF': { unified: '1F491-1F3FF', symbol: '💑🏿', addedIn: 13.1, hasImgTwitter: true },
      '1F3FB-1F3FC': {
        unified: '1F9D1-1F3FB-200D-2764-FE0F-200D-1F9D1-1F3FC',
        symbol: '🧑🏻‍❤️‍🧑🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FD': {
        unified: '1F9D1-1F3FB-200D-2764-FE0F-200D-1F9D1-1F3FD',
        symbol: '🧑🏻‍❤️‍🧑🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FE': {
        unified: '1F9D1-1F3FB-200D-2764-FE0F-200D-1F9D1-1F3FE',
        symbol: '🧑🏻‍❤️‍🧑🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FF': {
        unified: '1F9D1-1F3FB-200D-2764-FE0F-200D-1F9D1-1F3FF',
        symbol: '🧑🏻‍❤️‍🧑🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FB': {
        unified: '1F9D1-1F3FC-200D-2764-FE0F-200D-1F9D1-1F3FB',
        symbol: '🧑🏼‍❤️‍🧑🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FD': {
        unified: '1F9D1-1F3FC-200D-2764-FE0F-200D-1F9D1-1F3FD',
        symbol: '🧑🏼‍❤️‍🧑🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FE': {
        unified: '1F9D1-1F3FC-200D-2764-FE0F-200D-1F9D1-1F3FE',
        symbol: '🧑🏼‍❤️‍🧑🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FF': {
        unified: '1F9D1-1F3FC-200D-2764-FE0F-200D-1F9D1-1F3FF',
        symbol: '🧑🏼‍❤️‍🧑🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FB': {
        unified: '1F9D1-1F3FD-200D-2764-FE0F-200D-1F9D1-1F3FB',
        symbol: '🧑🏽‍❤️‍🧑🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FC': {
        unified: '1F9D1-1F3FD-200D-2764-FE0F-200D-1F9D1-1F3FC',
        symbol: '🧑🏽‍❤️‍🧑🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FE': {
        unified: '1F9D1-1F3FD-200D-2764-FE0F-200D-1F9D1-1F3FE',
        symbol: '🧑🏽‍❤️‍🧑🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FF': {
        unified: '1F9D1-1F3FD-200D-2764-FE0F-200D-1F9D1-1F3FF',
        symbol: '🧑🏽‍❤️‍🧑🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FB': {
        unified: '1F9D1-1F3FE-200D-2764-FE0F-200D-1F9D1-1F3FB',
        symbol: '🧑🏾‍❤️‍🧑🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FC': {
        unified: '1F9D1-1F3FE-200D-2764-FE0F-200D-1F9D1-1F3FC',
        symbol: '🧑🏾‍❤️‍🧑🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FD': {
        unified: '1F9D1-1F3FE-200D-2764-FE0F-200D-1F9D1-1F3FD',
        symbol: '🧑🏾‍❤️‍🧑🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FF': {
        unified: '1F9D1-1F3FE-200D-2764-FE0F-200D-1F9D1-1F3FF',
        symbol: '🧑🏾‍❤️‍🧑🏿',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FB': {
        unified: '1F9D1-1F3FF-200D-2764-FE0F-200D-1F9D1-1F3FB',
        symbol: '🧑🏿‍❤️‍🧑🏻',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FC': {
        unified: '1F9D1-1F3FF-200D-2764-FE0F-200D-1F9D1-1F3FC',
        symbol: '🧑🏿‍❤️‍🧑🏼',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FD': {
        unified: '1F9D1-1F3FF-200D-2764-FE0F-200D-1F9D1-1F3FD',
        symbol: '🧑🏿‍❤️‍🧑🏽',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FE': {
        unified: '1F9D1-1F3FF-200D-2764-FE0F-200D-1F9D1-1F3FE',
        symbol: '🧑🏿‍❤️‍🧑🏾',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
    },
  ],
  ['1F492', 'wedding', ['wedding'], 'Travel & Places', 846, 0.6, true, null],
  ['1F493', 'heartbeat', ['heartbeat'], 'Smileys & Emotion', 133, 0.6, true, null],
  ['1F494', 'broken_heart', ['broken_heart'], 'Smileys & Emotion', 138, 0.6, true, null],
  ['1F495', 'two_hearts', ['two_hearts'], 'Smileys & Emotion', 135, 0.6, true, null],
  ['1F496', 'sparkling_heart', ['sparkling_heart'], 'Smileys & Emotion', 131, 0.6, true, null],
  ['1F497', 'heartpulse', ['heartpulse'], 'Smileys & Emotion', 132, 0.6, true, null],
  ['1F498', 'cupid', ['cupid'], 'Smileys & Emotion', 129, 0.6, true, null],
  ['1F499', 'blue_heart', ['blue_heart'], 'Smileys & Emotion', 145, 0.6, true, null],
  ['1F49A', 'green_heart', ['green_heart'], 'Smileys & Emotion', 144, 0.6, true, null],
  ['1F49B', 'yellow_heart', ['yellow_heart'], 'Smileys & Emotion', 143, 0.6, true, null],
  ['1F49C', 'purple_heart', ['purple_heart'], 'Smileys & Emotion', 146, 0.6, true, null],
  ['1F49D', 'gift_heart', ['gift_heart'], 'Smileys & Emotion', 130, 0.6, true, null],
  ['1F49E', 'revolving_hearts', ['revolving_hearts'], 'Smileys & Emotion', 134, 0.6, true, null],
  ['1F49F', 'heart_decoration', ['heart_decoration'], 'Smileys & Emotion', 136, 0.6, true, null],
  [
    '1F4A0',
    'diamond_shape_with_a_dot_inside',
    ['diamond_shape_with_a_dot_inside'],
    'Symbols',
    1582,
    0.6,
    true,
    null,
  ],
  ['1F4A1', 'bulb', ['bulb'], 'Objects', 1214, 0.6, true, null],
  ['1F4A2', 'anger', ['anger'], 'Smileys & Emotion', 151, 0.6, true, null],
  ['1F4A3', 'bomb', ['bomb'], 'Smileys & Emotion', 157, 0.6, true, null],
  ['1F4A4', 'zzz', ['zzz'], 'Smileys & Emotion', 163, 0.6, true, null],
  ['1F4A5', 'boom', ['boom', 'collision'], 'Smileys & Emotion', 152, 0.6, true, null],
  ['1F4A6', 'sweat_drops', ['sweat_drops'], 'Smileys & Emotion', 154, 0.6, true, null],
  ['1F4A7', 'droplet', ['droplet'], 'Travel & Places', 1022, 0.6, true, null],
  ['1F4A8', 'dash', ['dash'], 'Smileys & Emotion', 155, 0.6, true, null],
  ['1F4A9', 'hankey', ['hankey', 'poop', 'shit'], 'Smileys & Emotion', 107, 0.6, true, null],
  [
    '1F4AA',
    'muscle',
    ['muscle'],
    'People & Body',
    205,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F4AA-1F3FB', symbol: '💪🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F4AA-1F3FC', symbol: '💪🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F4AA-1F3FD', symbol: '💪🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F4AA-1F3FE', symbol: '💪🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F4AA-1F3FF', symbol: '💪🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F4AB', 'dizzy', ['dizzy'], 'Smileys & Emotion', 153, 0.6, true, null],
  ['1F4AC', 'speech_balloon', ['speech_balloon'], 'Smileys & Emotion', 158, 0.6, true, null],
  ['1F4AD', 'thought_balloon', ['thought_balloon'], 'Smileys & Emotion', 162, 1, true, null],
  ['1F4AE', 'white_flower', ['white_flower'], 'Animals & Nature', 650, 0.6, true, null],
  ['1F4AF', '100', ['100'], 'Smileys & Emotion', 150, 0.6, true, null],
  ['1F4B0', 'moneybag', ['moneybag'], 'Objects', 1235, 0.6, true, null],
  ['1F4B1', 'currency_exchange', ['currency_exchange'], 'Symbols', 1477, 0.6, true, null],
  ['1F4B2', 'heavy_dollar_sign', ['heavy_dollar_sign'], 'Symbols', 1478, 0.6, true, null],
  ['1F4B3', 'credit_card', ['credit_card'], 'Objects', 1242, 0.6, true, null],
  ['1F4B4', 'yen', ['yen'], 'Objects', 1237, 0.6, true, null],
  ['1F4B5', 'dollar', ['dollar'], 'Objects', 1238, 0.6, true, null],
  ['1F4B6', 'euro', ['euro'], 'Objects', 1239, 1, true, null],
  ['1F4B7', 'pound', ['pound'], 'Objects', 1240, 1, true, null],
  ['1F4B8', 'money_with_wings', ['money_with_wings'], 'Objects', 1241, 0.6, true, null],
  ['1F4B9', 'chart', ['chart'], 'Objects', 1244, 0.6, true, null],
  ['1F4BA', 'seat', ['seat'], 'Travel & Places', 936, 0.6, true, null],
  ['1F4BB', 'computer', ['computer'], 'Objects', 1191, 0.6, true, null],
  ['1F4BC', 'briefcase', ['briefcase'], 'Objects', 1265, 0.6, true, null],
  ['1F4BD', 'minidisc', ['minidisc'], 'Objects', 1197, 0.6, true, null],
  ['1F4BE', 'floppy_disk', ['floppy_disk'], 'Objects', 1198, 0.6, true, null],
  ['1F4BF', 'cd', ['cd'], 'Objects', 1199, 0.6, true, null],
  ['1F4C0', 'dvd', ['dvd'], 'Objects', 1200, 0.6, true, null],
  ['1F4C1', 'file_folder', ['file_folder'], 'Objects', 1266, 0.6, true, null],
  ['1F4C2', 'open_file_folder', ['open_file_folder'], 'Objects', 1267, 0.6, true, null],
  ['1F4C3', 'page_with_curl', ['page_with_curl'], 'Objects', 1227, 0.6, true, null],
  ['1F4C4', 'page_facing_up', ['page_facing_up'], 'Objects', 1229, 0.6, true, null],
  ['1F4C5', 'date', ['date'], 'Objects', 1269, 0.6, true, null],
  ['1F4C6', 'calendar', ['calendar'], 'Objects', 1270, 0.6, true, null],
  ['1F4C7', 'card_index', ['card_index'], 'Objects', 1273, 0.6, true, null],
  [
    '1F4C8',
    'chart_with_upwards_trend',
    ['chart_with_upwards_trend'],
    'Objects',
    1274,
    0.6,
    true,
    null,
  ],
  [
    '1F4C9',
    'chart_with_downwards_trend',
    ['chart_with_downwards_trend'],
    'Objects',
    1275,
    0.6,
    true,
    null,
  ],
  ['1F4CA', 'bar_chart', ['bar_chart'], 'Objects', 1276, 0.6, true, null],
  ['1F4CB', 'clipboard', ['clipboard'], 'Objects', 1277, 0.6, true, null],
  ['1F4CC', 'pushpin', ['pushpin'], 'Objects', 1278, 0.6, true, null],
  ['1F4CD', 'round_pushpin', ['round_pushpin'], 'Objects', 1279, 0.6, true, null],
  ['1F4CE', 'paperclip', ['paperclip'], 'Objects', 1280, 0.6, true, null],
  ['1F4CF', 'straight_ruler', ['straight_ruler'], 'Objects', 1282, 0.6, true, null],
  ['1F4D0', 'triangular_ruler', ['triangular_ruler'], 'Objects', 1283, 0.6, true, null],
  ['1F4D1', 'bookmark_tabs', ['bookmark_tabs'], 'Objects', 1232, 0.6, true, null],
  ['1F4D2', 'ledger', ['ledger'], 'Objects', 1226, 0.6, true, null],
  ['1F4D3', 'notebook', ['notebook'], 'Objects', 1225, 0.6, true, null],
  [
    '1F4D4',
    'notebook_with_decorative_cover',
    ['notebook_with_decorative_cover'],
    'Objects',
    1218,
    0.6,
    true,
    null,
  ],
  ['1F4D5', 'closed_book', ['closed_book'], 'Objects', 1219, 0.6, true, null],
  ['1F4D6', 'book', ['book', 'open_book'], 'Objects', 1220, 0.6, true, null],
  ['1F4D7', 'green_book', ['green_book'], 'Objects', 1221, 0.6, true, null],
  ['1F4D8', 'blue_book', ['blue_book'], 'Objects', 1222, 0.6, true, null],
  ['1F4D9', 'orange_book', ['orange_book'], 'Objects', 1223, 0.6, true, null],
  ['1F4DA', 'books', ['books'], 'Objects', 1224, 0.6, true, null],
  ['1F4DB', 'name_badge', ['name_badge'], 'Symbols', 1483, 0.6, true, null],
  ['1F4DC', 'scroll', ['scroll'], 'Objects', 1228, 0.6, true, null],
  ['1F4DD', 'memo', ['memo', 'pencil'], 'Objects', 1264, 0.6, true, null],
  ['1F4DE', 'telephone_receiver', ['telephone_receiver'], 'Objects', 1185, 0.6, true, null],
  ['1F4DF', 'pager', ['pager'], 'Objects', 1186, 0.6, true, null],
  ['1F4E0', 'fax', ['fax'], 'Objects', 1187, 0.6, true, null],
  ['1F4E1', 'satellite_antenna', ['satellite_antenna'], 'Objects', 1325, 0.6, true, null],
  ['1F4E2', 'loudspeaker', ['loudspeaker'], 'Objects', 1159, 0.6, true, null],
  ['1F4E3', 'mega', ['mega'], 'Objects', 1160, 0.6, true, null],
  ['1F4E4', 'outbox_tray', ['outbox_tray'], 'Objects', 1249, 0.6, true, null],
  ['1F4E5', 'inbox_tray', ['inbox_tray'], 'Objects', 1250, 0.6, true, null],
  ['1F4E6', 'package', ['package'], 'Objects', 1251, 0.6, true, null],
  ['1F4E7', 'e-mail', ['e-mail'], 'Objects', 1246, 0.6, true, null],
  ['1F4E8', 'incoming_envelope', ['incoming_envelope'], 'Objects', 1247, 0.6, true, null],
  ['1F4E9', 'envelope_with_arrow', ['envelope_with_arrow'], 'Objects', 1248, 0.6, true, null],
  ['1F4EA', 'mailbox_closed', ['mailbox_closed'], 'Objects', 1253, 0.6, true, null],
  ['1F4EB', 'mailbox', ['mailbox'], 'Objects', 1252, 0.6, true, null],
  ['1F4EC', 'mailbox_with_mail', ['mailbox_with_mail'], 'Objects', 1254, 0.7, true, null],
  ['1F4ED', 'mailbox_with_no_mail', ['mailbox_with_no_mail'], 'Objects', 1255, 0.7, true, null],
  ['1F4EE', 'postbox', ['postbox'], 'Objects', 1256, 0.6, true, null],
  ['1F4EF', 'postal_horn', ['postal_horn'], 'Objects', 1161, 1, true, null],
  ['1F4F0', 'newspaper', ['newspaper'], 'Objects', 1230, 0.6, true, null],
  ['1F4F1', 'iphone', ['iphone'], 'Objects', 1182, 0.6, true, null],
  ['1F4F2', 'calling', ['calling'], 'Objects', 1183, 0.6, true, null],
  ['1F4F3', 'vibration_mode', ['vibration_mode'], 'Symbols', 1459, 0.6, true, null],
  ['1F4F4', 'mobile_phone_off', ['mobile_phone_off'], 'Symbols', 1460, 0.6, true, null],
  ['1F4F5', 'no_mobile_phones', ['no_mobile_phones'], 'Symbols', 1387, 1, true, null],
  ['1F4F6', 'signal_strength', ['signal_strength'], 'Symbols', 1458, 0.6, true, null],
  ['1F4F7', 'camera', ['camera'], 'Objects', 1207, 0.6, true, null],
  ['1F4F8', 'camera_with_flash', ['camera_with_flash'], 'Objects', 1208, 1, true, null],
  ['1F4F9', 'video_camera', ['video_camera'], 'Objects', 1209, 0.6, true, null],
  ['1F4FA', 'tv', ['tv'], 'Objects', 1206, 0.6, true, null],
  ['1F4FB', 'radio', ['radio'], 'Objects', 1172, 0.6, true, null],
  ['1F4FC', 'vhs', ['vhs'], 'Objects', 1210, 0.6, true, null],
  ['1F4FD-FE0F', 'film_projector', ['film_projector'], 'Objects', 1204, 0.7, true, null],
  ['1F4FF', 'prayer_beads', ['prayer_beads'], 'Objects', 1151, 1, true, null],
  [
    '1F500',
    'twisted_rightwards_arrows',
    ['twisted_rightwards_arrows'],
    'Symbols',
    1437,
    1,
    true,
    null,
  ],
  ['1F501', 'repeat', ['repeat'], 'Symbols', 1438, 1, true, null],
  ['1F502', 'repeat_one', ['repeat_one'], 'Symbols', 1439, 1, true, null],
  ['1F503', 'arrows_clockwise', ['arrows_clockwise'], 'Symbols', 1405, 0.6, true, null],
  ['1F504', 'arrows_counterclockwise', ['arrows_counterclockwise'], 'Symbols', 1406, 1, true, null],
  ['1F505', 'low_brightness', ['low_brightness'], 'Symbols', 1456, 1, true, null],
  ['1F506', 'high_brightness', ['high_brightness'], 'Symbols', 1457, 1, true, null],
  ['1F507', 'mute', ['mute'], 'Objects', 1155, 1, true, null],
  ['1F508', 'speaker', ['speaker'], 'Objects', 1156, 0.7, true, null],
  ['1F509', 'sound', ['sound'], 'Objects', 1157, 1, true, null],
  ['1F50A', 'loud_sound', ['loud_sound'], 'Objects', 1158, 0.6, true, null],
  ['1F50B', 'battery', ['battery'], 'Objects', 1188, 0.6, true, null],
  ['1F50C', 'electric_plug', ['electric_plug'], 'Objects', 1190, 0.6, true, null],
  ['1F50D', 'mag', ['mag'], 'Objects', 1211, 0.6, true, null],
  ['1F50E', 'mag_right', ['mag_right'], 'Objects', 1212, 0.6, true, null],
  ['1F50F', 'lock_with_ink_pen', ['lock_with_ink_pen'], 'Objects', 1290, 0.6, true, null],
  ['1F510', 'closed_lock_with_key', ['closed_lock_with_key'], 'Objects', 1291, 0.6, true, null],
  ['1F511', 'key', ['key'], 'Objects', 1292, 0.6, true, null],
  ['1F512', 'lock', ['lock'], 'Objects', 1288, 0.6, true, null],
  ['1F513', 'unlock', ['unlock'], 'Objects', 1289, 0.6, true, null],
  ['1F514', 'bell', ['bell'], 'Objects', 1162, 0.6, true, null],
  ['1F515', 'no_bell', ['no_bell'], 'Objects', 1163, 1, true, null],
  ['1F516', 'bookmark', ['bookmark'], 'Objects', 1233, 0.6, true, null],
  ['1F517', 'link', ['link'], 'Objects', 1313, 0.6, true, null],
  ['1F518', 'radio_button', ['radio_button'], 'Symbols', 1583, 0.6, true, null],
  ['1F519', 'back', ['back'], 'Symbols', 1407, 0.6, true, null],
  ['1F51A', 'end', ['end'], 'Symbols', 1408, 0.6, true, null],
  ['1F51B', 'on', ['on'], 'Symbols', 1409, 0.6, true, null],
  ['1F51C', 'soon', ['soon'], 'Symbols', 1410, 0.6, true, null],
  ['1F51D', 'top', ['top'], 'Symbols', 1411, 0.6, true, null],
  ['1F51E', 'underage', ['underage'], 'Symbols', 1388, 0.6, true, null],
  ['1F51F', 'keycap_ten', ['keycap_ten'], 'Symbols', 1512, 0.6, true, null],
  ['1F520', 'capital_abcd', ['capital_abcd'], 'Symbols', 1513, 0.6, true, null],
  ['1F521', 'abcd', ['abcd'], 'Symbols', 1514, 0.6, true, null],
  ['1F522', '1234', ['1234'], 'Symbols', 1515, 0.6, true, null],
  ['1F523', 'symbols', ['symbols'], 'Symbols', 1516, 0.6, true, null],
  ['1F524', 'abc', ['abc'], 'Symbols', 1517, 0.6, true, null],
  ['1F525', 'fire', ['fire'], 'Travel & Places', 1021, 0.6, true, null],
  ['1F526', 'flashlight', ['flashlight'], 'Objects', 1215, 0.6, true, null],
  ['1F527', 'wrench', ['wrench'], 'Objects', 1306, 0.6, true, null],
  ['1F528', 'hammer', ['hammer'], 'Objects', 1294, 0.6, true, null],
  ['1F529', 'nut_and_bolt', ['nut_and_bolt'], 'Objects', 1308, 0.6, true, null],
  ['1F52A', 'hocho', ['hocho', 'knife'], 'Food & Drink', 803, 0.6, true, null],
  ['1F52B', 'gun', ['gun'], 'Objects', 1301, 0.6, true, null],
  ['1F52C', 'microscope', ['microscope'], 'Objects', 1323, 1, true, null],
  ['1F52D', 'telescope', ['telescope'], 'Objects', 1324, 1, true, null],
  ['1F52E', 'crystal_ball', ['crystal_ball'], 'Activities', 1082, 0.6, true, null],
  ['1F52F', 'six_pointed_star', ['six_pointed_star'], 'Symbols', 1423, 0.6, true, null],
  ['1F530', 'beginner', ['beginner'], 'Symbols', 1484, 0.6, true, null],
  ['1F531', 'trident', ['trident'], 'Symbols', 1482, 0.6, true, null],
  ['1F532', 'black_square_button', ['black_square_button'], 'Symbols', 1585, 0.6, true, null],
  ['1F533', 'white_square_button', ['white_square_button'], 'Symbols', 1584, 0.6, true, null],
  ['1F534', 'red_circle', ['red_circle'], 'Symbols', 1552, 0.6, true, null],
  ['1F535', 'large_blue_circle', ['large_blue_circle'], 'Symbols', 1556, 0.6, true, null],
  ['1F536', 'large_orange_diamond', ['large_orange_diamond'], 'Symbols', 1576, 0.6, true, null],
  ['1F537', 'large_blue_diamond', ['large_blue_diamond'], 'Symbols', 1577, 0.6, true, null],
  ['1F538', 'small_orange_diamond', ['small_orange_diamond'], 'Symbols', 1578, 0.6, true, null],
  ['1F539', 'small_blue_diamond', ['small_blue_diamond'], 'Symbols', 1579, 0.6, true, null],
  ['1F53A', 'small_red_triangle', ['small_red_triangle'], 'Symbols', 1580, 0.6, true, null],
  [
    '1F53B',
    'small_red_triangle_down',
    ['small_red_triangle_down'],
    'Symbols',
    1581,
    0.6,
    true,
    null,
  ],
  ['1F53C', 'arrow_up_small', ['arrow_up_small'], 'Symbols', 1447, 0.6, true, null],
  ['1F53D', 'arrow_down_small', ['arrow_down_small'], 'Symbols', 1449, 0.6, true, null],
  ['1F549-FE0F', 'om_symbol', ['om_symbol'], 'Symbols', 1414, 0.7, true, null],
  ['1F54A-FE0F', 'dove_of_peace', ['dove_of_peace'], 'Animals & Nature', 602, 0.7, true, null],
  ['1F54B', 'kaaba', ['kaaba'], 'Travel & Places', 854, 1, true, null],
  ['1F54C', 'mosque', ['mosque'], 'Travel & Places', 850, 1, true, null],
  ['1F54D', 'synagogue', ['synagogue'], 'Travel & Places', 852, 1, true, null],
  [
    '1F54E',
    'menorah_with_nine_branches',
    ['menorah_with_nine_branches'],
    'Symbols',
    1422,
    1,
    true,
    null,
  ],
  ['1F550', 'clock1', ['clock1'], 'Travel & Places', 955, 0.6, true, null],
  ['1F551', 'clock2', ['clock2'], 'Travel & Places', 957, 0.6, true, null],
  ['1F552', 'clock3', ['clock3'], 'Travel & Places', 959, 0.6, true, null],
  ['1F553', 'clock4', ['clock4'], 'Travel & Places', 961, 0.6, true, null],
  ['1F554', 'clock5', ['clock5'], 'Travel & Places', 963, 0.6, true, null],
  ['1F555', 'clock6', ['clock6'], 'Travel & Places', 965, 0.6, true, null],
  ['1F556', 'clock7', ['clock7'], 'Travel & Places', 967, 0.6, true, null],
  ['1F557', 'clock8', ['clock8'], 'Travel & Places', 969, 0.6, true, null],
  ['1F558', 'clock9', ['clock9'], 'Travel & Places', 971, 0.6, true, null],
  ['1F559', 'clock10', ['clock10'], 'Travel & Places', 973, 0.6, true, null],
  ['1F55A', 'clock11', ['clock11'], 'Travel & Places', 975, 0.6, true, null],
  ['1F55B', 'clock12', ['clock12'], 'Travel & Places', 953, 0.6, true, null],
  ['1F55C', 'clock130', ['clock130'], 'Travel & Places', 956, 0.7, true, null],
  ['1F55D', 'clock230', ['clock230'], 'Travel & Places', 958, 0.7, true, null],
  ['1F55E', 'clock330', ['clock330'], 'Travel & Places', 960, 0.7, true, null],
  ['1F55F', 'clock430', ['clock430'], 'Travel & Places', 962, 0.7, true, null],
  ['1F560', 'clock530', ['clock530'], 'Travel & Places', 964, 0.7, true, null],
  ['1F561', 'clock630', ['clock630'], 'Travel & Places', 966, 0.7, true, null],
  ['1F562', 'clock730', ['clock730'], 'Travel & Places', 968, 0.7, true, null],
  ['1F563', 'clock830', ['clock830'], 'Travel & Places', 970, 0.7, true, null],
  ['1F564', 'clock930', ['clock930'], 'Travel & Places', 972, 0.7, true, null],
  ['1F565', 'clock1030', ['clock1030'], 'Travel & Places', 974, 0.7, true, null],
  ['1F566', 'clock1130', ['clock1130'], 'Travel & Places', 976, 0.7, true, null],
  ['1F567', 'clock1230', ['clock1230'], 'Travel & Places', 954, 0.7, true, null],
  ['1F56F-FE0F', 'candle', ['candle'], 'Objects', 1213, 0.7, true, null],
  [
    '1F570-FE0F',
    'mantelpiece_clock',
    ['mantelpiece_clock'],
    'Travel & Places',
    952,
    0.7,
    true,
    null,
  ],
  ['1F573-FE0F', 'hole', ['hole'], 'Smileys & Emotion', 156, 0.7, true, null],
  [
    '1F574-FE0F',
    'man_in_business_suit_levitating',
    ['man_in_business_suit_levitating'],
    'People & Body',
    424,
    0.7,
    true,
    {
      '1F3FB': { unified: '1F574-1F3FB', symbol: '🕴🏻', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F574-1F3FC', symbol: '🕴🏼', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F574-1F3FD', symbol: '🕴🏽', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F574-1F3FE', symbol: '🕴🏾', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F574-1F3FF', symbol: '🕴🏿', addedIn: 4, hasImgTwitter: true },
    },
  ],
  [
    '1F575-FE0F-200D-2640-FE0F',
    'female-detective',
    ['female-detective'],
    'People & Body',
    334,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F575-1F3FB-200D-2640-FE0F',
        symbol: '🕵🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F575-1F3FC-200D-2640-FE0F',
        symbol: '🕵🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F575-1F3FD-200D-2640-FE0F',
        symbol: '🕵🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F575-1F3FE-200D-2640-FE0F',
        symbol: '🕵🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F575-1F3FF-200D-2640-FE0F',
        symbol: '🕵🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F575-FE0F-200D-2642-FE0F',
    'male-detective',
    ['male-detective'],
    'People & Body',
    333,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F575-1F3FB-200D-2642-FE0F',
        symbol: '🕵🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F575-1F3FC-200D-2642-FE0F',
        symbol: '🕵🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F575-1F3FD-200D-2642-FE0F',
        symbol: '🕵🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F575-1F3FE-200D-2642-FE0F',
        symbol: '🕵🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F575-1F3FF-200D-2642-FE0F',
        symbol: '🕵🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F575-FE0F',
    'sleuth_or_spy',
    ['sleuth_or_spy'],
    'People & Body',
    332,
    0.7,
    true,
    {
      '1F3FB': { unified: '1F575-1F3FB', symbol: '🕵🏻', addedIn: 2, hasImgTwitter: true },
      '1F3FC': { unified: '1F575-1F3FC', symbol: '🕵🏼', addedIn: 2, hasImgTwitter: true },
      '1F3FD': { unified: '1F575-1F3FD', symbol: '🕵🏽', addedIn: 2, hasImgTwitter: true },
      '1F3FE': { unified: '1F575-1F3FE', symbol: '🕵🏾', addedIn: 2, hasImgTwitter: true },
      '1F3FF': { unified: '1F575-1F3FF', symbol: '🕵🏿', addedIn: 2, hasImgTwitter: true },
    },
  ],
  ['1F576-FE0F', 'dark_sunglasses', ['dark_sunglasses'], 'Objects', 1111, 0.7, true, null],
  ['1F577-FE0F', 'spider', ['spider'], 'Animals & Nature', 641, 0.7, true, null],
  ['1F578-FE0F', 'spider_web', ['spider_web'], 'Animals & Nature', 642, 0.7, true, null],
  ['1F579-FE0F', 'joystick', ['joystick'], 'Activities', 1087, 0.7, true, null],
  [
    '1F57A',
    'man_dancing',
    ['man_dancing'],
    'People & Body',
    423,
    3,
    true,
    {
      '1F3FB': { unified: '1F57A-1F3FB', symbol: '🕺🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F57A-1F3FC', symbol: '🕺🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F57A-1F3FD', symbol: '🕺🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F57A-1F3FE', symbol: '🕺🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F57A-1F3FF', symbol: '🕺🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  ['1F587-FE0F', 'linked_paperclips', ['linked_paperclips'], 'Objects', 1281, 0.7, true, null],
  [
    '1F58A-FE0F',
    'lower_left_ballpoint_pen',
    ['lower_left_ballpoint_pen'],
    'Objects',
    1261,
    0.7,
    true,
    null,
  ],
  [
    '1F58B-FE0F',
    'lower_left_fountain_pen',
    ['lower_left_fountain_pen'],
    'Objects',
    1260,
    0.7,
    true,
    null,
  ],
  [
    '1F58C-FE0F',
    'lower_left_paintbrush',
    ['lower_left_paintbrush'],
    'Objects',
    1262,
    0.7,
    true,
    null,
  ],
  ['1F58D-FE0F', 'lower_left_crayon', ['lower_left_crayon'], 'Objects', 1263, 0.7, true, null],
  [
    '1F590-FE0F',
    'raised_hand_with_fingers_splayed',
    ['raised_hand_with_fingers_splayed'],
    'People & Body',
    166,
    0.7,
    true,
    {
      '1F3FB': { unified: '1F590-1F3FB', symbol: '🖐🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F590-1F3FC', symbol: '🖐🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F590-1F3FD', symbol: '🖐🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F590-1F3FE', symbol: '🖐🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F590-1F3FF', symbol: '🖐🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F595',
    'middle_finger',
    ['middle_finger', 'reversed_hand_with_middle_finger_extended'],
    'People & Body',
    185,
    1,
    true,
    {
      '1F3FB': { unified: '1F595-1F3FB', symbol: '🖕🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F595-1F3FC', symbol: '🖕🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F595-1F3FD', symbol: '🖕🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F595-1F3FE', symbol: '🖕🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F595-1F3FF', symbol: '🖕🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F596',
    'spock-hand',
    ['spock-hand'],
    'People & Body',
    168,
    1,
    true,
    {
      '1F3FB': { unified: '1F596-1F3FB', symbol: '🖖🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F596-1F3FC', symbol: '🖖🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F596-1F3FD', symbol: '🖖🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F596-1F3FE', symbol: '🖖🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F596-1F3FF', symbol: '🖖🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F5A4', 'black_heart', ['black_heart'], 'Smileys & Emotion', 148, 3, true, null],
  ['1F5A5-FE0F', 'desktop_computer', ['desktop_computer'], 'Objects', 1192, 0.7, true, null],
  ['1F5A8-FE0F', 'printer', ['printer'], 'Objects', 1193, 0.7, true, null],
  ['1F5B1-FE0F', 'three_button_mouse', ['three_button_mouse'], 'Objects', 1195, 0.7, true, null],
  ['1F5B2-FE0F', 'trackball', ['trackball'], 'Objects', 1196, 0.7, true, null],
  ['1F5BC-FE0F', 'frame_with_picture', ['frame_with_picture'], 'Activities', 1104, 0.7, true, null],
  ['1F5C2-FE0F', 'card_index_dividers', ['card_index_dividers'], 'Objects', 1268, 0.7, true, null],
  ['1F5C3-FE0F', 'card_file_box', ['card_file_box'], 'Objects', 1285, 0.7, true, null],
  ['1F5C4-FE0F', 'file_cabinet', ['file_cabinet'], 'Objects', 1286, 0.7, true, null],
  ['1F5D1-FE0F', 'wastebasket', ['wastebasket'], 'Objects', 1287, 0.7, true, null],
  ['1F5D2-FE0F', 'spiral_note_pad', ['spiral_note_pad'], 'Objects', 1271, 0.7, true, null],
  ['1F5D3-FE0F', 'spiral_calendar_pad', ['spiral_calendar_pad'], 'Objects', 1272, 0.7, true, null],
  ['1F5DC-FE0F', 'compression', ['compression'], 'Objects', 1310, 0.7, true, null],
  ['1F5DD-FE0F', 'old_key', ['old_key'], 'Objects', 1293, 0.7, true, null],
  ['1F5DE-FE0F', 'rolled_up_newspaper', ['rolled_up_newspaper'], 'Objects', 1231, 0.7, true, null],
  ['1F5E1-FE0F', 'dagger_knife', ['dagger_knife'], 'Objects', 1299, 0.7, true, null],
  [
    '1F5E3-FE0F',
    'speaking_head_in_silhouette',
    ['speaking_head_in_silhouette'],
    'People & Body',
    520,
    0.7,
    true,
    null,
  ],
  [
    '1F5E8-FE0F',
    'left_speech_bubble',
    ['left_speech_bubble'],
    'Smileys & Emotion',
    160,
    2,
    true,
    null,
  ],
  [
    '1F5EF-FE0F',
    'right_anger_bubble',
    ['right_anger_bubble'],
    'Smileys & Emotion',
    161,
    0.7,
    true,
    null,
  ],
  [
    '1F5F3-FE0F',
    'ballot_box_with_ballot',
    ['ballot_box_with_ballot'],
    'Objects',
    1257,
    0.7,
    true,
    null,
  ],
  ['1F5FA-FE0F', 'world_map', ['world_map'], 'Travel & Places', 810, 0.7, true, null],
  ['1F5FB', 'mount_fuji', ['mount_fuji'], 'Travel & Places', 816, 0.6, true, null],
  ['1F5FC', 'tokyo_tower', ['tokyo_tower'], 'Travel & Places', 847, 0.6, true, null],
  ['1F5FD', 'statue_of_liberty', ['statue_of_liberty'], 'Travel & Places', 848, 0.6, true, null],
  ['1F5FE', 'japan', ['japan'], 'Travel & Places', 811, 0.6, true, null],
  ['1F5FF', 'moyai', ['moyai'], 'Objects', 1362, 0.6, true, null],
  ['1F600', 'grinning', ['grinning'], 'Smileys & Emotion', 1, 1, true, null],
  ['1F601', 'grin', ['grin'], 'Smileys & Emotion', 4, 0.6, true, null],
  ['1F602', 'joy', ['joy'], 'Smileys & Emotion', 8, 0.6, true, null],
  ['1F603', 'smiley', ['smiley'], 'Smileys & Emotion', 2, 0.6, true, null],
  ['1F604', 'smile', ['smile'], 'Smileys & Emotion', 3, 0.6, true, null],
  ['1F605', 'sweat_smile', ['sweat_smile'], 'Smileys & Emotion', 6, 0.6, true, null],
  ['1F606', 'laughing', ['laughing', 'satisfied'], 'Smileys & Emotion', 5, 0.6, true, null],
  ['1F607', 'innocent', ['innocent'], 'Smileys & Emotion', 14, 1, true, null],
  ['1F608', 'smiling_imp', ['smiling_imp'], 'Smileys & Emotion', 103, 1, true, null],
  ['1F609', 'wink', ['wink'], 'Smileys & Emotion', 12, 0.6, true, null],
  ['1F60A', 'blush', ['blush'], 'Smileys & Emotion', 13, 0.6, true, null],
  ['1F60B', 'yum', ['yum'], 'Smileys & Emotion', 24, 0.6, true, null],
  ['1F60C', 'relieved', ['relieved'], 'Smileys & Emotion', 50, 0.6, true, null],
  ['1F60D', 'heart_eyes', ['heart_eyes'], 'Smileys & Emotion', 16, 0.6, true, null],
  ['1F60E', 'sunglasses', ['sunglasses'], 'Smileys & Emotion', 70, 1, true, null],
  ['1F60F', 'smirk', ['smirk'], 'Smileys & Emotion', 44, 0.6, true, null],
  ['1F610', 'neutral_face', ['neutral_face'], 'Smileys & Emotion', 39, 0.7, true, null],
  ['1F611', 'expressionless', ['expressionless'], 'Smileys & Emotion', 40, 1, true, null],
  ['1F612', 'unamused', ['unamused'], 'Smileys & Emotion', 45, 0.6, true, null],
  ['1F613', 'sweat', ['sweat'], 'Smileys & Emotion', 95, 0.6, true, null],
  ['1F614', 'pensive', ['pensive'], 'Smileys & Emotion', 51, 0.6, true, null],
  ['1F615', 'confused', ['confused'], 'Smileys & Emotion', 73, 1, true, null],
  ['1F616', 'confounded', ['confounded'], 'Smileys & Emotion', 92, 0.6, true, null],
  ['1F617', 'kissing', ['kissing'], 'Smileys & Emotion', 19, 1, true, null],
  ['1F618', 'kissing_heart', ['kissing_heart'], 'Smileys & Emotion', 18, 0.6, true, null],
  [
    '1F619',
    'kissing_smiling_eyes',
    ['kissing_smiling_eyes'],
    'Smileys & Emotion',
    22,
    1,
    true,
    null,
  ],
  [
    '1F61A',
    'kissing_closed_eyes',
    ['kissing_closed_eyes'],
    'Smileys & Emotion',
    21,
    0.6,
    true,
    null,
  ],
  ['1F61B', 'stuck_out_tongue', ['stuck_out_tongue'], 'Smileys & Emotion', 25, 1, true, null],
  [
    '1F61C',
    'stuck_out_tongue_winking_eye',
    ['stuck_out_tongue_winking_eye'],
    'Smileys & Emotion',
    26,
    0.6,
    true,
    null,
  ],
  [
    '1F61D',
    'stuck_out_tongue_closed_eyes',
    ['stuck_out_tongue_closed_eyes'],
    'Smileys & Emotion',
    28,
    0.6,
    true,
    null,
  ],
  ['1F61E', 'disappointed', ['disappointed'], 'Smileys & Emotion', 94, 0.6, true, null],
  ['1F61F', 'worried', ['worried'], 'Smileys & Emotion', 75, 1, true, null],
  ['1F620', 'angry', ['angry'], 'Smileys & Emotion', 101, 0.6, true, null],
  ['1F621', 'rage', ['rage'], 'Smileys & Emotion', 100, 0.6, true, null],
  ['1F622', 'cry', ['cry'], 'Smileys & Emotion', 89, 0.6, true, null],
  ['1F623', 'persevere', ['persevere'], 'Smileys & Emotion', 93, 0.6, true, null],
  ['1F624', 'triumph', ['triumph'], 'Smileys & Emotion', 99, 0.6, true, null],
  [
    '1F625',
    'disappointed_relieved',
    ['disappointed_relieved'],
    'Smileys & Emotion',
    88,
    0.6,
    true,
    null,
  ],
  ['1F626', 'frowning', ['frowning'], 'Smileys & Emotion', 84, 1, true, null],
  ['1F627', 'anguished', ['anguished'], 'Smileys & Emotion', 85, 1, true, null],
  ['1F628', 'fearful', ['fearful'], 'Smileys & Emotion', 86, 0.6, true, null],
  ['1F629', 'weary', ['weary'], 'Smileys & Emotion', 96, 0.6, true, null],
  ['1F62A', 'sleepy', ['sleepy'], 'Smileys & Emotion', 52, 0.6, true, null],
  ['1F62B', 'tired_face', ['tired_face'], 'Smileys & Emotion', 97, 0.6, true, null],
  ['1F62C', 'grimacing', ['grimacing'], 'Smileys & Emotion', 47, 1, true, null],
  ['1F62D', 'sob', ['sob'], 'Smileys & Emotion', 90, 0.6, true, null],
  [
    '1F62E-200D-1F4A8',
    'face_exhaling',
    ['face_exhaling'],
    'Smileys & Emotion',
    48,
    13.1,
    true,
    null,
  ],
  ['1F62E', 'open_mouth', ['open_mouth'], 'Smileys & Emotion', 78, 1, true, null],
  ['1F62F', 'hushed', ['hushed'], 'Smileys & Emotion', 79, 1, true, null],
  ['1F630', 'cold_sweat', ['cold_sweat'], 'Smileys & Emotion', 87, 0.6, true, null],
  ['1F631', 'scream', ['scream'], 'Smileys & Emotion', 91, 0.6, true, null],
  ['1F632', 'astonished', ['astonished'], 'Smileys & Emotion', 80, 0.6, true, null],
  ['1F633', 'flushed', ['flushed'], 'Smileys & Emotion', 81, 0.6, true, null],
  ['1F634', 'sleeping', ['sleeping'], 'Smileys & Emotion', 54, 1, true, null],
  [
    '1F635-200D-1F4AB',
    'face_with_spiral_eyes',
    ['face_with_spiral_eyes'],
    'Smileys & Emotion',
    65,
    13.1,
    true,
    null,
  ],
  ['1F635', 'dizzy_face', ['dizzy_face'], 'Smileys & Emotion', 64, 0.6, true, null],
  [
    '1F636-200D-1F32B-FE0F',
    'face_in_clouds',
    ['face_in_clouds'],
    'Smileys & Emotion',
    43,
    13.1,
    true,
    null,
  ],
  ['1F636', 'no_mouth', ['no_mouth'], 'Smileys & Emotion', 41, 1, true, null],
  ['1F637', 'mask', ['mask'], 'Smileys & Emotion', 55, 0.6, true, null],
  ['1F638', 'smile_cat', ['smile_cat'], 'Smileys & Emotion', 116, 0.6, true, null],
  ['1F639', 'joy_cat', ['joy_cat'], 'Smileys & Emotion', 117, 0.6, true, null],
  ['1F63A', 'smiley_cat', ['smiley_cat'], 'Smileys & Emotion', 115, 0.6, true, null],
  ['1F63B', 'heart_eyes_cat', ['heart_eyes_cat'], 'Smileys & Emotion', 118, 0.6, true, null],
  ['1F63C', 'smirk_cat', ['smirk_cat'], 'Smileys & Emotion', 119, 0.6, true, null],
  ['1F63D', 'kissing_cat', ['kissing_cat'], 'Smileys & Emotion', 120, 0.6, true, null],
  ['1F63E', 'pouting_cat', ['pouting_cat'], 'Smileys & Emotion', 123, 0.6, true, null],
  ['1F63F', 'crying_cat_face', ['crying_cat_face'], 'Smileys & Emotion', 122, 0.6, true, null],
  ['1F640', 'scream_cat', ['scream_cat'], 'Smileys & Emotion', 121, 0.6, true, null],
  [
    '1F641',
    'slightly_frowning_face',
    ['slightly_frowning_face'],
    'Smileys & Emotion',
    76,
    1,
    true,
    null,
  ],
  [
    '1F642',
    'slightly_smiling_face',
    ['slightly_smiling_face'],
    'Smileys & Emotion',
    9,
    1,
    true,
    null,
  ],
  ['1F643', 'upside_down_face', ['upside_down_face'], 'Smileys & Emotion', 10, 1, true, null],
  [
    '1F644',
    'face_with_rolling_eyes',
    ['face_with_rolling_eyes'],
    'Smileys & Emotion',
    46,
    1,
    true,
    null,
  ],
  [
    '1F645-200D-2640-FE0F',
    'woman-gesturing-no',
    ['woman-gesturing-no'],
    'People & Body',
    259,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F645-1F3FB-200D-2640-FE0F',
        symbol: '🙅🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F645-1F3FC-200D-2640-FE0F',
        symbol: '🙅🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F645-1F3FD-200D-2640-FE0F',
        symbol: '🙅🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F645-1F3FE-200D-2640-FE0F',
        symbol: '🙅🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F645-1F3FF-200D-2640-FE0F',
        symbol: '🙅🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F645-200D-2642-FE0F',
    'man-gesturing-no',
    ['man-gesturing-no'],
    'People & Body',
    258,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F645-1F3FB-200D-2642-FE0F',
        symbol: '🙅🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F645-1F3FC-200D-2642-FE0F',
        symbol: '🙅🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F645-1F3FD-200D-2642-FE0F',
        symbol: '🙅🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F645-1F3FE-200D-2642-FE0F',
        symbol: '🙅🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F645-1F3FF-200D-2642-FE0F',
        symbol: '🙅🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F645',
    'no_good',
    ['no_good'],
    'People & Body',
    257,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F645-1F3FB', symbol: '🙅🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F645-1F3FC', symbol: '🙅🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F645-1F3FD', symbol: '🙅🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F645-1F3FE', symbol: '🙅🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F645-1F3FF', symbol: '🙅🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F646-200D-2640-FE0F',
    'woman-gesturing-ok',
    ['woman-gesturing-ok'],
    'People & Body',
    262,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F646-1F3FB-200D-2640-FE0F',
        symbol: '🙆🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F646-1F3FC-200D-2640-FE0F',
        symbol: '🙆🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F646-1F3FD-200D-2640-FE0F',
        symbol: '🙆🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F646-1F3FE-200D-2640-FE0F',
        symbol: '🙆🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F646-1F3FF-200D-2640-FE0F',
        symbol: '🙆🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F646-200D-2642-FE0F',
    'man-gesturing-ok',
    ['man-gesturing-ok'],
    'People & Body',
    261,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F646-1F3FB-200D-2642-FE0F',
        symbol: '🙆🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F646-1F3FC-200D-2642-FE0F',
        symbol: '🙆🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F646-1F3FD-200D-2642-FE0F',
        symbol: '🙆🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F646-1F3FE-200D-2642-FE0F',
        symbol: '🙆🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F646-1F3FF-200D-2642-FE0F',
        symbol: '🙆🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F646',
    'ok_woman',
    ['ok_woman'],
    'People & Body',
    260,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F646-1F3FB', symbol: '🙆🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F646-1F3FC', symbol: '🙆🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F646-1F3FD', symbol: '🙆🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F646-1F3FE', symbol: '🙆🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F646-1F3FF', symbol: '🙆🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F647-200D-2640-FE0F',
    'woman-bowing',
    ['woman-bowing'],
    'People & Body',
    274,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F647-1F3FB-200D-2640-FE0F',
        symbol: '🙇🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F647-1F3FC-200D-2640-FE0F',
        symbol: '🙇🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F647-1F3FD-200D-2640-FE0F',
        symbol: '🙇🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F647-1F3FE-200D-2640-FE0F',
        symbol: '🙇🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F647-1F3FF-200D-2640-FE0F',
        symbol: '🙇🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F647-200D-2642-FE0F',
    'man-bowing',
    ['man-bowing'],
    'People & Body',
    273,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F647-1F3FB-200D-2642-FE0F',
        symbol: '🙇🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F647-1F3FC-200D-2642-FE0F',
        symbol: '🙇🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F647-1F3FD-200D-2642-FE0F',
        symbol: '🙇🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F647-1F3FE-200D-2642-FE0F',
        symbol: '🙇🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F647-1F3FF-200D-2642-FE0F',
        symbol: '🙇🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F647',
    'bow',
    ['bow'],
    'People & Body',
    272,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F647-1F3FB', symbol: '🙇🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F647-1F3FC', symbol: '🙇🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F647-1F3FD', symbol: '🙇🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F647-1F3FE', symbol: '🙇🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F647-1F3FF', symbol: '🙇🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F648', 'see_no_evil', ['see_no_evil'], 'Smileys & Emotion', 124, 0.6, true, null],
  ['1F649', 'hear_no_evil', ['hear_no_evil'], 'Smileys & Emotion', 125, 0.6, true, null],
  ['1F64A', 'speak_no_evil', ['speak_no_evil'], 'Smileys & Emotion', 126, 0.6, true, null],
  [
    '1F64B-200D-2640-FE0F',
    'woman-raising-hand',
    ['woman-raising-hand'],
    'People & Body',
    268,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F64B-1F3FB-200D-2640-FE0F',
        symbol: '🙋🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F64B-1F3FC-200D-2640-FE0F',
        symbol: '🙋🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F64B-1F3FD-200D-2640-FE0F',
        symbol: '🙋🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F64B-1F3FE-200D-2640-FE0F',
        symbol: '🙋🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F64B-1F3FF-200D-2640-FE0F',
        symbol: '🙋🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F64B-200D-2642-FE0F',
    'man-raising-hand',
    ['man-raising-hand'],
    'People & Body',
    267,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F64B-1F3FB-200D-2642-FE0F',
        symbol: '🙋🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F64B-1F3FC-200D-2642-FE0F',
        symbol: '🙋🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F64B-1F3FD-200D-2642-FE0F',
        symbol: '🙋🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F64B-1F3FE-200D-2642-FE0F',
        symbol: '🙋🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F64B-1F3FF-200D-2642-FE0F',
        symbol: '🙋🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F64B',
    'raising_hand',
    ['raising_hand'],
    'People & Body',
    266,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F64B-1F3FB', symbol: '🙋🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F64B-1F3FC', symbol: '🙋🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F64B-1F3FD', symbol: '🙋🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F64B-1F3FE', symbol: '🙋🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F64B-1F3FF', symbol: '🙋🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F64C',
    'raised_hands',
    ['raised_hands'],
    'People & Body',
    196,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F64C-1F3FB', symbol: '🙌🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F64C-1F3FC', symbol: '🙌🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F64C-1F3FD', symbol: '🙌🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F64C-1F3FE', symbol: '🙌🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F64C-1F3FF', symbol: '🙌🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F64D-200D-2640-FE0F',
    'woman-frowning',
    ['woman-frowning'],
    'People & Body',
    253,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F64D-1F3FB-200D-2640-FE0F',
        symbol: '🙍🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F64D-1F3FC-200D-2640-FE0F',
        symbol: '🙍🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F64D-1F3FD-200D-2640-FE0F',
        symbol: '🙍🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F64D-1F3FE-200D-2640-FE0F',
        symbol: '🙍🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F64D-1F3FF-200D-2640-FE0F',
        symbol: '🙍🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F64D-200D-2642-FE0F',
    'man-frowning',
    ['man-frowning'],
    'People & Body',
    252,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F64D-1F3FB-200D-2642-FE0F',
        symbol: '🙍🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F64D-1F3FC-200D-2642-FE0F',
        symbol: '🙍🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F64D-1F3FD-200D-2642-FE0F',
        symbol: '🙍🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F64D-1F3FE-200D-2642-FE0F',
        symbol: '🙍🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F64D-1F3FF-200D-2642-FE0F',
        symbol: '🙍🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F64D',
    'person_frowning',
    ['person_frowning'],
    'People & Body',
    251,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F64D-1F3FB', symbol: '🙍🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F64D-1F3FC', symbol: '🙍🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F64D-1F3FD', symbol: '🙍🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F64D-1F3FE', symbol: '🙍🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F64D-1F3FF', symbol: '🙍🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F64E-200D-2640-FE0F',
    'woman-pouting',
    ['woman-pouting'],
    'People & Body',
    256,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F64E-1F3FB-200D-2640-FE0F',
        symbol: '🙎🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F64E-1F3FC-200D-2640-FE0F',
        symbol: '🙎🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F64E-1F3FD-200D-2640-FE0F',
        symbol: '🙎🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F64E-1F3FE-200D-2640-FE0F',
        symbol: '🙎🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F64E-1F3FF-200D-2640-FE0F',
        symbol: '🙎🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F64E-200D-2642-FE0F',
    'man-pouting',
    ['man-pouting'],
    'People & Body',
    255,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F64E-1F3FB-200D-2642-FE0F',
        symbol: '🙎🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F64E-1F3FC-200D-2642-FE0F',
        symbol: '🙎🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F64E-1F3FD-200D-2642-FE0F',
        symbol: '🙎🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F64E-1F3FE-200D-2642-FE0F',
        symbol: '🙎🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F64E-1F3FF-200D-2642-FE0F',
        symbol: '🙎🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F64E',
    'person_with_pouting_face',
    ['person_with_pouting_face'],
    'People & Body',
    254,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F64E-1F3FB', symbol: '🙎🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F64E-1F3FC', symbol: '🙎🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F64E-1F3FD', symbol: '🙎🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F64E-1F3FE', symbol: '🙎🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F64E-1F3FF', symbol: '🙎🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F64F',
    'pray',
    ['pray'],
    'People & Body',
    201,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F64F-1F3FB', symbol: '🙏🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F64F-1F3FC', symbol: '🙏🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F64F-1F3FD', symbol: '🙏🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F64F-1F3FE', symbol: '🙏🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F64F-1F3FF', symbol: '🙏🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F680', 'rocket', ['rocket'], 'Travel & Places', 942, 0.6, true, null],
  ['1F681', 'helicopter', ['helicopter'], 'Travel & Places', 937, 1, true, null],
  ['1F682', 'steam_locomotive', ['steam_locomotive'], 'Travel & Places', 872, 1, true, null],
  ['1F683', 'railway_car', ['railway_car'], 'Travel & Places', 873, 0.6, true, null],
  ['1F684', 'bullettrain_side', ['bullettrain_side'], 'Travel & Places', 874, 0.6, true, null],
  ['1F685', 'bullettrain_front', ['bullettrain_front'], 'Travel & Places', 875, 0.6, true, null],
  ['1F686', 'train2', ['train2'], 'Travel & Places', 876, 1, true, null],
  ['1F687', 'metro', ['metro'], 'Travel & Places', 877, 0.6, true, null],
  ['1F688', 'light_rail', ['light_rail'], 'Travel & Places', 878, 1, true, null],
  ['1F689', 'station', ['station'], 'Travel & Places', 879, 0.6, true, null],
  ['1F68A', 'tram', ['tram'], 'Travel & Places', 880, 1, true, null],
  ['1F68B', 'train', ['train'], 'Travel & Places', 883, 1, true, null],
  ['1F68C', 'bus', ['bus'], 'Travel & Places', 884, 0.6, true, null],
  ['1F68D', 'oncoming_bus', ['oncoming_bus'], 'Travel & Places', 885, 0.7, true, null],
  ['1F68E', 'trolleybus', ['trolleybus'], 'Travel & Places', 886, 1, true, null],
  ['1F68F', 'busstop', ['busstop'], 'Travel & Places', 911, 0.6, true, null],
  ['1F690', 'minibus', ['minibus'], 'Travel & Places', 887, 1, true, null],
  ['1F691', 'ambulance', ['ambulance'], 'Travel & Places', 888, 0.6, true, null],
  ['1F692', 'fire_engine', ['fire_engine'], 'Travel & Places', 889, 0.6, true, null],
  ['1F693', 'police_car', ['police_car'], 'Travel & Places', 890, 0.6, true, null],
  [
    '1F694',
    'oncoming_police_car',
    ['oncoming_police_car'],
    'Travel & Places',
    891,
    0.7,
    true,
    null,
  ],
  ['1F695', 'taxi', ['taxi'], 'Travel & Places', 892, 0.6, true, null],
  ['1F696', 'oncoming_taxi', ['oncoming_taxi'], 'Travel & Places', 893, 1, true, null],
  ['1F697', 'car', ['car', 'red_car'], 'Travel & Places', 894, 0.6, true, null],
  [
    '1F698',
    'oncoming_automobile',
    ['oncoming_automobile'],
    'Travel & Places',
    895,
    0.7,
    true,
    null,
  ],
  ['1F699', 'blue_car', ['blue_car'], 'Travel & Places', 896, 0.6, true, null],
  ['1F69A', 'truck', ['truck'], 'Travel & Places', 898, 0.6, true, null],
  ['1F69B', 'articulated_lorry', ['articulated_lorry'], 'Travel & Places', 899, 1, true, null],
  ['1F69C', 'tractor', ['tractor'], 'Travel & Places', 900, 1, true, null],
  ['1F69D', 'monorail', ['monorail'], 'Travel & Places', 881, 1, true, null],
  ['1F69E', 'mountain_railway', ['mountain_railway'], 'Travel & Places', 882, 1, true, null],
  ['1F69F', 'suspension_railway', ['suspension_railway'], 'Travel & Places', 938, 1, true, null],
  ['1F6A0', 'mountain_cableway', ['mountain_cableway'], 'Travel & Places', 939, 1, true, null],
  ['1F6A1', 'aerial_tramway', ['aerial_tramway'], 'Travel & Places', 940, 1, true, null],
  ['1F6A2', 'ship', ['ship'], 'Travel & Places', 930, 0.6, true, null],
  [
    '1F6A3-200D-2640-FE0F',
    'woman-rowing-boat',
    ['woman-rowing-boat'],
    'People & Body',
    446,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F6A3-1F3FB-200D-2640-FE0F',
        symbol: '🚣🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F6A3-1F3FC-200D-2640-FE0F',
        symbol: '🚣🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F6A3-1F3FD-200D-2640-FE0F',
        symbol: '🚣🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F6A3-1F3FE-200D-2640-FE0F',
        symbol: '🚣🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F6A3-1F3FF-200D-2640-FE0F',
        symbol: '🚣🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F6A3-200D-2642-FE0F',
    'man-rowing-boat',
    ['man-rowing-boat'],
    'People & Body',
    445,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F6A3-1F3FB-200D-2642-FE0F',
        symbol: '🚣🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F6A3-1F3FC-200D-2642-FE0F',
        symbol: '🚣🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F6A3-1F3FD-200D-2642-FE0F',
        symbol: '🚣🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F6A3-1F3FE-200D-2642-FE0F',
        symbol: '🚣🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F6A3-1F3FF-200D-2642-FE0F',
        symbol: '🚣🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F6A3',
    'rowboat',
    ['rowboat'],
    'People & Body',
    444,
    1,
    true,
    {
      '1F3FB': { unified: '1F6A3-1F3FB', symbol: '🚣🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F6A3-1F3FC', symbol: '🚣🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F6A3-1F3FD', symbol: '🚣🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F6A3-1F3FE', symbol: '🚣🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F6A3-1F3FF', symbol: '🚣🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F6A4', 'speedboat', ['speedboat'], 'Travel & Places', 926, 0.6, true, null],
  ['1F6A5', 'traffic_light', ['traffic_light'], 'Travel & Places', 918, 0.6, true, null],
  [
    '1F6A6',
    'vertical_traffic_light',
    ['vertical_traffic_light'],
    'Travel & Places',
    919,
    1,
    true,
    null,
  ],
  ['1F6A7', 'construction', ['construction'], 'Travel & Places', 921, 0.6, true, null],
  ['1F6A8', 'rotating_light', ['rotating_light'], 'Travel & Places', 917, 0.6, true, null],
  ['1F6A9', 'triangular_flag_on_post', ['triangular_flag_on_post'], 'Flags', 1587, 0.6, true, null],
  ['1F6AA', 'door', ['door'], 'Objects', 1333, 0.6, true, null],
  ['1F6AB', 'no_entry_sign', ['no_entry_sign'], 'Symbols', 1381, 0.6, true, null],
  ['1F6AC', 'smoking', ['smoking'], 'Objects', 1358, 0.6, true, null],
  ['1F6AD', 'no_smoking', ['no_smoking'], 'Symbols', 1383, 0.6, true, null],
  ['1F6AE', 'put_litter_in_its_place', ['put_litter_in_its_place'], 'Symbols', 1366, 1, true, null],
  ['1F6AF', 'do_not_litter', ['do_not_litter'], 'Symbols', 1384, 1, true, null],
  ['1F6B0', 'potable_water', ['potable_water'], 'Symbols', 1367, 1, true, null],
  ['1F6B1', 'non-potable_water', ['non-potable_water'], 'Symbols', 1385, 1, true, null],
  ['1F6B2', 'bike', ['bike'], 'Travel & Places', 907, 0.6, true, null],
  ['1F6B3', 'no_bicycles', ['no_bicycles'], 'Symbols', 1382, 1, true, null],
  [
    '1F6B4-200D-2640-FE0F',
    'woman-biking',
    ['woman-biking'],
    'People & Body',
    458,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F6B4-1F3FB-200D-2640-FE0F',
        symbol: '🚴🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F6B4-1F3FC-200D-2640-FE0F',
        symbol: '🚴🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F6B4-1F3FD-200D-2640-FE0F',
        symbol: '🚴🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F6B4-1F3FE-200D-2640-FE0F',
        symbol: '🚴🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F6B4-1F3FF-200D-2640-FE0F',
        symbol: '🚴🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F6B4-200D-2642-FE0F',
    'man-biking',
    ['man-biking'],
    'People & Body',
    457,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F6B4-1F3FB-200D-2642-FE0F',
        symbol: '🚴🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F6B4-1F3FC-200D-2642-FE0F',
        symbol: '🚴🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F6B4-1F3FD-200D-2642-FE0F',
        symbol: '🚴🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F6B4-1F3FE-200D-2642-FE0F',
        symbol: '🚴🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F6B4-1F3FF-200D-2642-FE0F',
        symbol: '🚴🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F6B4',
    'bicyclist',
    ['bicyclist'],
    'People & Body',
    456,
    1,
    true,
    {
      '1F3FB': { unified: '1F6B4-1F3FB', symbol: '🚴🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F6B4-1F3FC', symbol: '🚴🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F6B4-1F3FD', symbol: '🚴🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F6B4-1F3FE', symbol: '🚴🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F6B4-1F3FF', symbol: '🚴🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F6B5-200D-2640-FE0F',
    'woman-mountain-biking',
    ['woman-mountain-biking'],
    'People & Body',
    461,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F6B5-1F3FB-200D-2640-FE0F',
        symbol: '🚵🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F6B5-1F3FC-200D-2640-FE0F',
        symbol: '🚵🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F6B5-1F3FD-200D-2640-FE0F',
        symbol: '🚵🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F6B5-1F3FE-200D-2640-FE0F',
        symbol: '🚵🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F6B5-1F3FF-200D-2640-FE0F',
        symbol: '🚵🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F6B5-200D-2642-FE0F',
    'man-mountain-biking',
    ['man-mountain-biking'],
    'People & Body',
    460,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F6B5-1F3FB-200D-2642-FE0F',
        symbol: '🚵🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F6B5-1F3FC-200D-2642-FE0F',
        symbol: '🚵🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F6B5-1F3FD-200D-2642-FE0F',
        symbol: '🚵🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F6B5-1F3FE-200D-2642-FE0F',
        symbol: '🚵🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F6B5-1F3FF-200D-2642-FE0F',
        symbol: '🚵🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F6B5',
    'mountain_bicyclist',
    ['mountain_bicyclist'],
    'People & Body',
    459,
    1,
    true,
    {
      '1F3FB': { unified: '1F6B5-1F3FB', symbol: '🚵🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F6B5-1F3FC', symbol: '🚵🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F6B5-1F3FD', symbol: '🚵🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F6B5-1F3FE', symbol: '🚵🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F6B5-1F3FF', symbol: '🚵🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F6B6-200D-2640-FE0F',
    'woman-walking',
    ['woman-walking'],
    'People & Body',
    403,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F6B6-1F3FB-200D-2640-FE0F',
        symbol: '🚶🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F6B6-1F3FC-200D-2640-FE0F',
        symbol: '🚶🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F6B6-1F3FD-200D-2640-FE0F',
        symbol: '🚶🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F6B6-1F3FE-200D-2640-FE0F',
        symbol: '🚶🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F6B6-1F3FF-200D-2640-FE0F',
        symbol: '🚶🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F6B6-200D-2642-FE0F',
    'man-walking',
    ['man-walking'],
    'People & Body',
    402,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F6B6-1F3FB-200D-2642-FE0F',
        symbol: '🚶🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F6B6-1F3FC-200D-2642-FE0F',
        symbol: '🚶🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F6B6-1F3FD-200D-2642-FE0F',
        symbol: '🚶🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F6B6-1F3FE-200D-2642-FE0F',
        symbol: '🚶🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F6B6-1F3FF-200D-2642-FE0F',
        symbol: '🚶🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F6B6',
    'walking',
    ['walking'],
    'People & Body',
    401,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F6B6-1F3FB', symbol: '🚶🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F6B6-1F3FC', symbol: '🚶🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F6B6-1F3FD', symbol: '🚶🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F6B6-1F3FE', symbol: '🚶🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F6B6-1F3FF', symbol: '🚶🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F6B7', 'no_pedestrians', ['no_pedestrians'], 'Symbols', 1386, 1, true, null],
  ['1F6B8', 'children_crossing', ['children_crossing'], 'Symbols', 1379, 1, true, null],
  ['1F6B9', 'mens', ['mens'], 'Symbols', 1369, 0.6, true, null],
  ['1F6BA', 'womens', ['womens'], 'Symbols', 1370, 0.6, true, null],
  ['1F6BB', 'restroom', ['restroom'], 'Symbols', 1371, 0.6, true, null],
  ['1F6BC', 'baby_symbol', ['baby_symbol'], 'Symbols', 1372, 0.6, true, null],
  ['1F6BD', 'toilet', ['toilet'], 'Objects', 1340, 0.6, true, null],
  ['1F6BE', 'wc', ['wc'], 'Symbols', 1373, 0.6, true, null],
  ['1F6BF', 'shower', ['shower'], 'Objects', 1342, 1, true, null],
  [
    '1F6C0',
    'bath',
    ['bath'],
    'People & Body',
    480,
    0.6,
    true,
    {
      '1F3FB': { unified: '1F6C0-1F3FB', symbol: '🛀🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F6C0-1F3FC', symbol: '🛀🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F6C0-1F3FD', symbol: '🛀🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F6C0-1F3FE', symbol: '🛀🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F6C0-1F3FF', symbol: '🛀🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['1F6C1', 'bathtub', ['bathtub'], 'Objects', 1343, 1, true, null],
  ['1F6C2', 'passport_control', ['passport_control'], 'Symbols', 1374, 1, true, null],
  ['1F6C3', 'customs', ['customs'], 'Symbols', 1375, 1, true, null],
  ['1F6C4', 'baggage_claim', ['baggage_claim'], 'Symbols', 1376, 1, true, null],
  ['1F6C5', 'left_luggage', ['left_luggage'], 'Symbols', 1377, 1, true, null],
  ['1F6CB-FE0F', 'couch_and_lamp', ['couch_and_lamp'], 'Objects', 1338, 0.7, true, null],
  [
    '1F6CC',
    'sleeping_accommodation',
    ['sleeping_accommodation'],
    'People & Body',
    481,
    1,
    true,
    {
      '1F3FB': { unified: '1F6CC-1F3FB', symbol: '🛌🏻', addedIn: 4, hasImgTwitter: true },
      '1F3FC': { unified: '1F6CC-1F3FC', symbol: '🛌🏼', addedIn: 4, hasImgTwitter: true },
      '1F3FD': { unified: '1F6CC-1F3FD', symbol: '🛌🏽', addedIn: 4, hasImgTwitter: true },
      '1F3FE': { unified: '1F6CC-1F3FE', symbol: '🛌🏾', addedIn: 4, hasImgTwitter: true },
      '1F3FF': { unified: '1F6CC-1F3FF', symbol: '🛌🏿', addedIn: 4, hasImgTwitter: true },
    },
  ],
  ['1F6CD-FE0F', 'shopping_bags', ['shopping_bags'], 'Objects', 1133, 0.7, true, null],
  ['1F6CE-FE0F', 'bellhop_bell', ['bellhop_bell'], 'Travel & Places', 944, 0.7, true, null],
  ['1F6CF-FE0F', 'bed', ['bed'], 'Objects', 1337, 0.7, true, null],
  ['1F6D0', 'place_of_worship', ['place_of_worship'], 'Symbols', 1412, 1, true, null],
  ['1F6D1', 'octagonal_sign', ['octagonal_sign'], 'Travel & Places', 920, 3, true, null],
  ['1F6D2', 'shopping_trolley', ['shopping_trolley'], 'Objects', 1357, 3, true, null],
  ['1F6D5', 'hindu_temple', ['hindu_temple'], 'Travel & Places', 851, 12, true, null],
  ['1F6D6', 'hut', ['hut'], 'Travel & Places', 828, 13, true, null],
  ['1F6D7', 'elevator', ['elevator'], 'Objects', 1334, 13, true, null],
  ['1F6DD', 'playground_slide', ['playground_slide'], 'Travel & Places', 867, 14, true, null],
  ['1F6DE', 'wheel', ['wheel'], 'Travel & Places', 916, 14, true, null],
  ['1F6DF', 'ring_buoy', ['ring_buoy'], 'Travel & Places', 923, 14, true, null],
  ['1F6E0-FE0F', 'hammer_and_wrench', ['hammer_and_wrench'], 'Objects', 1298, 0.7, true, null],
  ['1F6E1-FE0F', 'shield', ['shield'], 'Objects', 1304, 0.7, true, null],
  ['1F6E2-FE0F', 'oil_drum', ['oil_drum'], 'Travel & Places', 914, 0.7, true, null],
  ['1F6E3-FE0F', 'motorway', ['motorway'], 'Travel & Places', 912, 0.7, true, null],
  ['1F6E4-FE0F', 'railway_track', ['railway_track'], 'Travel & Places', 913, 0.7, true, null],
  ['1F6E5-FE0F', 'motor_boat', ['motor_boat'], 'Travel & Places', 929, 0.7, true, null],
  ['1F6E9-FE0F', 'small_airplane', ['small_airplane'], 'Travel & Places', 932, 0.7, true, null],
  ['1F6EB', 'airplane_departure', ['airplane_departure'], 'Travel & Places', 933, 1, true, null],
  ['1F6EC', 'airplane_arriving', ['airplane_arriving'], 'Travel & Places', 934, 1, true, null],
  ['1F6F0-FE0F', 'satellite', ['satellite'], 'Travel & Places', 941, 0.7, true, null],
  ['1F6F3-FE0F', 'passenger_ship', ['passenger_ship'], 'Travel & Places', 927, 0.7, true, null],
  ['1F6F4', 'scooter', ['scooter'], 'Travel & Places', 908, 3, true, null],
  ['1F6F5', 'motor_scooter', ['motor_scooter'], 'Travel & Places', 903, 3, true, null],
  ['1F6F6', 'canoe', ['canoe'], 'Travel & Places', 925, 3, true, null],
  ['1F6F7', 'sled', ['sled'], 'Activities', 1076, 5, true, null],
  ['1F6F8', 'flying_saucer', ['flying_saucer'], 'Travel & Places', 943, 5, true, null],
  ['1F6F9', 'skateboard', ['skateboard'], 'Travel & Places', 909, 11, true, null],
  ['1F6FA', 'auto_rickshaw', ['auto_rickshaw'], 'Travel & Places', 906, 12, true, null],
  ['1F6FB', 'pickup_truck', ['pickup_truck'], 'Travel & Places', 897, 13, true, null],
  ['1F6FC', 'roller_skate', ['roller_skate'], 'Travel & Places', 910, 13, true, null],
  ['1F7E0', 'large_orange_circle', ['large_orange_circle'], 'Symbols', 1553, 12, true, null],
  ['1F7E1', 'large_yellow_circle', ['large_yellow_circle'], 'Symbols', 1554, 12, true, null],
  ['1F7E2', 'large_green_circle', ['large_green_circle'], 'Symbols', 1555, 12, true, null],
  ['1F7E3', 'large_purple_circle', ['large_purple_circle'], 'Symbols', 1557, 12, true, null],
  ['1F7E4', 'large_brown_circle', ['large_brown_circle'], 'Symbols', 1558, 12, true, null],
  ['1F7E5', 'large_red_square', ['large_red_square'], 'Symbols', 1561, 12, true, null],
  ['1F7E6', 'large_blue_square', ['large_blue_square'], 'Symbols', 1565, 12, true, null],
  ['1F7E7', 'large_orange_square', ['large_orange_square'], 'Symbols', 1562, 12, true, null],
  ['1F7E8', 'large_yellow_square', ['large_yellow_square'], 'Symbols', 1563, 12, true, null],
  ['1F7E9', 'large_green_square', ['large_green_square'], 'Symbols', 1564, 12, true, null],
  ['1F7EA', 'large_purple_square', ['large_purple_square'], 'Symbols', 1566, 12, true, null],
  ['1F7EB', 'large_brown_square', ['large_brown_square'], 'Symbols', 1567, 12, true, null],
  ['1F7F0', 'heavy_equals_sign', ['heavy_equals_sign'], 'Symbols', 1468, 14, true, null],
  [
    '1F90C',
    'pinched_fingers',
    ['pinched_fingers'],
    'People & Body',
    174,
    13,
    true,
    {
      '1F3FB': { unified: '1F90C-1F3FB', symbol: '🤌🏻', addedIn: 13, hasImgTwitter: true },
      '1F3FC': { unified: '1F90C-1F3FC', symbol: '🤌🏼', addedIn: 13, hasImgTwitter: true },
      '1F3FD': { unified: '1F90C-1F3FD', symbol: '🤌🏽', addedIn: 13, hasImgTwitter: true },
      '1F3FE': { unified: '1F90C-1F3FE', symbol: '🤌🏾', addedIn: 13, hasImgTwitter: true },
      '1F3FF': { unified: '1F90C-1F3FF', symbol: '🤌🏿', addedIn: 13, hasImgTwitter: true },
    },
  ],
  ['1F90D', 'white_heart', ['white_heart'], 'Smileys & Emotion', 149, 12, true, null],
  ['1F90E', 'brown_heart', ['brown_heart'], 'Smileys & Emotion', 147, 12, true, null],
  [
    '1F90F',
    'pinching_hand',
    ['pinching_hand'],
    'People & Body',
    175,
    12,
    true,
    {
      '1F3FB': { unified: '1F90F-1F3FB', symbol: '🤏🏻', addedIn: 12, hasImgTwitter: true },
      '1F3FC': { unified: '1F90F-1F3FC', symbol: '🤏🏼', addedIn: 12, hasImgTwitter: true },
      '1F3FD': { unified: '1F90F-1F3FD', symbol: '🤏🏽', addedIn: 12, hasImgTwitter: true },
      '1F3FE': { unified: '1F90F-1F3FE', symbol: '🤏🏾', addedIn: 12, hasImgTwitter: true },
      '1F3FF': { unified: '1F90F-1F3FF', symbol: '🤏🏿', addedIn: 12, hasImgTwitter: true },
    },
  ],
  ['1F910', 'zipper_mouth_face', ['zipper_mouth_face'], 'Smileys & Emotion', 37, 1, true, null],
  ['1F911', 'money_mouth_face', ['money_mouth_face'], 'Smileys & Emotion', 29, 1, true, null],
  [
    '1F912',
    'face_with_thermometer',
    ['face_with_thermometer'],
    'Smileys & Emotion',
    56,
    1,
    true,
    null,
  ],
  ['1F913', 'nerd_face', ['nerd_face'], 'Smileys & Emotion', 71, 1, true, null],
  ['1F914', 'thinking_face', ['thinking_face'], 'Smileys & Emotion', 35, 1, true, null],
  [
    '1F915',
    'face_with_head_bandage',
    ['face_with_head_bandage'],
    'Smileys & Emotion',
    57,
    1,
    true,
    null,
  ],
  ['1F916', 'robot_face', ['robot_face'], 'Smileys & Emotion', 114, 1, true, null],
  ['1F917', 'hugging_face', ['hugging_face'], 'Smileys & Emotion', 30, 1, true, null],
  [
    '1F918',
    'the_horns',
    ['the_horns', 'sign_of_the_horns'],
    'People & Body',
    180,
    1,
    true,
    {
      '1F3FB': { unified: '1F918-1F3FB', symbol: '🤘🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '1F918-1F3FC', symbol: '🤘🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '1F918-1F3FD', symbol: '🤘🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '1F918-1F3FE', symbol: '🤘🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '1F918-1F3FF', symbol: '🤘🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '1F919',
    'call_me_hand',
    ['call_me_hand'],
    'People & Body',
    181,
    3,
    true,
    {
      '1F3FB': { unified: '1F919-1F3FB', symbol: '🤙🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F919-1F3FC', symbol: '🤙🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F919-1F3FD', symbol: '🤙🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F919-1F3FE', symbol: '🤙🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F919-1F3FF', symbol: '🤙🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  [
    '1F91A',
    'raised_back_of_hand',
    ['raised_back_of_hand'],
    'People & Body',
    165,
    3,
    true,
    {
      '1F3FB': { unified: '1F91A-1F3FB', symbol: '🤚🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F91A-1F3FC', symbol: '🤚🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F91A-1F3FD', symbol: '🤚🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F91A-1F3FE', symbol: '🤚🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F91A-1F3FF', symbol: '🤚🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  [
    '1F91B',
    'left-facing_fist',
    ['left-facing_fist'],
    'People & Body',
    193,
    3,
    true,
    {
      '1F3FB': { unified: '1F91B-1F3FB', symbol: '🤛🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F91B-1F3FC', symbol: '🤛🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F91B-1F3FD', symbol: '🤛🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F91B-1F3FE', symbol: '🤛🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F91B-1F3FF', symbol: '🤛🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  [
    '1F91C',
    'right-facing_fist',
    ['right-facing_fist'],
    'People & Body',
    194,
    3,
    true,
    {
      '1F3FB': { unified: '1F91C-1F3FB', symbol: '🤜🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F91C-1F3FC', symbol: '🤜🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F91C-1F3FD', symbol: '🤜🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F91C-1F3FE', symbol: '🤜🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F91C-1F3FF', symbol: '🤜🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  [
    '1F91D',
    'handshake',
    ['handshake'],
    'People & Body',
    200,
    3,
    true,
    {
      '1F3FB': { unified: '1F91D-1F3FB', symbol: '🤝🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F91D-1F3FC', symbol: '🤝🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F91D-1F3FD', symbol: '🤝🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F91D-1F3FE', symbol: '🤝🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F91D-1F3FF', symbol: '🤝🏿', addedIn: 3, hasImgTwitter: true },
      '1F3FB-1F3FC': {
        unified: '1FAF1-1F3FB-200D-1FAF2-1F3FC',
        symbol: '🫱🏻‍🫲🏼',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FD': {
        unified: '1FAF1-1F3FB-200D-1FAF2-1F3FD',
        symbol: '🫱🏻‍🫲🏽',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FE': {
        unified: '1FAF1-1F3FB-200D-1FAF2-1F3FE',
        symbol: '🫱🏻‍🫲🏾',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FF': {
        unified: '1FAF1-1F3FB-200D-1FAF2-1F3FF',
        symbol: '🫱🏻‍🫲🏿',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FB': {
        unified: '1FAF1-1F3FC-200D-1FAF2-1F3FB',
        symbol: '🫱🏼‍🫲🏻',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FD': {
        unified: '1FAF1-1F3FC-200D-1FAF2-1F3FD',
        symbol: '🫱🏼‍🫲🏽',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FE': {
        unified: '1FAF1-1F3FC-200D-1FAF2-1F3FE',
        symbol: '🫱🏼‍🫲🏾',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FF': {
        unified: '1FAF1-1F3FC-200D-1FAF2-1F3FF',
        symbol: '🫱🏼‍🫲🏿',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FB': {
        unified: '1FAF1-1F3FD-200D-1FAF2-1F3FB',
        symbol: '🫱🏽‍🫲🏻',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FC': {
        unified: '1FAF1-1F3FD-200D-1FAF2-1F3FC',
        symbol: '🫱🏽‍🫲🏼',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FE': {
        unified: '1FAF1-1F3FD-200D-1FAF2-1F3FE',
        symbol: '🫱🏽‍🫲🏾',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FF': {
        unified: '1FAF1-1F3FD-200D-1FAF2-1F3FF',
        symbol: '🫱🏽‍🫲🏿',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FB': {
        unified: '1FAF1-1F3FE-200D-1FAF2-1F3FB',
        symbol: '🫱🏾‍🫲🏻',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FC': {
        unified: '1FAF1-1F3FE-200D-1FAF2-1F3FC',
        symbol: '🫱🏾‍🫲🏼',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FD': {
        unified: '1FAF1-1F3FE-200D-1FAF2-1F3FD',
        symbol: '🫱🏾‍🫲🏽',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FF': {
        unified: '1FAF1-1F3FE-200D-1FAF2-1F3FF',
        symbol: '🫱🏾‍🫲🏿',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FB': {
        unified: '1FAF1-1F3FF-200D-1FAF2-1F3FB',
        symbol: '🫱🏿‍🫲🏻',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FC': {
        unified: '1FAF1-1F3FF-200D-1FAF2-1F3FC',
        symbol: '🫱🏿‍🫲🏼',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FD': {
        unified: '1FAF1-1F3FF-200D-1FAF2-1F3FD',
        symbol: '🫱🏿‍🫲🏽',
        addedIn: 14,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FE': {
        unified: '1FAF1-1F3FF-200D-1FAF2-1F3FE',
        symbol: '🫱🏿‍🫲🏾',
        addedIn: 14,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F91E',
    'crossed_fingers',
    ['crossed_fingers', 'hand_with_index_and_middle_fingers_crossed'],
    'People & Body',
    177,
    3,
    true,
    {
      '1F3FB': { unified: '1F91E-1F3FB', symbol: '🤞🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F91E-1F3FC', symbol: '🤞🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F91E-1F3FD', symbol: '🤞🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F91E-1F3FE', symbol: '🤞🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F91E-1F3FF', symbol: '🤞🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  [
    '1F91F',
    'i_love_you_hand_sign',
    ['i_love_you_hand_sign'],
    'People & Body',
    179,
    5,
    true,
    {
      '1F3FB': { unified: '1F91F-1F3FB', symbol: '🤟🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F91F-1F3FC', symbol: '🤟🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F91F-1F3FD', symbol: '🤟🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F91F-1F3FE', symbol: '🤟🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F91F-1F3FF', symbol: '🤟🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F920',
    'face_with_cowboy_hat',
    ['face_with_cowboy_hat'],
    'Smileys & Emotion',
    67,
    3,
    true,
    null,
  ],
  ['1F921', 'clown_face', ['clown_face'], 'Smileys & Emotion', 108, 3, true, null],
  ['1F922', 'nauseated_face', ['nauseated_face'], 'Smileys & Emotion', 58, 3, true, null],
  [
    '1F923',
    'rolling_on_the_floor_laughing',
    ['rolling_on_the_floor_laughing'],
    'Smileys & Emotion',
    7,
    3,
    true,
    null,
  ],
  ['1F924', 'drooling_face', ['drooling_face'], 'Smileys & Emotion', 53, 3, true, null],
  ['1F925', 'lying_face', ['lying_face'], 'Smileys & Emotion', 49, 3, true, null],
  [
    '1F926-200D-2640-FE0F',
    'woman-facepalming',
    ['woman-facepalming'],
    'People & Body',
    277,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F926-1F3FB-200D-2640-FE0F',
        symbol: '🤦🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F926-1F3FC-200D-2640-FE0F',
        symbol: '🤦🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F926-1F3FD-200D-2640-FE0F',
        symbol: '🤦🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F926-1F3FE-200D-2640-FE0F',
        symbol: '🤦🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F926-1F3FF-200D-2640-FE0F',
        symbol: '🤦🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F926-200D-2642-FE0F',
    'man-facepalming',
    ['man-facepalming'],
    'People & Body',
    276,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F926-1F3FB-200D-2642-FE0F',
        symbol: '🤦🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F926-1F3FC-200D-2642-FE0F',
        symbol: '🤦🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F926-1F3FD-200D-2642-FE0F',
        symbol: '🤦🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F926-1F3FE-200D-2642-FE0F',
        symbol: '🤦🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F926-1F3FF-200D-2642-FE0F',
        symbol: '🤦🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F926',
    'face_palm',
    ['face_palm'],
    'People & Body',
    275,
    3,
    true,
    {
      '1F3FB': { unified: '1F926-1F3FB', symbol: '🤦🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F926-1F3FC', symbol: '🤦🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F926-1F3FD', symbol: '🤦🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F926-1F3FE', symbol: '🤦🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F926-1F3FF', symbol: '🤦🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  ['1F927', 'sneezing_face', ['sneezing_face'], 'Smileys & Emotion', 60, 3, true, null],
  [
    '1F928',
    'face_with_raised_eyebrow',
    ['face_with_raised_eyebrow', 'face_with_one_eyebrow_raised'],
    'Smileys & Emotion',
    38,
    5,
    true,
    null,
  ],
  [
    '1F929',
    'star-struck',
    ['star-struck', 'grinning_face_with_star_eyes'],
    'Smileys & Emotion',
    17,
    5,
    true,
    null,
  ],
  [
    '1F92A',
    'zany_face',
    ['zany_face', 'grinning_face_with_one_large_and_one_small_eye'],
    'Smileys & Emotion',
    27,
    5,
    true,
    null,
  ],
  [
    '1F92B',
    'shushing_face',
    ['shushing_face', 'face_with_finger_covering_closed_lips'],
    'Smileys & Emotion',
    34,
    5,
    true,
    null,
  ],
  [
    '1F92C',
    'face_with_symbols_on_mouth',
    ['face_with_symbols_on_mouth', 'serious_face_with_symbols_covering_mouth'],
    'Smileys & Emotion',
    102,
    5,
    true,
    null,
  ],
  [
    '1F92D',
    'face_with_hand_over_mouth',
    ['face_with_hand_over_mouth', 'smiling_face_with_smiling_eyes_and_hand_covering_mouth'],
    'Smileys & Emotion',
    31,
    5,
    true,
    null,
  ],
  [
    '1F92E',
    'face_vomiting',
    ['face_vomiting', 'face_with_open_mouth_vomiting'],
    'Smileys & Emotion',
    59,
    5,
    true,
    null,
  ],
  [
    '1F92F',
    'exploding_head',
    ['exploding_head', 'shocked_face_with_exploding_head'],
    'Smileys & Emotion',
    66,
    5,
    true,
    null,
  ],
  [
    '1F930',
    'pregnant_woman',
    ['pregnant_woman'],
    'People & Body',
    356,
    3,
    true,
    {
      '1F3FB': { unified: '1F930-1F3FB', symbol: '🤰🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F930-1F3FC', symbol: '🤰🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F930-1F3FD', symbol: '🤰🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F930-1F3FE', symbol: '🤰🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F930-1F3FF', symbol: '🤰🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  [
    '1F931',
    'breast-feeding',
    ['breast-feeding'],
    'People & Body',
    359,
    5,
    true,
    {
      '1F3FB': { unified: '1F931-1F3FB', symbol: '🤱🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F931-1F3FC', symbol: '🤱🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F931-1F3FD', symbol: '🤱🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F931-1F3FE', symbol: '🤱🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F931-1F3FF', symbol: '🤱🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F932',
    'palms_up_together',
    ['palms_up_together'],
    'People & Body',
    199,
    5,
    true,
    {
      '1F3FB': { unified: '1F932-1F3FB', symbol: '🤲🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F932-1F3FC', symbol: '🤲🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F932-1F3FD', symbol: '🤲🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F932-1F3FE', symbol: '🤲🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F932-1F3FF', symbol: '🤲🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F933',
    'selfie',
    ['selfie'],
    'People & Body',
    204,
    3,
    true,
    {
      '1F3FB': { unified: '1F933-1F3FB', symbol: '🤳🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F933-1F3FC', symbol: '🤳🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F933-1F3FD', symbol: '🤳🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F933-1F3FE', symbol: '🤳🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F933-1F3FF', symbol: '🤳🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  [
    '1F934',
    'prince',
    ['prince'],
    'People & Body',
    343,
    3,
    true,
    {
      '1F3FB': { unified: '1F934-1F3FB', symbol: '🤴🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F934-1F3FC', symbol: '🤴🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F934-1F3FD', symbol: '🤴🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F934-1F3FE', symbol: '🤴🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F934-1F3FF', symbol: '🤴🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  [
    '1F935-200D-2640-FE0F',
    'woman_in_tuxedo',
    ['woman_in_tuxedo'],
    'People & Body',
    352,
    13,
    true,
    {
      '1F3FB': {
        unified: '1F935-1F3FB-200D-2640-FE0F',
        symbol: '🤵🏻‍♀️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F935-1F3FC-200D-2640-FE0F',
        symbol: '🤵🏼‍♀️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F935-1F3FD-200D-2640-FE0F',
        symbol: '🤵🏽‍♀️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F935-1F3FE-200D-2640-FE0F',
        symbol: '🤵🏾‍♀️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F935-1F3FF-200D-2640-FE0F',
        symbol: '🤵🏿‍♀️',
        addedIn: 13,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F935-200D-2642-FE0F',
    'man_in_tuxedo',
    ['man_in_tuxedo'],
    'People & Body',
    351,
    13,
    true,
    {
      '1F3FB': {
        unified: '1F935-1F3FB-200D-2642-FE0F',
        symbol: '🤵🏻‍♂️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F935-1F3FC-200D-2642-FE0F',
        symbol: '🤵🏼‍♂️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F935-1F3FD-200D-2642-FE0F',
        symbol: '🤵🏽‍♂️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F935-1F3FE-200D-2642-FE0F',
        symbol: '🤵🏾‍♂️',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F935-1F3FF-200D-2642-FE0F',
        symbol: '🤵🏿‍♂️',
        addedIn: 13,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F935',
    'person_in_tuxedo',
    ['person_in_tuxedo'],
    'People & Body',
    350,
    3,
    true,
    {
      '1F3FB': { unified: '1F935-1F3FB', symbol: '🤵🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F935-1F3FC', symbol: '🤵🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F935-1F3FD', symbol: '🤵🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F935-1F3FE', symbol: '🤵🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F935-1F3FF', symbol: '🤵🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  [
    '1F936',
    'mrs_claus',
    ['mrs_claus', 'mother_christmas'],
    'People & Body',
    365,
    3,
    true,
    {
      '1F3FB': { unified: '1F936-1F3FB', symbol: '🤶🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F936-1F3FC', symbol: '🤶🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F936-1F3FD', symbol: '🤶🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F936-1F3FE', symbol: '🤶🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F936-1F3FF', symbol: '🤶🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  [
    '1F937-200D-2640-FE0F',
    'woman-shrugging',
    ['woman-shrugging'],
    'People & Body',
    280,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F937-1F3FB-200D-2640-FE0F',
        symbol: '🤷🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F937-1F3FC-200D-2640-FE0F',
        symbol: '🤷🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F937-1F3FD-200D-2640-FE0F',
        symbol: '🤷🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F937-1F3FE-200D-2640-FE0F',
        symbol: '🤷🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F937-1F3FF-200D-2640-FE0F',
        symbol: '🤷🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F937-200D-2642-FE0F',
    'man-shrugging',
    ['man-shrugging'],
    'People & Body',
    279,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F937-1F3FB-200D-2642-FE0F',
        symbol: '🤷🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F937-1F3FC-200D-2642-FE0F',
        symbol: '🤷🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F937-1F3FD-200D-2642-FE0F',
        symbol: '🤷🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F937-1F3FE-200D-2642-FE0F',
        symbol: '🤷🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F937-1F3FF-200D-2642-FE0F',
        symbol: '🤷🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F937',
    'shrug',
    ['shrug'],
    'People & Body',
    278,
    3,
    true,
    {
      '1F3FB': { unified: '1F937-1F3FB', symbol: '🤷🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F937-1F3FC', symbol: '🤷🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F937-1F3FD', symbol: '🤷🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F937-1F3FE', symbol: '🤷🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F937-1F3FF', symbol: '🤷🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  [
    '1F938-200D-2640-FE0F',
    'woman-cartwheeling',
    ['woman-cartwheeling'],
    'People & Body',
    464,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F938-1F3FB-200D-2640-FE0F',
        symbol: '🤸🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F938-1F3FC-200D-2640-FE0F',
        symbol: '🤸🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F938-1F3FD-200D-2640-FE0F',
        symbol: '🤸🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F938-1F3FE-200D-2640-FE0F',
        symbol: '🤸🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F938-1F3FF-200D-2640-FE0F',
        symbol: '🤸🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F938-200D-2642-FE0F',
    'man-cartwheeling',
    ['man-cartwheeling'],
    'People & Body',
    463,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F938-1F3FB-200D-2642-FE0F',
        symbol: '🤸🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F938-1F3FC-200D-2642-FE0F',
        symbol: '🤸🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F938-1F3FD-200D-2642-FE0F',
        symbol: '🤸🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F938-1F3FE-200D-2642-FE0F',
        symbol: '🤸🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F938-1F3FF-200D-2642-FE0F',
        symbol: '🤸🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F938',
    'person_doing_cartwheel',
    ['person_doing_cartwheel'],
    'People & Body',
    462,
    3,
    true,
    {
      '1F3FB': { unified: '1F938-1F3FB', symbol: '🤸🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F938-1F3FC', symbol: '🤸🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F938-1F3FD', symbol: '🤸🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F938-1F3FE', symbol: '🤸🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F938-1F3FF', symbol: '🤸🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  [
    '1F939-200D-2640-FE0F',
    'woman-juggling',
    ['woman-juggling'],
    'People & Body',
    476,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F939-1F3FB-200D-2640-FE0F',
        symbol: '🤹🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F939-1F3FC-200D-2640-FE0F',
        symbol: '🤹🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F939-1F3FD-200D-2640-FE0F',
        symbol: '🤹🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F939-1F3FE-200D-2640-FE0F',
        symbol: '🤹🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F939-1F3FF-200D-2640-FE0F',
        symbol: '🤹🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F939-200D-2642-FE0F',
    'man-juggling',
    ['man-juggling'],
    'People & Body',
    475,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F939-1F3FB-200D-2642-FE0F',
        symbol: '🤹🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F939-1F3FC-200D-2642-FE0F',
        symbol: '🤹🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F939-1F3FD-200D-2642-FE0F',
        symbol: '🤹🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F939-1F3FE-200D-2642-FE0F',
        symbol: '🤹🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F939-1F3FF-200D-2642-FE0F',
        symbol: '🤹🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F939',
    'juggling',
    ['juggling'],
    'People & Body',
    474,
    3,
    true,
    {
      '1F3FB': { unified: '1F939-1F3FB', symbol: '🤹🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F939-1F3FC', symbol: '🤹🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F939-1F3FD', symbol: '🤹🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F939-1F3FE', symbol: '🤹🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F939-1F3FF', symbol: '🤹🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  ['1F93A', 'fencer', ['fencer'], 'People & Body', 434, 3, true, null],
  [
    '1F93C-200D-2640-FE0F',
    'woman-wrestling',
    ['woman-wrestling'],
    'People & Body',
    467,
    4,
    true,
    null,
  ],
  ['1F93C-200D-2642-FE0F', 'man-wrestling', ['man-wrestling'], 'People & Body', 466, 4, true, null],
  ['1F93C', 'wrestlers', ['wrestlers'], 'People & Body', 465, 3, true, null],
  [
    '1F93D-200D-2640-FE0F',
    'woman-playing-water-polo',
    ['woman-playing-water-polo'],
    'People & Body',
    470,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F93D-1F3FB-200D-2640-FE0F',
        symbol: '🤽🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F93D-1F3FC-200D-2640-FE0F',
        symbol: '🤽🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F93D-1F3FD-200D-2640-FE0F',
        symbol: '🤽🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F93D-1F3FE-200D-2640-FE0F',
        symbol: '🤽🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F93D-1F3FF-200D-2640-FE0F',
        symbol: '🤽🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F93D-200D-2642-FE0F',
    'man-playing-water-polo',
    ['man-playing-water-polo'],
    'People & Body',
    469,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F93D-1F3FB-200D-2642-FE0F',
        symbol: '🤽🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F93D-1F3FC-200D-2642-FE0F',
        symbol: '🤽🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F93D-1F3FD-200D-2642-FE0F',
        symbol: '🤽🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F93D-1F3FE-200D-2642-FE0F',
        symbol: '🤽🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F93D-1F3FF-200D-2642-FE0F',
        symbol: '🤽🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F93D',
    'water_polo',
    ['water_polo'],
    'People & Body',
    468,
    3,
    true,
    {
      '1F3FB': { unified: '1F93D-1F3FB', symbol: '🤽🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F93D-1F3FC', symbol: '🤽🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F93D-1F3FD', symbol: '🤽🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F93D-1F3FE', symbol: '🤽🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F93D-1F3FF', symbol: '🤽🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  [
    '1F93E-200D-2640-FE0F',
    'woman-playing-handball',
    ['woman-playing-handball'],
    'People & Body',
    473,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F93E-1F3FB-200D-2640-FE0F',
        symbol: '🤾🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F93E-1F3FC-200D-2640-FE0F',
        symbol: '🤾🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F93E-1F3FD-200D-2640-FE0F',
        symbol: '🤾🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F93E-1F3FE-200D-2640-FE0F',
        symbol: '🤾🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F93E-1F3FF-200D-2640-FE0F',
        symbol: '🤾🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F93E-200D-2642-FE0F',
    'man-playing-handball',
    ['man-playing-handball'],
    'People & Body',
    472,
    4,
    true,
    {
      '1F3FB': {
        unified: '1F93E-1F3FB-200D-2642-FE0F',
        symbol: '🤾🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F93E-1F3FC-200D-2642-FE0F',
        symbol: '🤾🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F93E-1F3FD-200D-2642-FE0F',
        symbol: '🤾🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F93E-1F3FE-200D-2642-FE0F',
        symbol: '🤾🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F93E-1F3FF-200D-2642-FE0F',
        symbol: '🤾🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F93E',
    'handball',
    ['handball'],
    'People & Body',
    471,
    3,
    true,
    {
      '1F3FB': { unified: '1F93E-1F3FB', symbol: '🤾🏻', addedIn: 3, hasImgTwitter: true },
      '1F3FC': { unified: '1F93E-1F3FC', symbol: '🤾🏼', addedIn: 3, hasImgTwitter: true },
      '1F3FD': { unified: '1F93E-1F3FD', symbol: '🤾🏽', addedIn: 3, hasImgTwitter: true },
      '1F3FE': { unified: '1F93E-1F3FE', symbol: '🤾🏾', addedIn: 3, hasImgTwitter: true },
      '1F3FF': { unified: '1F93E-1F3FF', symbol: '🤾🏿', addedIn: 3, hasImgTwitter: true },
    },
  ],
  ['1F93F', 'diving_mask', ['diving_mask'], 'Activities', 1073, 12, true, null],
  ['1F940', 'wilted_flower', ['wilted_flower'], 'Animals & Nature', 654, 3, true, null],
  ['1F941', 'drum_with_drumsticks', ['drum_with_drumsticks'], 'Objects', 1180, 3, true, null],
  ['1F942', 'clinking_glasses', ['clinking_glasses'], 'Food & Drink', 791, 3, true, null],
  ['1F943', 'tumbler_glass', ['tumbler_glass'], 'Food & Drink', 792, 3, true, null],
  ['1F944', 'spoon', ['spoon'], 'Food & Drink', 802, 3, true, null],
  ['1F945', 'goal_net', ['goal_net'], 'Activities', 1069, 3, true, null],
  ['1F947', 'first_place_medal', ['first_place_medal'], 'Activities', 1048, 3, true, null],
  ['1F948', 'second_place_medal', ['second_place_medal'], 'Activities', 1049, 3, true, null],
  ['1F949', 'third_place_medal', ['third_place_medal'], 'Activities', 1050, 3, true, null],
  ['1F94A', 'boxing_glove', ['boxing_glove'], 'Activities', 1067, 3, true, null],
  ['1F94B', 'martial_arts_uniform', ['martial_arts_uniform'], 'Activities', 1068, 3, true, null],
  ['1F94C', 'curling_stone', ['curling_stone'], 'Activities', 1077, 5, true, null],
  ['1F94D', 'lacrosse', ['lacrosse'], 'Activities', 1064, 11, true, null],
  ['1F94E', 'softball', ['softball'], 'Activities', 1053, 11, true, null],
  ['1F94F', 'flying_disc', ['flying_disc'], 'Activities', 1059, 11, true, null],
  ['1F950', 'croissant', ['croissant'], 'Food & Drink', 710, 3, true, null],
  ['1F951', 'avocado', ['avocado'], 'Food & Drink', 693, 3, true, null],
  ['1F952', 'cucumber', ['cucumber'], 'Food & Drink', 700, 3, true, null],
  ['1F953', 'bacon', ['bacon'], 'Food & Drink', 721, 3, true, null],
  ['1F954', 'potato', ['potato'], 'Food & Drink', 695, 3, true, null],
  ['1F955', 'carrot', ['carrot'], 'Food & Drink', 696, 3, true, null],
  ['1F956', 'baguette_bread', ['baguette_bread'], 'Food & Drink', 711, 3, true, null],
  ['1F957', 'green_salad', ['green_salad'], 'Food & Drink', 738, 3, true, null],
  ['1F958', 'shallow_pan_of_food', ['shallow_pan_of_food'], 'Food & Drink', 734, 3, true, null],
  ['1F959', 'stuffed_flatbread', ['stuffed_flatbread'], 'Food & Drink', 730, 3, true, null],
  ['1F95A', 'egg', ['egg'], 'Food & Drink', 732, 3, true, null],
  ['1F95B', 'glass_of_milk', ['glass_of_milk'], 'Food & Drink', 780, 3, true, null],
  ['1F95C', 'peanuts', ['peanuts'], 'Food & Drink', 706, 3, true, null],
  ['1F95D', 'kiwifruit', ['kiwifruit'], 'Food & Drink', 689, 3, true, null],
  ['1F95E', 'pancakes', ['pancakes'], 'Food & Drink', 715, 3, true, null],
  ['1F95F', 'dumpling', ['dumpling'], 'Food & Drink', 757, 5, true, null],
  ['1F960', 'fortune_cookie', ['fortune_cookie'], 'Food & Drink', 758, 5, true, null],
  ['1F961', 'takeout_box', ['takeout_box'], 'Food & Drink', 759, 5, true, null],
  ['1F962', 'chopsticks', ['chopsticks'], 'Food & Drink', 799, 5, true, null],
  ['1F963', 'bowl_with_spoon', ['bowl_with_spoon'], 'Food & Drink', 737, 5, true, null],
  ['1F964', 'cup_with_straw', ['cup_with_straw'], 'Food & Drink', 794, 5, true, null],
  ['1F965', 'coconut', ['coconut'], 'Food & Drink', 692, 5, true, null],
  ['1F966', 'broccoli', ['broccoli'], 'Food & Drink', 702, 5, true, null],
  ['1F967', 'pie', ['pie'], 'Food & Drink', 773, 5, true, null],
  ['1F968', 'pretzel', ['pretzel'], 'Food & Drink', 713, 5, true, null],
  ['1F969', 'cut_of_meat', ['cut_of_meat'], 'Food & Drink', 720, 5, true, null],
  ['1F96A', 'sandwich', ['sandwich'], 'Food & Drink', 726, 5, true, null],
  ['1F96B', 'canned_food', ['canned_food'], 'Food & Drink', 742, 5, true, null],
  ['1F96C', 'leafy_green', ['leafy_green'], 'Food & Drink', 701, 11, true, null],
  ['1F96D', 'mango', ['mango'], 'Food & Drink', 681, 11, true, null],
  ['1F96E', 'moon_cake', ['moon_cake'], 'Food & Drink', 755, 11, true, null],
  ['1F96F', 'bagel', ['bagel'], 'Food & Drink', 714, 11, true, null],
  [
    '1F970',
    'smiling_face_with_3_hearts',
    ['smiling_face_with_3_hearts'],
    'Smileys & Emotion',
    15,
    11,
    true,
    null,
  ],
  ['1F971', 'yawning_face', ['yawning_face'], 'Smileys & Emotion', 98, 12, true, null],
  [
    '1F972',
    'smiling_face_with_tear',
    ['smiling_face_with_tear'],
    'Smileys & Emotion',
    23,
    13,
    true,
    null,
  ],
  ['1F973', 'partying_face', ['partying_face'], 'Smileys & Emotion', 68, 11, true, null],
  ['1F974', 'woozy_face', ['woozy_face'], 'Smileys & Emotion', 63, 11, true, null],
  ['1F975', 'hot_face', ['hot_face'], 'Smileys & Emotion', 61, 11, true, null],
  ['1F976', 'cold_face', ['cold_face'], 'Smileys & Emotion', 62, 11, true, null],
  [
    '1F977',
    'ninja',
    ['ninja'],
    'People & Body',
    338,
    13,
    true,
    {
      '1F3FB': { unified: '1F977-1F3FB', symbol: '🥷🏻', addedIn: 13, hasImgTwitter: true },
      '1F3FC': { unified: '1F977-1F3FC', symbol: '🥷🏼', addedIn: 13, hasImgTwitter: true },
      '1F3FD': { unified: '1F977-1F3FD', symbol: '🥷🏽', addedIn: 13, hasImgTwitter: true },
      '1F3FE': { unified: '1F977-1F3FE', symbol: '🥷🏾', addedIn: 13, hasImgTwitter: true },
      '1F3FF': { unified: '1F977-1F3FF', symbol: '🥷🏿', addedIn: 13, hasImgTwitter: true },
    },
  ],
  ['1F978', 'disguised_face', ['disguised_face'], 'Smileys & Emotion', 69, 13, true, null],
  [
    '1F979',
    'face_holding_back_tears',
    ['face_holding_back_tears'],
    'Smileys & Emotion',
    83,
    14,
    true,
    null,
  ],
  ['1F97A', 'pleading_face', ['pleading_face'], 'Smileys & Emotion', 82, 11, true, null],
  ['1F97B', 'sari', ['sari'], 'Objects', 1124, 12, true, null],
  ['1F97C', 'lab_coat', ['lab_coat'], 'Objects', 1113, 11, true, null],
  ['1F97D', 'goggles', ['goggles'], 'Objects', 1112, 11, true, null],
  ['1F97E', 'hiking_boot', ['hiking_boot'], 'Objects', 1138, 11, true, null],
  ['1F97F', 'womans_flat_shoe', ['womans_flat_shoe'], 'Objects', 1139, 11, true, null],
  ['1F980', 'crab', ['crab'], 'Food & Drink', 760, 1, true, null],
  ['1F981', 'lion_face', ['lion_face'], 'Animals & Nature', 545, 1, true, null],
  ['1F982', 'scorpion', ['scorpion'], 'Animals & Nature', 643, 1, true, null],
  ['1F983', 'turkey', ['turkey'], 'Animals & Nature', 594, 1, true, null],
  ['1F984', 'unicorn_face', ['unicorn_face'], 'Animals & Nature', 551, 1, true, null],
  ['1F985', 'eagle', ['eagle'], 'Animals & Nature', 603, 3, true, null],
  ['1F986', 'duck', ['duck'], 'Animals & Nature', 604, 3, true, null],
  ['1F987', 'bat', ['bat'], 'Animals & Nature', 583, 3, true, null],
  ['1F988', 'shark', ['shark'], 'Animals & Nature', 628, 3, true, null],
  ['1F989', 'owl', ['owl'], 'Animals & Nature', 606, 3, true, null],
  ['1F98A', 'fox_face', ['fox_face'], 'Animals & Nature', 540, 3, true, null],
  ['1F98B', 'butterfly', ['butterfly'], 'Animals & Nature', 633, 3, true, null],
  ['1F98C', 'deer', ['deer'], 'Animals & Nature', 553, 3, true, null],
  ['1F98D', 'gorilla', ['gorilla'], 'Animals & Nature', 532, 3, true, null],
  ['1F98E', 'lizard', ['lizard'], 'Animals & Nature', 615, 3, true, null],
  ['1F98F', 'rhinoceros', ['rhinoceros'], 'Animals & Nature', 572, 3, true, null],
  ['1F990', 'shrimp', ['shrimp'], 'Food & Drink', 762, 3, true, null],
  ['1F991', 'squid', ['squid'], 'Food & Drink', 763, 3, true, null],
  ['1F992', 'giraffe_face', ['giraffe_face'], 'Animals & Nature', 569, 5, true, null],
  ['1F993', 'zebra_face', ['zebra_face'], 'Animals & Nature', 552, 5, true, null],
  ['1F994', 'hedgehog', ['hedgehog'], 'Animals & Nature', 582, 5, true, null],
  ['1F995', 'sauropod', ['sauropod'], 'Animals & Nature', 619, 5, true, null],
  ['1F996', 't-rex', ['t-rex'], 'Animals & Nature', 620, 5, true, null],
  ['1F997', 'cricket', ['cricket'], 'Animals & Nature', 639, 5, true, null],
  ['1F998', 'kangaroo', ['kangaroo'], 'Animals & Nature', 591, 11, true, null],
  ['1F999', 'llama', ['llama'], 'Animals & Nature', 568, 11, true, null],
  ['1F99A', 'peacock', ['peacock'], 'Animals & Nature', 610, 11, true, null],
  ['1F99B', 'hippopotamus', ['hippopotamus'], 'Animals & Nature', 573, 11, true, null],
  ['1F99C', 'parrot', ['parrot'], 'Animals & Nature', 611, 11, true, null],
  ['1F99D', 'raccoon', ['raccoon'], 'Animals & Nature', 541, 11, true, null],
  ['1F99E', 'lobster', ['lobster'], 'Food & Drink', 761, 11, true, null],
  ['1F99F', 'mosquito', ['mosquito'], 'Animals & Nature', 644, 11, true, null],
  ['1F9A0', 'microbe', ['microbe'], 'Animals & Nature', 647, 11, true, null],
  ['1F9A1', 'badger', ['badger'], 'Animals & Nature', 592, 11, true, null],
  ['1F9A2', 'swan', ['swan'], 'Animals & Nature', 605, 11, true, null],
  ['1F9A3', 'mammoth', ['mammoth'], 'Animals & Nature', 571, 13, true, null],
  ['1F9A4', 'dodo', ['dodo'], 'Animals & Nature', 607, 13, true, null],
  ['1F9A5', 'sloth', ['sloth'], 'Animals & Nature', 588, 12, true, null],
  ['1F9A6', 'otter', ['otter'], 'Animals & Nature', 589, 12, true, null],
  ['1F9A7', 'orangutan', ['orangutan'], 'Animals & Nature', 533, 12, true, null],
  ['1F9A8', 'skunk', ['skunk'], 'Animals & Nature', 590, 12, true, null],
  ['1F9A9', 'flamingo', ['flamingo'], 'Animals & Nature', 609, 12, true, null],
  ['1F9AA', 'oyster', ['oyster'], 'Food & Drink', 764, 12, true, null],
  ['1F9AB', 'beaver', ['beaver'], 'Animals & Nature', 581, 13, true, null],
  ['1F9AC', 'bison', ['bison'], 'Animals & Nature', 554, 13, true, null],
  ['1F9AD', 'seal', ['seal'], 'Animals & Nature', 624, 13, true, null],
  ['1F9AE', 'guide_dog', ['guide_dog'], 'Animals & Nature', 536, 12, true, null],
  ['1F9AF', 'probing_cane', ['probing_cane'], 'Objects', 1312, 12, true, null],
  ['1F9B4', 'bone', ['bone'], 'People & Body', 217, 11, true, null],
  [
    '1F9B5',
    'leg',
    ['leg'],
    'People & Body',
    208,
    11,
    true,
    {
      '1F3FB': { unified: '1F9B5-1F3FB', symbol: '🦵🏻', addedIn: 11, hasImgTwitter: true },
      '1F3FC': { unified: '1F9B5-1F3FC', symbol: '🦵🏼', addedIn: 11, hasImgTwitter: true },
      '1F3FD': { unified: '1F9B5-1F3FD', symbol: '🦵🏽', addedIn: 11, hasImgTwitter: true },
      '1F3FE': { unified: '1F9B5-1F3FE', symbol: '🦵🏾', addedIn: 11, hasImgTwitter: true },
      '1F3FF': { unified: '1F9B5-1F3FF', symbol: '🦵🏿', addedIn: 11, hasImgTwitter: true },
    },
  ],
  [
    '1F9B6',
    'foot',
    ['foot'],
    'People & Body',
    209,
    11,
    true,
    {
      '1F3FB': { unified: '1F9B6-1F3FB', symbol: '🦶🏻', addedIn: 11, hasImgTwitter: true },
      '1F3FC': { unified: '1F9B6-1F3FC', symbol: '🦶🏼', addedIn: 11, hasImgTwitter: true },
      '1F3FD': { unified: '1F9B6-1F3FD', symbol: '🦶🏽', addedIn: 11, hasImgTwitter: true },
      '1F3FE': { unified: '1F9B6-1F3FE', symbol: '🦶🏾', addedIn: 11, hasImgTwitter: true },
      '1F3FF': { unified: '1F9B6-1F3FF', symbol: '🦶🏿', addedIn: 11, hasImgTwitter: true },
    },
  ],
  ['1F9B7', 'tooth', ['tooth'], 'People & Body', 216, 11, true, null],
  [
    '1F9B8-200D-2640-FE0F',
    'female_superhero',
    ['female_superhero'],
    'People & Body',
    369,
    11,
    true,
    {
      '1F3FB': {
        unified: '1F9B8-1F3FB-200D-2640-FE0F',
        symbol: '🦸🏻‍♀️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9B8-1F3FC-200D-2640-FE0F',
        symbol: '🦸🏼‍♀️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9B8-1F3FD-200D-2640-FE0F',
        symbol: '🦸🏽‍♀️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9B8-1F3FE-200D-2640-FE0F',
        symbol: '🦸🏾‍♀️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9B8-1F3FF-200D-2640-FE0F',
        symbol: '🦸🏿‍♀️',
        addedIn: 11,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9B8-200D-2642-FE0F',
    'male_superhero',
    ['male_superhero'],
    'People & Body',
    368,
    11,
    true,
    {
      '1F3FB': {
        unified: '1F9B8-1F3FB-200D-2642-FE0F',
        symbol: '🦸🏻‍♂️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9B8-1F3FC-200D-2642-FE0F',
        symbol: '🦸🏼‍♂️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9B8-1F3FD-200D-2642-FE0F',
        symbol: '🦸🏽‍♂️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9B8-1F3FE-200D-2642-FE0F',
        symbol: '🦸🏾‍♂️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9B8-1F3FF-200D-2642-FE0F',
        symbol: '🦸🏿‍♂️',
        addedIn: 11,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9B8',
    'superhero',
    ['superhero'],
    'People & Body',
    367,
    11,
    true,
    {
      '1F3FB': { unified: '1F9B8-1F3FB', symbol: '🦸🏻', addedIn: 11, hasImgTwitter: true },
      '1F3FC': { unified: '1F9B8-1F3FC', symbol: '🦸🏼', addedIn: 11, hasImgTwitter: true },
      '1F3FD': { unified: '1F9B8-1F3FD', symbol: '🦸🏽', addedIn: 11, hasImgTwitter: true },
      '1F3FE': { unified: '1F9B8-1F3FE', symbol: '🦸🏾', addedIn: 11, hasImgTwitter: true },
      '1F3FF': { unified: '1F9B8-1F3FF', symbol: '🦸🏿', addedIn: 11, hasImgTwitter: true },
    },
  ],
  [
    '1F9B9-200D-2640-FE0F',
    'female_supervillain',
    ['female_supervillain'],
    'People & Body',
    372,
    11,
    true,
    {
      '1F3FB': {
        unified: '1F9B9-1F3FB-200D-2640-FE0F',
        symbol: '🦹🏻‍♀️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9B9-1F3FC-200D-2640-FE0F',
        symbol: '🦹🏼‍♀️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9B9-1F3FD-200D-2640-FE0F',
        symbol: '🦹🏽‍♀️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9B9-1F3FE-200D-2640-FE0F',
        symbol: '🦹🏾‍♀️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9B9-1F3FF-200D-2640-FE0F',
        symbol: '🦹🏿‍♀️',
        addedIn: 11,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9B9-200D-2642-FE0F',
    'male_supervillain',
    ['male_supervillain'],
    'People & Body',
    371,
    11,
    true,
    {
      '1F3FB': {
        unified: '1F9B9-1F3FB-200D-2642-FE0F',
        symbol: '🦹🏻‍♂️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9B9-1F3FC-200D-2642-FE0F',
        symbol: '🦹🏼‍♂️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9B9-1F3FD-200D-2642-FE0F',
        symbol: '🦹🏽‍♂️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9B9-1F3FE-200D-2642-FE0F',
        symbol: '🦹🏾‍♂️',
        addedIn: 11,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9B9-1F3FF-200D-2642-FE0F',
        symbol: '🦹🏿‍♂️',
        addedIn: 11,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9B9',
    'supervillain',
    ['supervillain'],
    'People & Body',
    370,
    11,
    true,
    {
      '1F3FB': { unified: '1F9B9-1F3FB', symbol: '🦹🏻', addedIn: 11, hasImgTwitter: true },
      '1F3FC': { unified: '1F9B9-1F3FC', symbol: '🦹🏼', addedIn: 11, hasImgTwitter: true },
      '1F3FD': { unified: '1F9B9-1F3FD', symbol: '🦹🏽', addedIn: 11, hasImgTwitter: true },
      '1F3FE': { unified: '1F9B9-1F3FE', symbol: '🦹🏾', addedIn: 11, hasImgTwitter: true },
      '1F3FF': { unified: '1F9B9-1F3FF', symbol: '🦹🏿', addedIn: 11, hasImgTwitter: true },
    },
  ],
  ['1F9BA', 'safety_vest', ['safety_vest'], 'Objects', 1114, 12, true, null],
  [
    '1F9BB',
    'ear_with_hearing_aid',
    ['ear_with_hearing_aid'],
    'People & Body',
    211,
    12,
    true,
    {
      '1F3FB': { unified: '1F9BB-1F3FB', symbol: '🦻🏻', addedIn: 12, hasImgTwitter: true },
      '1F3FC': { unified: '1F9BB-1F3FC', symbol: '🦻🏼', addedIn: 12, hasImgTwitter: true },
      '1F3FD': { unified: '1F9BB-1F3FD', symbol: '🦻🏽', addedIn: 12, hasImgTwitter: true },
      '1F3FE': { unified: '1F9BB-1F3FE', symbol: '🦻🏾', addedIn: 12, hasImgTwitter: true },
      '1F3FF': { unified: '1F9BB-1F3FF', symbol: '🦻🏿', addedIn: 12, hasImgTwitter: true },
    },
  ],
  [
    '1F9BC',
    'motorized_wheelchair',
    ['motorized_wheelchair'],
    'Travel & Places',
    905,
    12,
    true,
    null,
  ],
  ['1F9BD', 'manual_wheelchair', ['manual_wheelchair'], 'Travel & Places', 904, 12, true, null],
  ['1F9BE', 'mechanical_arm', ['mechanical_arm'], 'People & Body', 206, 12, true, null],
  ['1F9BF', 'mechanical_leg', ['mechanical_leg'], 'People & Body', 207, 12, true, null],
  ['1F9C0', 'cheese_wedge', ['cheese_wedge'], 'Food & Drink', 717, 1, true, null],
  ['1F9C1', 'cupcake', ['cupcake'], 'Food & Drink', 772, 11, true, null],
  ['1F9C2', 'salt', ['salt'], 'Food & Drink', 741, 11, true, null],
  ['1F9C3', 'beverage_box', ['beverage_box'], 'Food & Drink', 796, 12, true, null],
  ['1F9C4', 'garlic', ['garlic'], 'Food & Drink', 703, 12, true, null],
  ['1F9C5', 'onion', ['onion'], 'Food & Drink', 704, 12, true, null],
  ['1F9C6', 'falafel', ['falafel'], 'Food & Drink', 731, 12, true, null],
  ['1F9C7', 'waffle', ['waffle'], 'Food & Drink', 716, 12, true, null],
  ['1F9C8', 'butter', ['butter'], 'Food & Drink', 740, 12, true, null],
  ['1F9C9', 'mate_drink', ['mate_drink'], 'Food & Drink', 797, 12, true, null],
  ['1F9CA', 'ice_cube', ['ice_cube'], 'Food & Drink', 798, 12, true, null],
  ['1F9CB', 'bubble_tea', ['bubble_tea'], 'Food & Drink', 795, 13, true, null],
  ['1F9CC', 'troll', ['troll'], 'People & Body', 394, 14, true, null],
  [
    '1F9CD-200D-2640-FE0F',
    'woman_standing',
    ['woman_standing'],
    'People & Body',
    406,
    12,
    true,
    {
      '1F3FB': {
        unified: '1F9CD-1F3FB-200D-2640-FE0F',
        symbol: '🧍🏻‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9CD-1F3FC-200D-2640-FE0F',
        symbol: '🧍🏼‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9CD-1F3FD-200D-2640-FE0F',
        symbol: '🧍🏽‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9CD-1F3FE-200D-2640-FE0F',
        symbol: '🧍🏾‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9CD-1F3FF-200D-2640-FE0F',
        symbol: '🧍🏿‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9CD-200D-2642-FE0F',
    'man_standing',
    ['man_standing'],
    'People & Body',
    405,
    12,
    true,
    {
      '1F3FB': {
        unified: '1F9CD-1F3FB-200D-2642-FE0F',
        symbol: '🧍🏻‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9CD-1F3FC-200D-2642-FE0F',
        symbol: '🧍🏼‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9CD-1F3FD-200D-2642-FE0F',
        symbol: '🧍🏽‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9CD-1F3FE-200D-2642-FE0F',
        symbol: '🧍🏾‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9CD-1F3FF-200D-2642-FE0F',
        symbol: '🧍🏿‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9CD',
    'standing_person',
    ['standing_person'],
    'People & Body',
    404,
    12,
    true,
    {
      '1F3FB': { unified: '1F9CD-1F3FB', symbol: '🧍🏻', addedIn: 12, hasImgTwitter: true },
      '1F3FC': { unified: '1F9CD-1F3FC', symbol: '🧍🏼', addedIn: 12, hasImgTwitter: true },
      '1F3FD': { unified: '1F9CD-1F3FD', symbol: '🧍🏽', addedIn: 12, hasImgTwitter: true },
      '1F3FE': { unified: '1F9CD-1F3FE', symbol: '🧍🏾', addedIn: 12, hasImgTwitter: true },
      '1F3FF': { unified: '1F9CD-1F3FF', symbol: '🧍🏿', addedIn: 12, hasImgTwitter: true },
    },
  ],
  [
    '1F9CE-200D-2640-FE0F',
    'woman_kneeling',
    ['woman_kneeling'],
    'People & Body',
    409,
    12,
    true,
    {
      '1F3FB': {
        unified: '1F9CE-1F3FB-200D-2640-FE0F',
        symbol: '🧎🏻‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9CE-1F3FC-200D-2640-FE0F',
        symbol: '🧎🏼‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9CE-1F3FD-200D-2640-FE0F',
        symbol: '🧎🏽‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9CE-1F3FE-200D-2640-FE0F',
        symbol: '🧎🏾‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9CE-1F3FF-200D-2640-FE0F',
        symbol: '🧎🏿‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9CE-200D-2642-FE0F',
    'man_kneeling',
    ['man_kneeling'],
    'People & Body',
    408,
    12,
    true,
    {
      '1F3FB': {
        unified: '1F9CE-1F3FB-200D-2642-FE0F',
        symbol: '🧎🏻‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9CE-1F3FC-200D-2642-FE0F',
        symbol: '🧎🏼‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9CE-1F3FD-200D-2642-FE0F',
        symbol: '🧎🏽‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9CE-1F3FE-200D-2642-FE0F',
        symbol: '🧎🏾‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9CE-1F3FF-200D-2642-FE0F',
        symbol: '🧎🏿‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9CE',
    'kneeling_person',
    ['kneeling_person'],
    'People & Body',
    407,
    12,
    true,
    {
      '1F3FB': { unified: '1F9CE-1F3FB', symbol: '🧎🏻', addedIn: 12, hasImgTwitter: true },
      '1F3FC': { unified: '1F9CE-1F3FC', symbol: '🧎🏼', addedIn: 12, hasImgTwitter: true },
      '1F3FD': { unified: '1F9CE-1F3FD', symbol: '🧎🏽', addedIn: 12, hasImgTwitter: true },
      '1F3FE': { unified: '1F9CE-1F3FE', symbol: '🧎🏾', addedIn: 12, hasImgTwitter: true },
      '1F3FF': { unified: '1F9CE-1F3FF', symbol: '🧎🏿', addedIn: 12, hasImgTwitter: true },
    },
  ],
  [
    '1F9CF-200D-2640-FE0F',
    'deaf_woman',
    ['deaf_woman'],
    'People & Body',
    271,
    12,
    true,
    {
      '1F3FB': {
        unified: '1F9CF-1F3FB-200D-2640-FE0F',
        symbol: '🧏🏻‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9CF-1F3FC-200D-2640-FE0F',
        symbol: '🧏🏼‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9CF-1F3FD-200D-2640-FE0F',
        symbol: '🧏🏽‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9CF-1F3FE-200D-2640-FE0F',
        symbol: '🧏🏾‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9CF-1F3FF-200D-2640-FE0F',
        symbol: '🧏🏿‍♀️',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9CF-200D-2642-FE0F',
    'deaf_man',
    ['deaf_man'],
    'People & Body',
    270,
    12,
    true,
    {
      '1F3FB': {
        unified: '1F9CF-1F3FB-200D-2642-FE0F',
        symbol: '🧏🏻‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9CF-1F3FC-200D-2642-FE0F',
        symbol: '🧏🏼‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9CF-1F3FD-200D-2642-FE0F',
        symbol: '🧏🏽‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9CF-1F3FE-200D-2642-FE0F',
        symbol: '🧏🏾‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9CF-1F3FF-200D-2642-FE0F',
        symbol: '🧏🏿‍♂️',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9CF',
    'deaf_person',
    ['deaf_person'],
    'People & Body',
    269,
    12,
    true,
    {
      '1F3FB': { unified: '1F9CF-1F3FB', symbol: '🧏🏻', addedIn: 12, hasImgTwitter: true },
      '1F3FC': { unified: '1F9CF-1F3FC', symbol: '🧏🏼', addedIn: 12, hasImgTwitter: true },
      '1F3FD': { unified: '1F9CF-1F3FD', symbol: '🧏🏽', addedIn: 12, hasImgTwitter: true },
      '1F3FE': { unified: '1F9CF-1F3FE', symbol: '🧏🏾', addedIn: 12, hasImgTwitter: true },
      '1F3FF': { unified: '1F9CF-1F3FF', symbol: '🧏🏿', addedIn: 12, hasImgTwitter: true },
    },
  ],
  ['1F9D0', 'face_with_monocle', ['face_with_monocle'], 'Smileys & Emotion', 72, 5, true, null],
  [
    '1F9D1-200D-1F33E',
    'farmer',
    ['farmer'],
    'People & Body',
    293,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F33E',
        symbol: '🧑🏻‍🌾',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F33E',
        symbol: '🧑🏼‍🌾',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F33E',
        symbol: '🧑🏽‍🌾',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F33E',
        symbol: '🧑🏾‍🌾',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F33E',
        symbol: '🧑🏿‍🌾',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F373',
    'cook',
    ['cook'],
    'People & Body',
    296,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F373',
        symbol: '🧑🏻‍🍳',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F373',
        symbol: '🧑🏼‍🍳',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F373',
        symbol: '🧑🏽‍🍳',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F373',
        symbol: '🧑🏾‍🍳',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F373',
        symbol: '🧑🏿‍🍳',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F37C',
    'person_feeding_baby',
    ['person_feeding_baby'],
    'People & Body',
    362,
    13,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F37C',
        symbol: '🧑🏻‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F37C',
        symbol: '🧑🏼‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F37C',
        symbol: '🧑🏽‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F37C',
        symbol: '🧑🏾‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F37C',
        symbol: '🧑🏿‍🍼',
        addedIn: 13,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F384',
    'mx_claus',
    ['mx_claus'],
    'People & Body',
    366,
    13,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F384',
        symbol: '🧑🏻‍🎄',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F384',
        symbol: '🧑🏼‍🎄',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F384',
        symbol: '🧑🏽‍🎄',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F384',
        symbol: '🧑🏾‍🎄',
        addedIn: 13,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F384',
        symbol: '🧑🏿‍🎄',
        addedIn: 13,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F393',
    'student',
    ['student'],
    'People & Body',
    284,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F393',
        symbol: '🧑🏻‍🎓',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F393',
        symbol: '🧑🏼‍🎓',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F393',
        symbol: '🧑🏽‍🎓',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F393',
        symbol: '🧑🏾‍🎓',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F393',
        symbol: '🧑🏿‍🎓',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F3A4',
    'singer',
    ['singer'],
    'People & Body',
    314,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F3A4',
        symbol: '🧑🏻‍🎤',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F3A4',
        symbol: '🧑🏼‍🎤',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F3A4',
        symbol: '🧑🏽‍🎤',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F3A4',
        symbol: '🧑🏾‍🎤',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F3A4',
        symbol: '🧑🏿‍🎤',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F3A8',
    'artist',
    ['artist'],
    'People & Body',
    317,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F3A8',
        symbol: '🧑🏻‍🎨',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F3A8',
        symbol: '🧑🏼‍🎨',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F3A8',
        symbol: '🧑🏽‍🎨',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F3A8',
        symbol: '🧑🏾‍🎨',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F3A8',
        symbol: '🧑🏿‍🎨',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F3EB',
    'teacher',
    ['teacher'],
    'People & Body',
    287,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F3EB',
        symbol: '🧑🏻‍🏫',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F3EB',
        symbol: '🧑🏼‍🏫',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F3EB',
        symbol: '🧑🏽‍🏫',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F3EB',
        symbol: '🧑🏾‍🏫',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F3EB',
        symbol: '🧑🏿‍🏫',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F3ED',
    'factory_worker',
    ['factory_worker'],
    'People & Body',
    302,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F3ED',
        symbol: '🧑🏻‍🏭',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F3ED',
        symbol: '🧑🏼‍🏭',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F3ED',
        symbol: '🧑🏽‍🏭',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F3ED',
        symbol: '🧑🏾‍🏭',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F3ED',
        symbol: '🧑🏿‍🏭',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F4BB',
    'technologist',
    ['technologist'],
    'People & Body',
    311,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F4BB',
        symbol: '🧑🏻‍💻',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F4BB',
        symbol: '🧑🏼‍💻',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F4BB',
        symbol: '🧑🏽‍💻',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F4BB',
        symbol: '🧑🏾‍💻',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F4BB',
        symbol: '🧑🏿‍💻',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F4BC',
    'office_worker',
    ['office_worker'],
    'People & Body',
    305,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F4BC',
        symbol: '🧑🏻‍💼',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F4BC',
        symbol: '🧑🏼‍💼',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F4BC',
        symbol: '🧑🏽‍💼',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F4BC',
        symbol: '🧑🏾‍💼',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F4BC',
        symbol: '🧑🏿‍💼',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F527',
    'mechanic',
    ['mechanic'],
    'People & Body',
    299,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F527',
        symbol: '🧑🏻‍🔧',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F527',
        symbol: '🧑🏼‍🔧',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F527',
        symbol: '🧑🏽‍🔧',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F527',
        symbol: '🧑🏾‍🔧',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F527',
        symbol: '🧑🏿‍🔧',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F52C',
    'scientist',
    ['scientist'],
    'People & Body',
    308,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F52C',
        symbol: '🧑🏻‍🔬',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F52C',
        symbol: '🧑🏼‍🔬',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F52C',
        symbol: '🧑🏽‍🔬',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F52C',
        symbol: '🧑🏾‍🔬',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F52C',
        symbol: '🧑🏿‍🔬',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F680',
    'astronaut',
    ['astronaut'],
    'People & Body',
    323,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F680',
        symbol: '🧑🏻‍🚀',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F680',
        symbol: '🧑🏼‍🚀',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F680',
        symbol: '🧑🏽‍🚀',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F680',
        symbol: '🧑🏾‍🚀',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F680',
        symbol: '🧑🏿‍🚀',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F692',
    'firefighter',
    ['firefighter'],
    'People & Body',
    326,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F692',
        symbol: '🧑🏻‍🚒',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F692',
        symbol: '🧑🏼‍🚒',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F692',
        symbol: '🧑🏽‍🚒',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F692',
        symbol: '🧑🏾‍🚒',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F692',
        symbol: '🧑🏿‍🚒',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F91D-200D-1F9D1',
    'people_holding_hands',
    ['people_holding_hands'],
    'People & Body',
    482,
    12,
    true,
    {
      '1F3FB-1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FB',
        symbol: '🧑🏻‍🤝‍🧑🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FC': {
        unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FC',
        symbol: '🧑🏻‍🤝‍🧑🏼',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FD': {
        unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FD',
        symbol: '🧑🏻‍🤝‍🧑🏽',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FE': {
        unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FE',
        symbol: '🧑🏻‍🤝‍🧑🏾',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FB-1F3FF': {
        unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FF',
        symbol: '🧑🏻‍🤝‍🧑🏿',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FB': {
        unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FB',
        symbol: '🧑🏼‍🤝‍🧑🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FC',
        symbol: '🧑🏼‍🤝‍🧑🏼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FD': {
        unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FD',
        symbol: '🧑🏼‍🤝‍🧑🏽',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FE': {
        unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FE',
        symbol: '🧑🏼‍🤝‍🧑🏾',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC-1F3FF': {
        unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FF',
        symbol: '🧑🏼‍🤝‍🧑🏿',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FB': {
        unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FB',
        symbol: '🧑🏽‍🤝‍🧑🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FC': {
        unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FC',
        symbol: '🧑🏽‍🤝‍🧑🏼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FD',
        symbol: '🧑🏽‍🤝‍🧑🏽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FE': {
        unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FE',
        symbol: '🧑🏽‍🤝‍🧑🏾',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD-1F3FF': {
        unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FF',
        symbol: '🧑🏽‍🤝‍🧑🏿',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FB': {
        unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FB',
        symbol: '🧑🏾‍🤝‍🧑🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FC': {
        unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FC',
        symbol: '🧑🏾‍🤝‍🧑🏼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FD': {
        unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FD',
        symbol: '🧑🏾‍🤝‍🧑🏽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FE',
        symbol: '🧑🏾‍🤝‍🧑🏾',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FE-1F3FF': {
        unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FF',
        symbol: '🧑🏾‍🤝‍🧑🏿',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FB': {
        unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FB',
        symbol: '🧑🏿‍🤝‍🧑🏻',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FC': {
        unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FC',
        symbol: '🧑🏿‍🤝‍🧑🏼',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FD': {
        unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FD',
        symbol: '🧑🏿‍🤝‍🧑🏽',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FE': {
        unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FE',
        symbol: '🧑🏿‍🤝‍🧑🏾',
        addedIn: 12,
        hasImgTwitter: true,
      },
      '1F3FF-1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FF',
        symbol: '🧑🏿‍🤝‍🧑🏿',
        addedIn: 12,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F9AF',
    'person_with_probing_cane',
    ['person_with_probing_cane'],
    'People & Body',
    410,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F9AF',
        symbol: '🧑🏻‍🦯',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F9AF',
        symbol: '🧑🏼‍🦯',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F9AF',
        symbol: '🧑🏽‍🦯',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F9AF',
        symbol: '🧑🏾‍🦯',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F9AF',
        symbol: '🧑🏿‍🦯',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F9B0',
    'red_haired_person',
    ['red_haired_person'],
    'People & Body',
    239,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F9B0',
        symbol: '🧑🏻‍🦰',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F9B0',
        symbol: '🧑🏼‍🦰',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F9B0',
        symbol: '🧑🏽‍🦰',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F9B0',
        symbol: '🧑🏾‍🦰',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F9B0',
        symbol: '🧑🏿‍🦰',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F9B1',
    'curly_haired_person',
    ['curly_haired_person'],
    'People & Body',
    241,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F9B1',
        symbol: '🧑🏻‍🦱',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F9B1',
        symbol: '🧑🏼‍🦱',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F9B1',
        symbol: '🧑🏽‍🦱',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F9B1',
        symbol: '🧑🏾‍🦱',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F9B1',
        symbol: '🧑🏿‍🦱',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F9B2',
    'bald_person',
    ['bald_person'],
    'People & Body',
    245,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F9B2',
        symbol: '🧑🏻‍🦲',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F9B2',
        symbol: '🧑🏼‍🦲',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F9B2',
        symbol: '🧑🏽‍🦲',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F9B2',
        symbol: '🧑🏾‍🦲',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F9B2',
        symbol: '🧑🏿‍🦲',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F9B3',
    'white_haired_person',
    ['white_haired_person'],
    'People & Body',
    243,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F9B3',
        symbol: '🧑🏻‍🦳',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F9B3',
        symbol: '🧑🏼‍🦳',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F9B3',
        symbol: '🧑🏽‍🦳',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F9B3',
        symbol: '🧑🏾‍🦳',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F9B3',
        symbol: '🧑🏿‍🦳',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F9BC',
    'person_in_motorized_wheelchair',
    ['person_in_motorized_wheelchair'],
    'People & Body',
    413,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F9BC',
        symbol: '🧑🏻‍🦼',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F9BC',
        symbol: '🧑🏼‍🦼',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F9BC',
        symbol: '🧑🏽‍🦼',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F9BC',
        symbol: '🧑🏾‍🦼',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F9BC',
        symbol: '🧑🏿‍🦼',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-1F9BD',
    'person_in_manual_wheelchair',
    ['person_in_manual_wheelchair'],
    'People & Body',
    416,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-1F9BD',
        symbol: '🧑🏻‍🦽',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-1F9BD',
        symbol: '🧑🏼‍🦽',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-1F9BD',
        symbol: '🧑🏽‍🦽',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-1F9BD',
        symbol: '🧑🏾‍🦽',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-1F9BD',
        symbol: '🧑🏿‍🦽',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-2695-FE0F',
    'health_worker',
    ['health_worker'],
    'People & Body',
    281,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-2695-FE0F',
        symbol: '🧑🏻‍⚕️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-2695-FE0F',
        symbol: '🧑🏼‍⚕️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-2695-FE0F',
        symbol: '🧑🏽‍⚕️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-2695-FE0F',
        symbol: '🧑🏾‍⚕️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-2695-FE0F',
        symbol: '🧑🏿‍⚕️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-2696-FE0F',
    'judge',
    ['judge'],
    'People & Body',
    290,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-2696-FE0F',
        symbol: '🧑🏻‍⚖️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-2696-FE0F',
        symbol: '🧑🏼‍⚖️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-2696-FE0F',
        symbol: '🧑🏽‍⚖️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-2696-FE0F',
        symbol: '🧑🏾‍⚖️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-2696-FE0F',
        symbol: '🧑🏿‍⚖️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1-200D-2708-FE0F',
    'pilot',
    ['pilot'],
    'People & Body',
    320,
    12.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D1-1F3FB-200D-2708-FE0F',
        symbol: '🧑🏻‍✈️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D1-1F3FC-200D-2708-FE0F',
        symbol: '🧑🏼‍✈️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D1-1F3FD-200D-2708-FE0F',
        symbol: '🧑🏽‍✈️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D1-1F3FE-200D-2708-FE0F',
        symbol: '🧑🏾‍✈️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D1-1F3FF-200D-2708-FE0F',
        symbol: '🧑🏿‍✈️',
        addedIn: 12.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D1',
    'adult',
    ['adult'],
    'People & Body',
    227,
    5,
    true,
    {
      '1F3FB': { unified: '1F9D1-1F3FB', symbol: '🧑🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F9D1-1F3FC', symbol: '🧑🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F9D1-1F3FD', symbol: '🧑🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F9D1-1F3FE', symbol: '🧑🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F9D1-1F3FF', symbol: '🧑🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F9D2',
    'child',
    ['child'],
    'People & Body',
    224,
    5,
    true,
    {
      '1F3FB': { unified: '1F9D2-1F3FB', symbol: '🧒🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F9D2-1F3FC', symbol: '🧒🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F9D2-1F3FD', symbol: '🧒🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F9D2-1F3FE', symbol: '🧒🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F9D2-1F3FF', symbol: '🧒🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F9D3',
    'older_adult',
    ['older_adult'],
    'People & Body',
    248,
    5,
    true,
    {
      '1F3FB': { unified: '1F9D3-1F3FB', symbol: '🧓🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F9D3-1F3FC', symbol: '🧓🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F9D3-1F3FD', symbol: '🧓🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F9D3-1F3FE', symbol: '🧓🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F9D3-1F3FF', symbol: '🧓🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F9D4-200D-2640-FE0F',
    'woman_with_beard',
    ['woman_with_beard'],
    'People & Body',
    232,
    13.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D4-1F3FB-200D-2640-FE0F',
        symbol: '🧔🏻‍♀️',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D4-1F3FC-200D-2640-FE0F',
        symbol: '🧔🏼‍♀️',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D4-1F3FD-200D-2640-FE0F',
        symbol: '🧔🏽‍♀️',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D4-1F3FE-200D-2640-FE0F',
        symbol: '🧔🏾‍♀️',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D4-1F3FF-200D-2640-FE0F',
        symbol: '🧔🏿‍♀️',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D4-200D-2642-FE0F',
    'man_with_beard',
    ['man_with_beard'],
    'People & Body',
    231,
    13.1,
    true,
    {
      '1F3FB': {
        unified: '1F9D4-1F3FB-200D-2642-FE0F',
        symbol: '🧔🏻‍♂️',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D4-1F3FC-200D-2642-FE0F',
        symbol: '🧔🏼‍♂️',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D4-1F3FD-200D-2642-FE0F',
        symbol: '🧔🏽‍♂️',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D4-1F3FE-200D-2642-FE0F',
        symbol: '🧔🏾‍♂️',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D4-1F3FF-200D-2642-FE0F',
        symbol: '🧔🏿‍♂️',
        addedIn: 13.1,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D4',
    'bearded_person',
    ['bearded_person'],
    'People & Body',
    230,
    5,
    true,
    {
      '1F3FB': { unified: '1F9D4-1F3FB', symbol: '🧔🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F9D4-1F3FC', symbol: '🧔🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F9D4-1F3FD', symbol: '🧔🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F9D4-1F3FE', symbol: '🧔🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F9D4-1F3FF', symbol: '🧔🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F9D5',
    'person_with_headscarf',
    ['person_with_headscarf'],
    'People & Body',
    349,
    5,
    true,
    {
      '1F3FB': { unified: '1F9D5-1F3FB', symbol: '🧕🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F9D5-1F3FC', symbol: '🧕🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F9D5-1F3FD', symbol: '🧕🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F9D5-1F3FE', symbol: '🧕🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F9D5-1F3FF', symbol: '🧕🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F9D6-200D-2640-FE0F',
    'woman_in_steamy_room',
    ['woman_in_steamy_room'],
    'People & Body',
    430,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9D6-1F3FB-200D-2640-FE0F',
        symbol: '🧖🏻‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D6-1F3FC-200D-2640-FE0F',
        symbol: '🧖🏼‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D6-1F3FD-200D-2640-FE0F',
        symbol: '🧖🏽‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D6-1F3FE-200D-2640-FE0F',
        symbol: '🧖🏾‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D6-1F3FF-200D-2640-FE0F',
        symbol: '🧖🏿‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D6-200D-2642-FE0F',
    'man_in_steamy_room',
    ['man_in_steamy_room'],
    'People & Body',
    429,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9D6-1F3FB-200D-2642-FE0F',
        symbol: '🧖🏻‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D6-1F3FC-200D-2642-FE0F',
        symbol: '🧖🏼‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D6-1F3FD-200D-2642-FE0F',
        symbol: '🧖🏽‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D6-1F3FE-200D-2642-FE0F',
        symbol: '🧖🏾‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D6-1F3FF-200D-2642-FE0F',
        symbol: '🧖🏿‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D6',
    'person_in_steamy_room',
    ['person_in_steamy_room'],
    'People & Body',
    428,
    5,
    true,
    {
      '1F3FB': { unified: '1F9D6-1F3FB', symbol: '🧖🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F9D6-1F3FC', symbol: '🧖🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F9D6-1F3FD', symbol: '🧖🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F9D6-1F3FE', symbol: '🧖🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F9D6-1F3FF', symbol: '🧖🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F9D7-200D-2640-FE0F',
    'woman_climbing',
    ['woman_climbing'],
    'People & Body',
    433,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9D7-1F3FB-200D-2640-FE0F',
        symbol: '🧗🏻‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D7-1F3FC-200D-2640-FE0F',
        symbol: '🧗🏼‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D7-1F3FD-200D-2640-FE0F',
        symbol: '🧗🏽‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D7-1F3FE-200D-2640-FE0F',
        symbol: '🧗🏾‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D7-1F3FF-200D-2640-FE0F',
        symbol: '🧗🏿‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D7-200D-2642-FE0F',
    'man_climbing',
    ['man_climbing'],
    'People & Body',
    432,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9D7-1F3FB-200D-2642-FE0F',
        symbol: '🧗🏻‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D7-1F3FC-200D-2642-FE0F',
        symbol: '🧗🏼‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D7-1F3FD-200D-2642-FE0F',
        symbol: '🧗🏽‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D7-1F3FE-200D-2642-FE0F',
        symbol: '🧗🏾‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D7-1F3FF-200D-2642-FE0F',
        symbol: '🧗🏿‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D7',
    'person_climbing',
    ['person_climbing'],
    'People & Body',
    431,
    5,
    true,
    {
      '1F3FB': { unified: '1F9D7-1F3FB', symbol: '🧗🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F9D7-1F3FC', symbol: '🧗🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F9D7-1F3FD', symbol: '🧗🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F9D7-1F3FE', symbol: '🧗🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F9D7-1F3FF', symbol: '🧗🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F9D8-200D-2640-FE0F',
    'woman_in_lotus_position',
    ['woman_in_lotus_position'],
    'People & Body',
    479,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9D8-1F3FB-200D-2640-FE0F',
        symbol: '🧘🏻‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D8-1F3FC-200D-2640-FE0F',
        symbol: '🧘🏼‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D8-1F3FD-200D-2640-FE0F',
        symbol: '🧘🏽‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D8-1F3FE-200D-2640-FE0F',
        symbol: '🧘🏾‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D8-1F3FF-200D-2640-FE0F',
        symbol: '🧘🏿‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D8-200D-2642-FE0F',
    'man_in_lotus_position',
    ['man_in_lotus_position'],
    'People & Body',
    478,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9D8-1F3FB-200D-2642-FE0F',
        symbol: '🧘🏻‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D8-1F3FC-200D-2642-FE0F',
        symbol: '🧘🏼‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D8-1F3FD-200D-2642-FE0F',
        symbol: '🧘🏽‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D8-1F3FE-200D-2642-FE0F',
        symbol: '🧘🏾‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D8-1F3FF-200D-2642-FE0F',
        symbol: '🧘🏿‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D8',
    'person_in_lotus_position',
    ['person_in_lotus_position'],
    'People & Body',
    477,
    5,
    true,
    {
      '1F3FB': { unified: '1F9D8-1F3FB', symbol: '🧘🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F9D8-1F3FC', symbol: '🧘🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F9D8-1F3FD', symbol: '🧘🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F9D8-1F3FE', symbol: '🧘🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F9D8-1F3FF', symbol: '🧘🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F9D9-200D-2640-FE0F',
    'female_mage',
    ['female_mage'],
    'People & Body',
    375,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9D9-1F3FB-200D-2640-FE0F',
        symbol: '🧙🏻‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D9-1F3FC-200D-2640-FE0F',
        symbol: '🧙🏼‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D9-1F3FD-200D-2640-FE0F',
        symbol: '🧙🏽‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D9-1F3FE-200D-2640-FE0F',
        symbol: '🧙🏾‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D9-1F3FF-200D-2640-FE0F',
        symbol: '🧙🏿‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D9-200D-2642-FE0F',
    'male_mage',
    ['male_mage'],
    'People & Body',
    374,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9D9-1F3FB-200D-2642-FE0F',
        symbol: '🧙🏻‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9D9-1F3FC-200D-2642-FE0F',
        symbol: '🧙🏼‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9D9-1F3FD-200D-2642-FE0F',
        symbol: '🧙🏽‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9D9-1F3FE-200D-2642-FE0F',
        symbol: '🧙🏾‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9D9-1F3FF-200D-2642-FE0F',
        symbol: '🧙🏿‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9D9',
    'mage',
    ['mage'],
    'People & Body',
    373,
    5,
    true,
    {
      '1F3FB': { unified: '1F9D9-1F3FB', symbol: '🧙🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F9D9-1F3FC', symbol: '🧙🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F9D9-1F3FD', symbol: '🧙🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F9D9-1F3FE', symbol: '🧙🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F9D9-1F3FF', symbol: '🧙🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F9DA-200D-2640-FE0F',
    'female_fairy',
    ['female_fairy'],
    'People & Body',
    378,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9DA-1F3FB-200D-2640-FE0F',
        symbol: '🧚🏻‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9DA-1F3FC-200D-2640-FE0F',
        symbol: '🧚🏼‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9DA-1F3FD-200D-2640-FE0F',
        symbol: '🧚🏽‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9DA-1F3FE-200D-2640-FE0F',
        symbol: '🧚🏾‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9DA-1F3FF-200D-2640-FE0F',
        symbol: '🧚🏿‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9DA-200D-2642-FE0F',
    'male_fairy',
    ['male_fairy'],
    'People & Body',
    377,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9DA-1F3FB-200D-2642-FE0F',
        symbol: '🧚🏻‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9DA-1F3FC-200D-2642-FE0F',
        symbol: '🧚🏼‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9DA-1F3FD-200D-2642-FE0F',
        symbol: '🧚🏽‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9DA-1F3FE-200D-2642-FE0F',
        symbol: '🧚🏾‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9DA-1F3FF-200D-2642-FE0F',
        symbol: '🧚🏿‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9DA',
    'fairy',
    ['fairy'],
    'People & Body',
    376,
    5,
    true,
    {
      '1F3FB': { unified: '1F9DA-1F3FB', symbol: '🧚🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F9DA-1F3FC', symbol: '🧚🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F9DA-1F3FD', symbol: '🧚🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F9DA-1F3FE', symbol: '🧚🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F9DA-1F3FF', symbol: '🧚🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F9DB-200D-2640-FE0F',
    'female_vampire',
    ['female_vampire'],
    'People & Body',
    381,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9DB-1F3FB-200D-2640-FE0F',
        symbol: '🧛🏻‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9DB-1F3FC-200D-2640-FE0F',
        symbol: '🧛🏼‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9DB-1F3FD-200D-2640-FE0F',
        symbol: '🧛🏽‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9DB-1F3FE-200D-2640-FE0F',
        symbol: '🧛🏾‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9DB-1F3FF-200D-2640-FE0F',
        symbol: '🧛🏿‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9DB-200D-2642-FE0F',
    'male_vampire',
    ['male_vampire'],
    'People & Body',
    380,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9DB-1F3FB-200D-2642-FE0F',
        symbol: '🧛🏻‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9DB-1F3FC-200D-2642-FE0F',
        symbol: '🧛🏼‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9DB-1F3FD-200D-2642-FE0F',
        symbol: '🧛🏽‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9DB-1F3FE-200D-2642-FE0F',
        symbol: '🧛🏾‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9DB-1F3FF-200D-2642-FE0F',
        symbol: '🧛🏿‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9DB',
    'vampire',
    ['vampire'],
    'People & Body',
    379,
    5,
    true,
    {
      '1F3FB': { unified: '1F9DB-1F3FB', symbol: '🧛🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F9DB-1F3FC', symbol: '🧛🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F9DB-1F3FD', symbol: '🧛🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F9DB-1F3FE', symbol: '🧛🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F9DB-1F3FF', symbol: '🧛🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F9DC-200D-2640-FE0F',
    'mermaid',
    ['mermaid'],
    'People & Body',
    384,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9DC-1F3FB-200D-2640-FE0F',
        symbol: '🧜🏻‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9DC-1F3FC-200D-2640-FE0F',
        symbol: '🧜🏼‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9DC-1F3FD-200D-2640-FE0F',
        symbol: '🧜🏽‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9DC-1F3FE-200D-2640-FE0F',
        symbol: '🧜🏾‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9DC-1F3FF-200D-2640-FE0F',
        symbol: '🧜🏿‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9DC-200D-2642-FE0F',
    'merman',
    ['merman'],
    'People & Body',
    383,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9DC-1F3FB-200D-2642-FE0F',
        symbol: '🧜🏻‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9DC-1F3FC-200D-2642-FE0F',
        symbol: '🧜🏼‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9DC-1F3FD-200D-2642-FE0F',
        symbol: '🧜🏽‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9DC-1F3FE-200D-2642-FE0F',
        symbol: '🧜🏾‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9DC-1F3FF-200D-2642-FE0F',
        symbol: '🧜🏿‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9DC',
    'merperson',
    ['merperson'],
    'People & Body',
    382,
    5,
    true,
    {
      '1F3FB': { unified: '1F9DC-1F3FB', symbol: '🧜🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F9DC-1F3FC', symbol: '🧜🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F9DC-1F3FD', symbol: '🧜🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F9DC-1F3FE', symbol: '🧜🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F9DC-1F3FF', symbol: '🧜🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  [
    '1F9DD-200D-2640-FE0F',
    'female_elf',
    ['female_elf'],
    'People & Body',
    387,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9DD-1F3FB-200D-2640-FE0F',
        symbol: '🧝🏻‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9DD-1F3FC-200D-2640-FE0F',
        symbol: '🧝🏼‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9DD-1F3FD-200D-2640-FE0F',
        symbol: '🧝🏽‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9DD-1F3FE-200D-2640-FE0F',
        symbol: '🧝🏾‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9DD-1F3FF-200D-2640-FE0F',
        symbol: '🧝🏿‍♀️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9DD-200D-2642-FE0F',
    'male_elf',
    ['male_elf'],
    'People & Body',
    386,
    5,
    true,
    {
      '1F3FB': {
        unified: '1F9DD-1F3FB-200D-2642-FE0F',
        symbol: '🧝🏻‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '1F9DD-1F3FC-200D-2642-FE0F',
        symbol: '🧝🏼‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '1F9DD-1F3FD-200D-2642-FE0F',
        symbol: '🧝🏽‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '1F9DD-1F3FE-200D-2642-FE0F',
        symbol: '🧝🏾‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '1F9DD-1F3FF-200D-2642-FE0F',
        symbol: '🧝🏿‍♂️',
        addedIn: 5,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '1F9DD',
    'elf',
    ['elf'],
    'People & Body',
    385,
    5,
    true,
    {
      '1F3FB': { unified: '1F9DD-1F3FB', symbol: '🧝🏻', addedIn: 5, hasImgTwitter: true },
      '1F3FC': { unified: '1F9DD-1F3FC', symbol: '🧝🏼', addedIn: 5, hasImgTwitter: true },
      '1F3FD': { unified: '1F9DD-1F3FD', symbol: '🧝🏽', addedIn: 5, hasImgTwitter: true },
      '1F3FE': { unified: '1F9DD-1F3FE', symbol: '🧝🏾', addedIn: 5, hasImgTwitter: true },
      '1F3FF': { unified: '1F9DD-1F3FF', symbol: '🧝🏿', addedIn: 5, hasImgTwitter: true },
    },
  ],
  ['1F9DE-200D-2640-FE0F', 'female_genie', ['female_genie'], 'People & Body', 390, 5, true, null],
  ['1F9DE-200D-2642-FE0F', 'male_genie', ['male_genie'], 'People & Body', 389, 5, true, null],
  ['1F9DE', 'genie', ['genie'], 'People & Body', 388, 5, true, null],
  ['1F9DF-200D-2640-FE0F', 'female_zombie', ['female_zombie'], 'People & Body', 393, 5, true, null],
  ['1F9DF-200D-2642-FE0F', 'male_zombie', ['male_zombie'], 'People & Body', 392, 5, true, null],
  ['1F9DF', 'zombie', ['zombie'], 'People & Body', 391, 5, true, null],
  ['1F9E0', 'brain', ['brain'], 'People & Body', 213, 5, true, null],
  ['1F9E1', 'orange_heart', ['orange_heart'], 'Smileys & Emotion', 142, 5, true, null],
  ['1F9E2', 'billed_cap', ['billed_cap'], 'Objects', 1148, 5, true, null],
  ['1F9E3', 'scarf', ['scarf'], 'Objects', 1118, 5, true, null],
  ['1F9E4', 'gloves', ['gloves'], 'Objects', 1119, 5, true, null],
  ['1F9E5', 'coat', ['coat'], 'Objects', 1120, 5, true, null],
  ['1F9E6', 'socks', ['socks'], 'Objects', 1121, 5, true, null],
  ['1F9E7', 'red_envelope', ['red_envelope'], 'Activities', 1039, 11, true, null],
  ['1F9E8', 'firecracker', ['firecracker'], 'Activities', 1028, 11, true, null],
  ['1F9E9', 'jigsaw', ['jigsaw'], 'Activities', 1090, 11, true, null],
  ['1F9EA', 'test_tube', ['test_tube'], 'Objects', 1320, 11, true, null],
  ['1F9EB', 'petri_dish', ['petri_dish'], 'Objects', 1321, 11, true, null],
  ['1F9EC', 'dna', ['dna'], 'Objects', 1322, 11, true, null],
  ['1F9ED', 'compass', ['compass'], 'Travel & Places', 812, 11, true, null],
  ['1F9EE', 'abacus', ['abacus'], 'Objects', 1201, 11, true, null],
  ['1F9EF', 'fire_extinguisher', ['fire_extinguisher'], 'Objects', 1356, 11, true, null],
  ['1F9F0', 'toolbox', ['toolbox'], 'Objects', 1316, 11, true, null],
  ['1F9F1', 'bricks', ['bricks'], 'Travel & Places', 825, 11, true, null],
  ['1F9F2', 'magnet', ['magnet'], 'Objects', 1317, 11, true, null],
  ['1F9F3', 'luggage', ['luggage'], 'Travel & Places', 945, 11, true, null],
  ['1F9F4', 'lotion_bottle', ['lotion_bottle'], 'Objects', 1346, 11, true, null],
  ['1F9F5', 'thread', ['thread'], 'Activities', 1106, 11, true, null],
  ['1F9F6', 'yarn', ['yarn'], 'Activities', 1108, 11, true, null],
  ['1F9F7', 'safety_pin', ['safety_pin'], 'Objects', 1347, 11, true, null],
  ['1F9F8', 'teddy_bear', ['teddy_bear'], 'Activities', 1091, 11, true, null],
  ['1F9F9', 'broom', ['broom'], 'Objects', 1348, 11, true, null],
  ['1F9FA', 'basket', ['basket'], 'Objects', 1349, 11, true, null],
  ['1F9FB', 'roll_of_paper', ['roll_of_paper'], 'Objects', 1350, 11, true, null],
  ['1F9FC', 'soap', ['soap'], 'Objects', 1352, 11, true, null],
  ['1F9FD', 'sponge', ['sponge'], 'Objects', 1355, 11, true, null],
  ['1F9FE', 'receipt', ['receipt'], 'Objects', 1243, 11, true, null],
  ['1F9FF', 'nazar_amulet', ['nazar_amulet'], 'Activities', 1084, 11, true, null],
  ['1FA70', 'ballet_shoes', ['ballet_shoes'], 'Objects', 1142, 12, true, null],
  ['1FA71', 'one-piece_swimsuit', ['one-piece_swimsuit'], 'Objects', 1125, 12, true, null],
  ['1FA72', 'briefs', ['briefs'], 'Objects', 1126, 12, true, null],
  ['1FA73', 'shorts', ['shorts'], 'Objects', 1127, 12, true, null],
  ['1FA74', 'thong_sandal', ['thong_sandal'], 'Objects', 1135, 13, true, null],
  ['1FA78', 'drop_of_blood', ['drop_of_blood'], 'Objects', 1327, 12, true, null],
  ['1FA79', 'adhesive_bandage', ['adhesive_bandage'], 'Objects', 1329, 12, true, null],
  ['1FA7A', 'stethoscope', ['stethoscope'], 'Objects', 1331, 12, true, null],
  ['1FA7B', 'x-ray', ['x-ray'], 'Objects', 1332, 14, true, null],
  ['1FA7C', 'crutch', ['crutch'], 'Objects', 1330, 14, true, null],
  ['1FA80', 'yo-yo', ['yo-yo'], 'Activities', 1079, 12, true, null],
  ['1FA81', 'kite', ['kite'], 'Activities', 1080, 12, true, null],
  ['1FA82', 'parachute', ['parachute'], 'Travel & Places', 935, 12, true, null],
  ['1FA83', 'boomerang', ['boomerang'], 'Objects', 1302, 13, true, null],
  ['1FA84', 'magic_wand', ['magic_wand'], 'Activities', 1083, 13, true, null],
  ['1FA85', 'pinata', ['pinata'], 'Activities', 1092, 13, true, null],
  ['1FA86', 'nesting_dolls', ['nesting_dolls'], 'Activities', 1094, 13, true, null],
  ['1FA90', 'ringed_planet', ['ringed_planet'], 'Travel & Places', 993, 12, true, null],
  ['1FA91', 'chair', ['chair'], 'Objects', 1339, 12, true, null],
  ['1FA92', 'razor', ['razor'], 'Objects', 1345, 12, true, null],
  ['1FA93', 'axe', ['axe'], 'Objects', 1295, 12, true, null],
  ['1FA94', 'diya_lamp', ['diya_lamp'], 'Objects', 1217, 12, true, null],
  ['1FA95', 'banjo', ['banjo'], 'Objects', 1179, 12, true, null],
  ['1FA96', 'military_helmet', ['military_helmet'], 'Objects', 1149, 13, true, null],
  ['1FA97', 'accordion', ['accordion'], 'Objects', 1174, 13, true, null],
  ['1FA98', 'long_drum', ['long_drum'], 'Objects', 1181, 13, true, null],
  ['1FA99', 'coin', ['coin'], 'Objects', 1236, 13, true, null],
  ['1FA9A', 'carpentry_saw', ['carpentry_saw'], 'Objects', 1305, 13, true, null],
  ['1FA9B', 'screwdriver', ['screwdriver'], 'Objects', 1307, 13, true, null],
  ['1FA9C', 'ladder', ['ladder'], 'Objects', 1318, 13, true, null],
  ['1FA9D', 'hook', ['hook'], 'Objects', 1315, 13, true, null],
  ['1FA9E', 'mirror', ['mirror'], 'Objects', 1335, 13, true, null],
  ['1FA9F', 'window', ['window'], 'Objects', 1336, 13, true, null],
  ['1FAA0', 'plunger', ['plunger'], 'Objects', 1341, 13, true, null],
  ['1FAA1', 'sewing_needle', ['sewing_needle'], 'Activities', 1107, 13, true, null],
  ['1FAA2', 'knot', ['knot'], 'Activities', 1109, 13, true, null],
  ['1FAA3', 'bucket', ['bucket'], 'Objects', 1351, 13, true, null],
  ['1FAA4', 'mouse_trap', ['mouse_trap'], 'Objects', 1344, 13, true, null],
  ['1FAA5', 'toothbrush', ['toothbrush'], 'Objects', 1354, 13, true, null],
  ['1FAA6', 'headstone', ['headstone'], 'Objects', 1360, 13, true, null],
  ['1FAA7', 'placard', ['placard'], 'Objects', 1363, 13, true, null],
  ['1FAA8', 'rock', ['rock'], 'Travel & Places', 826, 13, true, null],
  ['1FAA9', 'mirror_ball', ['mirror_ball'], 'Activities', 1093, 14, true, null],
  ['1FAAA', 'identification_card', ['identification_card'], 'Objects', 1364, 14, true, null],
  ['1FAAB', 'low_battery', ['low_battery'], 'Objects', 1189, 14, true, null],
  ['1FAAC', 'hamsa', ['hamsa'], 'Activities', 1085, 14, true, null],
  ['1FAB0', 'fly', ['fly'], 'Animals & Nature', 645, 13, true, null],
  ['1FAB1', 'worm', ['worm'], 'Animals & Nature', 646, 13, true, null],
  ['1FAB2', 'beetle', ['beetle'], 'Animals & Nature', 637, 13, true, null],
  ['1FAB3', 'cockroach', ['cockroach'], 'Animals & Nature', 640, 13, true, null],
  ['1FAB4', 'potted_plant', ['potted_plant'], 'Animals & Nature', 660, 13, true, null],
  ['1FAB5', 'wood', ['wood'], 'Travel & Places', 827, 13, true, null],
  ['1FAB6', 'feather', ['feather'], 'Animals & Nature', 608, 13, true, null],
  ['1FAB7', 'lotus', ['lotus'], 'Animals & Nature', 651, 14, true, null],
  ['1FAB8', 'coral', ['coral'], 'Animals & Nature', 631, 14, true, null],
  ['1FAB9', 'empty_nest', ['empty_nest'], 'Animals & Nature', 672, 14, true, null],
  ['1FABA', 'nest_with_eggs', ['nest_with_eggs'], 'Animals & Nature', 673, 14, true, null],
  ['1FAC0', 'anatomical_heart', ['anatomical_heart'], 'People & Body', 214, 13, true, null],
  ['1FAC1', 'lungs', ['lungs'], 'People & Body', 215, 13, true, null],
  ['1FAC2', 'people_hugging', ['people_hugging'], 'People & Body', 523, 13, true, null],
  [
    '1FAC3',
    'pregnant_man',
    ['pregnant_man'],
    'People & Body',
    357,
    14,
    true,
    {
      '1F3FB': { unified: '1FAC3-1F3FB', symbol: '🫃🏻', addedIn: 14, hasImgTwitter: true },
      '1F3FC': { unified: '1FAC3-1F3FC', symbol: '🫃🏼', addedIn: 14, hasImgTwitter: true },
      '1F3FD': { unified: '1FAC3-1F3FD', symbol: '🫃🏽', addedIn: 14, hasImgTwitter: true },
      '1F3FE': { unified: '1FAC3-1F3FE', symbol: '🫃🏾', addedIn: 14, hasImgTwitter: true },
      '1F3FF': { unified: '1FAC3-1F3FF', symbol: '🫃🏿', addedIn: 14, hasImgTwitter: true },
    },
  ],
  [
    '1FAC4',
    'pregnant_person',
    ['pregnant_person'],
    'People & Body',
    358,
    14,
    true,
    {
      '1F3FB': { unified: '1FAC4-1F3FB', symbol: '🫄🏻', addedIn: 14, hasImgTwitter: true },
      '1F3FC': { unified: '1FAC4-1F3FC', symbol: '🫄🏼', addedIn: 14, hasImgTwitter: true },
      '1F3FD': { unified: '1FAC4-1F3FD', symbol: '🫄🏽', addedIn: 14, hasImgTwitter: true },
      '1F3FE': { unified: '1FAC4-1F3FE', symbol: '🫄🏾', addedIn: 14, hasImgTwitter: true },
      '1F3FF': { unified: '1FAC4-1F3FF', symbol: '🫄🏿', addedIn: 14, hasImgTwitter: true },
    },
  ],
  [
    '1FAC5',
    'person_with_crown',
    ['person_with_crown'],
    'People & Body',
    342,
    14,
    true,
    {
      '1F3FB': { unified: '1FAC5-1F3FB', symbol: '🫅🏻', addedIn: 14, hasImgTwitter: true },
      '1F3FC': { unified: '1FAC5-1F3FC', symbol: '🫅🏼', addedIn: 14, hasImgTwitter: true },
      '1F3FD': { unified: '1FAC5-1F3FD', symbol: '🫅🏽', addedIn: 14, hasImgTwitter: true },
      '1F3FE': { unified: '1FAC5-1F3FE', symbol: '🫅🏾', addedIn: 14, hasImgTwitter: true },
      '1F3FF': { unified: '1FAC5-1F3FF', symbol: '🫅🏿', addedIn: 14, hasImgTwitter: true },
    },
  ],
  ['1FAD0', 'blueberries', ['blueberries'], 'Food & Drink', 688, 13, true, null],
  ['1FAD1', 'bell_pepper', ['bell_pepper'], 'Food & Drink', 699, 13, true, null],
  ['1FAD2', 'olive', ['olive'], 'Food & Drink', 691, 13, true, null],
  ['1FAD3', 'flatbread', ['flatbread'], 'Food & Drink', 712, 13, true, null],
  ['1FAD4', 'tamale', ['tamale'], 'Food & Drink', 729, 13, true, null],
  ['1FAD5', 'fondue', ['fondue'], 'Food & Drink', 736, 13, true, null],
  ['1FAD6', 'teapot', ['teapot'], 'Food & Drink', 782, 13, true, null],
  ['1FAD7', 'pouring_liquid', ['pouring_liquid'], 'Food & Drink', 793, 14, true, null],
  ['1FAD8', 'beans', ['beans'], 'Food & Drink', 707, 14, true, null],
  ['1FAD9', 'jar', ['jar'], 'Food & Drink', 804, 14, true, null],
  ['1FAE0', 'melting_face', ['melting_face'], 'Smileys & Emotion', 11, 14, true, null],
  ['1FAE1', 'saluting_face', ['saluting_face'], 'Smileys & Emotion', 36, 14, true, null],
  [
    '1FAE2',
    'face_with_open_eyes_and_hand_over_mouth',
    ['face_with_open_eyes_and_hand_over_mouth'],
    'Smileys & Emotion',
    32,
    14,
    true,
    null,
  ],
  [
    '1FAE3',
    'face_with_peeking_eye',
    ['face_with_peeking_eye'],
    'Smileys & Emotion',
    33,
    14,
    true,
    null,
  ],
  [
    '1FAE4',
    'face_with_diagonal_mouth',
    ['face_with_diagonal_mouth'],
    'Smileys & Emotion',
    74,
    14,
    true,
    null,
  ],
  ['1FAE5', 'dotted_line_face', ['dotted_line_face'], 'Smileys & Emotion', 42, 14, true, null],
  ['1FAE6', 'biting_lip', ['biting_lip'], 'People & Body', 222, 14, true, null],
  ['1FAE7', 'bubbles', ['bubbles'], 'Objects', 1353, 14, true, null],
  [
    '1FAF0',
    'hand_with_index_finger_and_thumb_crossed',
    ['hand_with_index_finger_and_thumb_crossed'],
    'People & Body',
    178,
    14,
    true,
    {
      '1F3FB': { unified: '1FAF0-1F3FB', symbol: '🫰🏻', addedIn: 14, hasImgTwitter: true },
      '1F3FC': { unified: '1FAF0-1F3FC', symbol: '🫰🏼', addedIn: 14, hasImgTwitter: true },
      '1F3FD': { unified: '1FAF0-1F3FD', symbol: '🫰🏽', addedIn: 14, hasImgTwitter: true },
      '1F3FE': { unified: '1FAF0-1F3FE', symbol: '🫰🏾', addedIn: 14, hasImgTwitter: true },
      '1F3FF': { unified: '1FAF0-1F3FF', symbol: '🫰🏿', addedIn: 14, hasImgTwitter: true },
    },
  ],
  [
    '1FAF1',
    'rightwards_hand',
    ['rightwards_hand'],
    'People & Body',
    169,
    14,
    true,
    {
      '1F3FB': { unified: '1FAF1-1F3FB', symbol: '🫱🏻', addedIn: 14, hasImgTwitter: true },
      '1F3FC': { unified: '1FAF1-1F3FC', symbol: '🫱🏼', addedIn: 14, hasImgTwitter: true },
      '1F3FD': { unified: '1FAF1-1F3FD', symbol: '🫱🏽', addedIn: 14, hasImgTwitter: true },
      '1F3FE': { unified: '1FAF1-1F3FE', symbol: '🫱🏾', addedIn: 14, hasImgTwitter: true },
      '1F3FF': { unified: '1FAF1-1F3FF', symbol: '🫱🏿', addedIn: 14, hasImgTwitter: true },
    },
  ],
  [
    '1FAF2',
    'leftwards_hand',
    ['leftwards_hand'],
    'People & Body',
    170,
    14,
    true,
    {
      '1F3FB': { unified: '1FAF2-1F3FB', symbol: '🫲🏻', addedIn: 14, hasImgTwitter: true },
      '1F3FC': { unified: '1FAF2-1F3FC', symbol: '🫲🏼', addedIn: 14, hasImgTwitter: true },
      '1F3FD': { unified: '1FAF2-1F3FD', symbol: '🫲🏽', addedIn: 14, hasImgTwitter: true },
      '1F3FE': { unified: '1FAF2-1F3FE', symbol: '🫲🏾', addedIn: 14, hasImgTwitter: true },
      '1F3FF': { unified: '1FAF2-1F3FF', symbol: '🫲🏿', addedIn: 14, hasImgTwitter: true },
    },
  ],
  [
    '1FAF3',
    'palm_down_hand',
    ['palm_down_hand'],
    'People & Body',
    171,
    14,
    true,
    {
      '1F3FB': { unified: '1FAF3-1F3FB', symbol: '🫳🏻', addedIn: 14, hasImgTwitter: true },
      '1F3FC': { unified: '1FAF3-1F3FC', symbol: '🫳🏼', addedIn: 14, hasImgTwitter: true },
      '1F3FD': { unified: '1FAF3-1F3FD', symbol: '🫳🏽', addedIn: 14, hasImgTwitter: true },
      '1F3FE': { unified: '1FAF3-1F3FE', symbol: '🫳🏾', addedIn: 14, hasImgTwitter: true },
      '1F3FF': { unified: '1FAF3-1F3FF', symbol: '🫳🏿', addedIn: 14, hasImgTwitter: true },
    },
  ],
  [
    '1FAF4',
    'palm_up_hand',
    ['palm_up_hand'],
    'People & Body',
    172,
    14,
    true,
    {
      '1F3FB': { unified: '1FAF4-1F3FB', symbol: '🫴🏻', addedIn: 14, hasImgTwitter: true },
      '1F3FC': { unified: '1FAF4-1F3FC', symbol: '🫴🏼', addedIn: 14, hasImgTwitter: true },
      '1F3FD': { unified: '1FAF4-1F3FD', symbol: '🫴🏽', addedIn: 14, hasImgTwitter: true },
      '1F3FE': { unified: '1FAF4-1F3FE', symbol: '🫴🏾', addedIn: 14, hasImgTwitter: true },
      '1F3FF': { unified: '1FAF4-1F3FF', symbol: '🫴🏿', addedIn: 14, hasImgTwitter: true },
    },
  ],
  [
    '1FAF5',
    'index_pointing_at_the_viewer',
    ['index_pointing_at_the_viewer'],
    'People & Body',
    188,
    14,
    true,
    {
      '1F3FB': { unified: '1FAF5-1F3FB', symbol: '🫵🏻', addedIn: 14, hasImgTwitter: true },
      '1F3FC': { unified: '1FAF5-1F3FC', symbol: '🫵🏼', addedIn: 14, hasImgTwitter: true },
      '1F3FD': { unified: '1FAF5-1F3FD', symbol: '🫵🏽', addedIn: 14, hasImgTwitter: true },
      '1F3FE': { unified: '1FAF5-1F3FE', symbol: '🫵🏾', addedIn: 14, hasImgTwitter: true },
      '1F3FF': { unified: '1FAF5-1F3FF', symbol: '🫵🏿', addedIn: 14, hasImgTwitter: true },
    },
  ],
  [
    '1FAF6',
    'heart_hands',
    ['heart_hands'],
    'People & Body',
    197,
    14,
    true,
    {
      '1F3FB': { unified: '1FAF6-1F3FB', symbol: '🫶🏻', addedIn: 14, hasImgTwitter: true },
      '1F3FC': { unified: '1FAF6-1F3FC', symbol: '🫶🏼', addedIn: 14, hasImgTwitter: true },
      '1F3FD': { unified: '1FAF6-1F3FD', symbol: '🫶🏽', addedIn: 14, hasImgTwitter: true },
      '1F3FE': { unified: '1FAF6-1F3FE', symbol: '🫶🏾', addedIn: 14, hasImgTwitter: true },
      '1F3FF': { unified: '1FAF6-1F3FF', symbol: '🫶🏿', addedIn: 14, hasImgTwitter: true },
    },
  ],
  ['203C-FE0F', 'bangbang', ['bangbang'], 'Symbols', 1470, 0.6, true, null],
  ['2049-FE0F', 'interrobang', ['interrobang'], 'Symbols', 1471, 0.6, true, null],
  ['2122-FE0F', 'tm', ['tm'], 'Symbols', 1499, 0.6, true, null],
  ['2139-FE0F', 'information_source', ['information_source'], 'Symbols', 1524, 0.6, true, null],
  ['2194-FE0F', 'left_right_arrow', ['left_right_arrow'], 'Symbols', 1400, 0.6, true, null],
  ['2195-FE0F', 'arrow_up_down', ['arrow_up_down'], 'Symbols', 1399, 0.6, true, null],
  ['2196-FE0F', 'arrow_upper_left', ['arrow_upper_left'], 'Symbols', 1398, 0.6, true, null],
  ['2197-FE0F', 'arrow_upper_right', ['arrow_upper_right'], 'Symbols', 1392, 0.6, true, null],
  ['2198-FE0F', 'arrow_lower_right', ['arrow_lower_right'], 'Symbols', 1394, 0.6, true, null],
  ['2199-FE0F', 'arrow_lower_left', ['arrow_lower_left'], 'Symbols', 1396, 0.6, true, null],
  [
    '21A9-FE0F',
    'leftwards_arrow_with_hook',
    ['leftwards_arrow_with_hook'],
    'Symbols',
    1401,
    0.6,
    true,
    null,
  ],
  ['21AA-FE0F', 'arrow_right_hook', ['arrow_right_hook'], 'Symbols', 1402, 0.6, true, null],
  ['231A', 'watch', ['watch'], 'Travel & Places', 948, 0.6, true, null],
  ['231B', 'hourglass', ['hourglass'], 'Travel & Places', 946, 0.6, true, null],
  ['2328-FE0F', 'keyboard', ['keyboard'], 'Objects', 1194, 1, true, null],
  ['23CF-FE0F', 'eject', ['eject'], 'Symbols', 1454, 1, true, null],
  ['23E9', 'fast_forward', ['fast_forward'], 'Symbols', 1441, 0.6, true, null],
  ['23EA', 'rewind', ['rewind'], 'Symbols', 1445, 0.6, true, null],
  ['23EB', 'arrow_double_up', ['arrow_double_up'], 'Symbols', 1448, 0.6, true, null],
  ['23EC', 'arrow_double_down', ['arrow_double_down'], 'Symbols', 1450, 0.6, true, null],
  [
    '23ED-FE0F',
    'black_right_pointing_double_triangle_with_vertical_bar',
    ['black_right_pointing_double_triangle_with_vertical_bar'],
    'Symbols',
    1442,
    0.7,
    true,
    null,
  ],
  [
    '23EE-FE0F',
    'black_left_pointing_double_triangle_with_vertical_bar',
    ['black_left_pointing_double_triangle_with_vertical_bar'],
    'Symbols',
    1446,
    0.7,
    true,
    null,
  ],
  [
    '23EF-FE0F',
    'black_right_pointing_triangle_with_double_vertical_bar',
    ['black_right_pointing_triangle_with_double_vertical_bar'],
    'Symbols',
    1443,
    1,
    true,
    null,
  ],
  ['23F0', 'alarm_clock', ['alarm_clock'], 'Travel & Places', 949, 0.6, true, null],
  ['23F1-FE0F', 'stopwatch', ['stopwatch'], 'Travel & Places', 950, 1, true, null],
  ['23F2-FE0F', 'timer_clock', ['timer_clock'], 'Travel & Places', 951, 1, true, null],
  [
    '23F3',
    'hourglass_flowing_sand',
    ['hourglass_flowing_sand'],
    'Travel & Places',
    947,
    0.6,
    true,
    null,
  ],
  ['23F8-FE0F', 'double_vertical_bar', ['double_vertical_bar'], 'Symbols', 1451, 0.7, true, null],
  [
    '23F9-FE0F',
    'black_square_for_stop',
    ['black_square_for_stop'],
    'Symbols',
    1452,
    0.7,
    true,
    null,
  ],
  [
    '23FA-FE0F',
    'black_circle_for_record',
    ['black_circle_for_record'],
    'Symbols',
    1453,
    0.7,
    true,
    null,
  ],
  ['24C2-FE0F', 'm', ['m'], 'Symbols', 1526, 0.6, true, null],
  ['25AA-FE0F', 'black_small_square', ['black_small_square'], 'Symbols', 1574, 0.6, true, null],
  ['25AB-FE0F', 'white_small_square', ['white_small_square'], 'Symbols', 1575, 0.6, true, null],
  ['25B6-FE0F', 'arrow_forward', ['arrow_forward'], 'Symbols', 1440, 0.6, true, null],
  ['25C0-FE0F', 'arrow_backward', ['arrow_backward'], 'Symbols', 1444, 0.6, true, null],
  ['25FB-FE0F', 'white_medium_square', ['white_medium_square'], 'Symbols', 1571, 0.6, true, null],
  ['25FC-FE0F', 'black_medium_square', ['black_medium_square'], 'Symbols', 1570, 0.6, true, null],
  [
    '25FD',
    'white_medium_small_square',
    ['white_medium_small_square'],
    'Symbols',
    1573,
    0.6,
    true,
    null,
  ],
  [
    '25FE',
    'black_medium_small_square',
    ['black_medium_small_square'],
    'Symbols',
    1572,
    0.6,
    true,
    null,
  ],
  ['2600-FE0F', 'sunny', ['sunny'], 'Travel & Places', 990, 0.6, true, null],
  ['2601-FE0F', 'cloud', ['cloud'], 'Travel & Places', 998, 0.6, true, null],
  ['2602-FE0F', 'umbrella', ['umbrella'], 'Travel & Places', 1013, 0.7, true, null],
  ['2603-FE0F', 'snowman', ['snowman'], 'Travel & Places', 1018, 0.7, true, null],
  ['2604-FE0F', 'comet', ['comet'], 'Travel & Places', 1020, 1, true, null],
  ['260E-FE0F', 'phone', ['phone', 'telephone'], 'Objects', 1184, 0.6, true, null],
  [
    '2611-FE0F',
    'ballot_box_with_check',
    ['ballot_box_with_check'],
    'Symbols',
    1487,
    0.6,
    true,
    null,
  ],
  [
    '2614',
    'umbrella_with_rain_drops',
    ['umbrella_with_rain_drops'],
    'Travel & Places',
    1014,
    0.6,
    true,
    null,
  ],
  ['2615', 'coffee', ['coffee'], 'Food & Drink', 781, 0.6, true, null],
  ['2618-FE0F', 'shamrock', ['shamrock'], 'Animals & Nature', 667, 1, true, null],
  [
    '261D-FE0F',
    'point_up',
    ['point_up'],
    'People & Body',
    187,
    0.6,
    true,
    {
      '1F3FB': { unified: '261D-1F3FB', symbol: '☝🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '261D-1F3FC', symbol: '☝🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '261D-1F3FD', symbol: '☝🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '261D-1F3FE', symbol: '☝🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '261D-1F3FF', symbol: '☝🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '2620-FE0F',
    'skull_and_crossbones',
    ['skull_and_crossbones'],
    'Smileys & Emotion',
    106,
    1,
    true,
    null,
  ],
  ['2622-FE0F', 'radioactive_sign', ['radioactive_sign'], 'Symbols', 1389, 1, true, null],
  ['2623-FE0F', 'biohazard_sign', ['biohazard_sign'], 'Symbols', 1390, 1, true, null],
  ['2626-FE0F', 'orthodox_cross', ['orthodox_cross'], 'Symbols', 1419, 1, true, null],
  ['262A-FE0F', 'star_and_crescent', ['star_and_crescent'], 'Symbols', 1420, 0.7, true, null],
  ['262E-FE0F', 'peace_symbol', ['peace_symbol'], 'Symbols', 1421, 1, true, null],
  ['262F-FE0F', 'yin_yang', ['yin_yang'], 'Symbols', 1417, 0.7, true, null],
  ['2638-FE0F', 'wheel_of_dharma', ['wheel_of_dharma'], 'Symbols', 1416, 0.7, true, null],
  [
    '2639-FE0F',
    'white_frowning_face',
    ['white_frowning_face'],
    'Smileys & Emotion',
    77,
    0.7,
    true,
    null,
  ],
  ['263A-FE0F', 'relaxed', ['relaxed'], 'Smileys & Emotion', 20, 0.6, true, null],
  ['2640-FE0F', 'female_sign', ['female_sign'], 'Symbols', 1461, 4, true, null],
  ['2642-FE0F', 'male_sign', ['male_sign'], 'Symbols', 1462, 4, true, null],
  ['2648', 'aries', ['aries'], 'Symbols', 1424, 0.6, true, null],
  ['2649', 'taurus', ['taurus'], 'Symbols', 1425, 0.6, true, null],
  ['264A', 'gemini', ['gemini'], 'Symbols', 1426, 0.6, true, null],
  ['264B', 'cancer', ['cancer'], 'Symbols', 1427, 0.6, true, null],
  ['264C', 'leo', ['leo'], 'Symbols', 1428, 0.6, true, null],
  ['264D', 'virgo', ['virgo'], 'Symbols', 1429, 0.6, true, null],
  ['264E', 'libra', ['libra'], 'Symbols', 1430, 0.6, true, null],
  ['264F', 'scorpius', ['scorpius'], 'Symbols', 1431, 0.6, true, null],
  ['2650', 'sagittarius', ['sagittarius'], 'Symbols', 1432, 0.6, true, null],
  ['2651', 'capricorn', ['capricorn'], 'Symbols', 1433, 0.6, true, null],
  ['2652', 'aquarius', ['aquarius'], 'Symbols', 1434, 0.6, true, null],
  ['2653', 'pisces', ['pisces'], 'Symbols', 1435, 0.6, true, null],
  ['265F-FE0F', 'chess_pawn', ['chess_pawn'], 'Activities', 1099, 11, true, null],
  ['2660-FE0F', 'spades', ['spades'], 'Activities', 1095, 0.6, true, null],
  ['2663-FE0F', 'clubs', ['clubs'], 'Activities', 1098, 0.6, true, null],
  ['2665-FE0F', 'hearts', ['hearts'], 'Activities', 1096, 0.6, true, null],
  ['2666-FE0F', 'diamonds', ['diamonds'], 'Activities', 1097, 0.6, true, null],
  ['2668-FE0F', 'hotsprings', ['hotsprings'], 'Travel & Places', 865, 0.6, true, null],
  ['267B-FE0F', 'recycle', ['recycle'], 'Symbols', 1480, 0.6, true, null],
  ['267E-FE0F', 'infinity', ['infinity'], 'Symbols', 1469, 11, true, null],
  ['267F', 'wheelchair', ['wheelchair'], 'Symbols', 1368, 0.6, true, null],
  ['2692-FE0F', 'hammer_and_pick', ['hammer_and_pick'], 'Objects', 1297, 1, true, null],
  ['2693', 'anchor', ['anchor'], 'Travel & Places', 922, 0.6, true, null],
  ['2694-FE0F', 'crossed_swords', ['crossed_swords'], 'Objects', 1300, 1, true, null],
  [
    '2695-FE0F',
    'medical_symbol',
    ['medical_symbol', 'staff_of_aesculapius'],
    'Symbols',
    1479,
    4,
    true,
    null,
  ],
  ['2696-FE0F', 'scales', ['scales'], 'Objects', 1311, 1, true, null],
  ['2697-FE0F', 'alembic', ['alembic'], 'Objects', 1319, 1, true, null],
  ['2699-FE0F', 'gear', ['gear'], 'Objects', 1309, 1, true, null],
  ['269B-FE0F', 'atom_symbol', ['atom_symbol'], 'Symbols', 1413, 1, true, null],
  ['269C-FE0F', 'fleur_de_lis', ['fleur_de_lis'], 'Symbols', 1481, 1, true, null],
  ['26A0-FE0F', 'warning', ['warning'], 'Symbols', 1378, 0.6, true, null],
  ['26A1', 'zap', ['zap'], 'Travel & Places', 1016, 0.6, true, null],
  ['26A7-FE0F', 'transgender_symbol', ['transgender_symbol'], 'Symbols', 1463, 13, true, null],
  ['26AA', 'white_circle', ['white_circle'], 'Symbols', 1560, 0.6, true, null],
  ['26AB', 'black_circle', ['black_circle'], 'Symbols', 1559, 0.6, true, null],
  ['26B0-FE0F', 'coffin', ['coffin'], 'Objects', 1359, 1, true, null],
  ['26B1-FE0F', 'funeral_urn', ['funeral_urn'], 'Objects', 1361, 1, true, null],
  ['26BD', 'soccer', ['soccer'], 'Activities', 1051, 0.6, true, null],
  ['26BE', 'baseball', ['baseball'], 'Activities', 1052, 0.6, true, null],
  [
    '26C4',
    'snowman_without_snow',
    ['snowman_without_snow'],
    'Travel & Places',
    1019,
    0.6,
    true,
    null,
  ],
  ['26C5', 'partly_sunny', ['partly_sunny'], 'Travel & Places', 999, 0.6, true, null],
  [
    '26C8-FE0F',
    'thunder_cloud_and_rain',
    ['thunder_cloud_and_rain'],
    'Travel & Places',
    1000,
    0.7,
    true,
    null,
  ],
  ['26CE', 'ophiuchus', ['ophiuchus'], 'Symbols', 1436, 0.6, true, null],
  ['26CF-FE0F', 'pick', ['pick'], 'Objects', 1296, 0.7, true, null],
  [
    '26D1-FE0F',
    'helmet_with_white_cross',
    ['helmet_with_white_cross'],
    'Objects',
    1150,
    0.7,
    true,
    null,
  ],
  ['26D3-FE0F', 'chains', ['chains'], 'Objects', 1314, 0.7, true, null],
  ['26D4', 'no_entry', ['no_entry'], 'Symbols', 1380, 0.6, true, null],
  ['26E9-FE0F', 'shinto_shrine', ['shinto_shrine'], 'Travel & Places', 853, 0.7, true, null],
  ['26EA', 'church', ['church'], 'Travel & Places', 849, 0.6, true, null],
  ['26F0-FE0F', 'mountain', ['mountain'], 'Travel & Places', 814, 0.7, true, null],
  [
    '26F1-FE0F',
    'umbrella_on_ground',
    ['umbrella_on_ground'],
    'Travel & Places',
    1015,
    0.7,
    true,
    null,
  ],
  ['26F2', 'fountain', ['fountain'], 'Travel & Places', 855, 0.6, true, null],
  ['26F3', 'golf', ['golf'], 'Activities', 1070, 0.6, true, null],
  ['26F4-FE0F', 'ferry', ['ferry'], 'Travel & Places', 928, 0.7, true, null],
  ['26F5', 'boat', ['boat', 'sailboat'], 'Travel & Places', 924, 0.6, true, null],
  ['26F7-FE0F', 'skier', ['skier'], 'People & Body', 436, 0.7, true, null],
  ['26F8-FE0F', 'ice_skate', ['ice_skate'], 'Activities', 1071, 0.7, true, null],
  [
    '26F9-FE0F-200D-2640-FE0F',
    'woman-bouncing-ball',
    ['woman-bouncing-ball'],
    'People & Body',
    452,
    4,
    true,
    {
      '1F3FB': {
        unified: '26F9-1F3FB-200D-2640-FE0F',
        symbol: '⛹🏻‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '26F9-1F3FC-200D-2640-FE0F',
        symbol: '⛹🏼‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '26F9-1F3FD-200D-2640-FE0F',
        symbol: '⛹🏽‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '26F9-1F3FE-200D-2640-FE0F',
        symbol: '⛹🏾‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '26F9-1F3FF-200D-2640-FE0F',
        symbol: '⛹🏿‍♀️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '26F9-FE0F-200D-2642-FE0F',
    'man-bouncing-ball',
    ['man-bouncing-ball'],
    'People & Body',
    451,
    4,
    true,
    {
      '1F3FB': {
        unified: '26F9-1F3FB-200D-2642-FE0F',
        symbol: '⛹🏻‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FC': {
        unified: '26F9-1F3FC-200D-2642-FE0F',
        symbol: '⛹🏼‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FD': {
        unified: '26F9-1F3FD-200D-2642-FE0F',
        symbol: '⛹🏽‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FE': {
        unified: '26F9-1F3FE-200D-2642-FE0F',
        symbol: '⛹🏾‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
      '1F3FF': {
        unified: '26F9-1F3FF-200D-2642-FE0F',
        symbol: '⛹🏿‍♂️',
        addedIn: 4,
        hasImgTwitter: true,
      },
    },
  ],
  [
    '26F9-FE0F',
    'person_with_ball',
    ['person_with_ball'],
    'People & Body',
    450,
    0.7,
    true,
    {
      '1F3FB': { unified: '26F9-1F3FB', symbol: '⛹🏻', addedIn: 2, hasImgTwitter: true },
      '1F3FC': { unified: '26F9-1F3FC', symbol: '⛹🏼', addedIn: 2, hasImgTwitter: true },
      '1F3FD': { unified: '26F9-1F3FD', symbol: '⛹🏽', addedIn: 2, hasImgTwitter: true },
      '1F3FE': { unified: '26F9-1F3FE', symbol: '⛹🏾', addedIn: 2, hasImgTwitter: true },
      '1F3FF': { unified: '26F9-1F3FF', symbol: '⛹🏿', addedIn: 2, hasImgTwitter: true },
    },
  ],
  ['26FA', 'tent', ['tent'], 'Travel & Places', 856, 0.6, true, null],
  ['26FD', 'fuelpump', ['fuelpump'], 'Travel & Places', 915, 0.6, true, null],
  ['2702-FE0F', 'scissors', ['scissors'], 'Objects', 1284, 0.6, true, null],
  ['2705', 'white_check_mark', ['white_check_mark'], 'Symbols', 1486, 0.6, true, null],
  ['2708-FE0F', 'airplane', ['airplane'], 'Travel & Places', 931, 0.6, true, null],
  ['2709-FE0F', 'email', ['email', 'envelope'], 'Objects', 1245, 0.6, true, null],
  [
    '270A',
    'fist',
    ['fist'],
    'People & Body',
    191,
    0.6,
    true,
    {
      '1F3FB': { unified: '270A-1F3FB', symbol: '✊🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '270A-1F3FC', symbol: '✊🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '270A-1F3FD', symbol: '✊🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '270A-1F3FE', symbol: '✊🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '270A-1F3FF', symbol: '✊🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '270B',
    'hand',
    ['hand', 'raised_hand'],
    'People & Body',
    167,
    0.6,
    true,
    {
      '1F3FB': { unified: '270B-1F3FB', symbol: '✋🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '270B-1F3FC', symbol: '✋🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '270B-1F3FD', symbol: '✋🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '270B-1F3FE', symbol: '✋🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '270B-1F3FF', symbol: '✋🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '270C-FE0F',
    'v',
    ['v'],
    'People & Body',
    176,
    0.6,
    true,
    {
      '1F3FB': { unified: '270C-1F3FB', symbol: '✌🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '270C-1F3FC', symbol: '✌🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '270C-1F3FD', symbol: '✌🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '270C-1F3FE', symbol: '✌🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '270C-1F3FF', symbol: '✌🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  [
    '270D-FE0F',
    'writing_hand',
    ['writing_hand'],
    'People & Body',
    202,
    0.7,
    true,
    {
      '1F3FB': { unified: '270D-1F3FB', symbol: '✍🏻', addedIn: 1, hasImgTwitter: true },
      '1F3FC': { unified: '270D-1F3FC', symbol: '✍🏼', addedIn: 1, hasImgTwitter: true },
      '1F3FD': { unified: '270D-1F3FD', symbol: '✍🏽', addedIn: 1, hasImgTwitter: true },
      '1F3FE': { unified: '270D-1F3FE', symbol: '✍🏾', addedIn: 1, hasImgTwitter: true },
      '1F3FF': { unified: '270D-1F3FF', symbol: '✍🏿', addedIn: 1, hasImgTwitter: true },
    },
  ],
  ['270F-FE0F', 'pencil2', ['pencil2'], 'Objects', 1258, 0.6, true, null],
  ['2712-FE0F', 'black_nib', ['black_nib'], 'Objects', 1259, 0.6, true, null],
  ['2714-FE0F', 'heavy_check_mark', ['heavy_check_mark'], 'Symbols', 1488, 0.6, true, null],
  [
    '2716-FE0F',
    'heavy_multiplication_x',
    ['heavy_multiplication_x'],
    'Symbols',
    1464,
    0.6,
    true,
    null,
  ],
  ['271D-FE0F', 'latin_cross', ['latin_cross'], 'Symbols', 1418, 0.7, true, null],
  ['2721-FE0F', 'star_of_david', ['star_of_david'], 'Symbols', 1415, 0.7, true, null],
  ['2728', 'sparkles', ['sparkles'], 'Activities', 1029, 0.6, true, null],
  [
    '2733-FE0F',
    'eight_spoked_asterisk',
    ['eight_spoked_asterisk'],
    'Symbols',
    1494,
    0.6,
    true,
    null,
  ],
  [
    '2734-FE0F',
    'eight_pointed_black_star',
    ['eight_pointed_black_star'],
    'Symbols',
    1495,
    0.6,
    true,
    null,
  ],
  ['2744-FE0F', 'snowflake', ['snowflake'], 'Travel & Places', 1017, 0.6, true, null],
  ['2747-FE0F', 'sparkle', ['sparkle'], 'Symbols', 1496, 0.6, true, null],
  ['274C', 'x', ['x'], 'Symbols', 1489, 0.6, true, null],
  [
    '274E',
    'negative_squared_cross_mark',
    ['negative_squared_cross_mark'],
    'Symbols',
    1490,
    0.6,
    true,
    null,
  ],
  ['2753', 'question', ['question'], 'Symbols', 1472, 0.6, true, null],
  ['2754', 'grey_question', ['grey_question'], 'Symbols', 1473, 0.6, true, null],
  ['2755', 'grey_exclamation', ['grey_exclamation'], 'Symbols', 1474, 0.6, true, null],
  [
    '2757',
    'exclamation',
    ['exclamation', 'heavy_exclamation_mark'],
    'Symbols',
    1475,
    0.6,
    true,
    null,
  ],
  [
    '2763-FE0F',
    'heavy_heart_exclamation_mark_ornament',
    ['heavy_heart_exclamation_mark_ornament'],
    'Smileys & Emotion',
    137,
    1,
    true,
    null,
  ],
  [
    '2764-FE0F-200D-1F525',
    'heart_on_fire',
    ['heart_on_fire'],
    'Smileys & Emotion',
    139,
    13.1,
    true,
    null,
  ],
  [
    '2764-FE0F-200D-1FA79',
    'mending_heart',
    ['mending_heart'],
    'Smileys & Emotion',
    140,
    13.1,
    true,
    null,
  ],
  ['2764-FE0F', 'heart', ['heart'], 'Smileys & Emotion', 141, 0.6, true, null],
  ['2795', 'heavy_plus_sign', ['heavy_plus_sign'], 'Symbols', 1465, 0.6, true, null],
  ['2796', 'heavy_minus_sign', ['heavy_minus_sign'], 'Symbols', 1466, 0.6, true, null],
  ['2797', 'heavy_division_sign', ['heavy_division_sign'], 'Symbols', 1467, 0.6, true, null],
  ['27A1-FE0F', 'arrow_right', ['arrow_right'], 'Symbols', 1393, 0.6, true, null],
  ['27B0', 'curly_loop', ['curly_loop'], 'Symbols', 1491, 0.6, true, null],
  ['27BF', 'loop', ['loop'], 'Symbols', 1492, 1, true, null],
  ['2934-FE0F', 'arrow_heading_up', ['arrow_heading_up'], 'Symbols', 1403, 0.6, true, null],
  ['2935-FE0F', 'arrow_heading_down', ['arrow_heading_down'], 'Symbols', 1404, 0.6, true, null],
  ['2B05-FE0F', 'arrow_left', ['arrow_left'], 'Symbols', 1397, 0.6, true, null],
  ['2B06-FE0F', 'arrow_up', ['arrow_up'], 'Symbols', 1391, 0.6, true, null],
  ['2B07-FE0F', 'arrow_down', ['arrow_down'], 'Symbols', 1395, 0.6, true, null],
  ['2B1B', 'black_large_square', ['black_large_square'], 'Symbols', 1568, 0.6, true, null],
  ['2B1C', 'white_large_square', ['white_large_square'], 'Symbols', 1569, 0.6, true, null],
  ['2B50', 'star', ['star'], 'Travel & Places', 994, 0.6, true, null],
  ['2B55', 'o', ['o'], 'Symbols', 1485, 0.6, true, null],
  ['3030-FE0F', 'wavy_dash', ['wavy_dash'], 'Symbols', 1476, 0.6, true, null],
  [
    '303D-FE0F',
    'part_alternation_mark',
    ['part_alternation_mark'],
    'Symbols',
    1493,
    0.6,
    true,
    null,
  ],
  ['3297-FE0F', 'congratulations', ['congratulations'], 'Symbols', 1548, 0.6, true, null],
  ['3299-FE0F', 'secret', ['secret'], 'Symbols', 1549, 0.6, true, null],
];
